import { E as It, _ as gn, a as _n, f as vn, x as le, y as yn } from "./layout-BD1t4ofR.js";
import { i as oe } from "./common-Cd7R8f1s.js";
import { n as y } from "./Logger-CmiOOsKC.js";
import { a as he, d as bn, f as On, i as An, n as G, o as $, t as K } from "./tracebehavior-5_qSKjs6.js";
import { r as Sn } from "./TransformUtils-Bd2LIBHs.js";
import { t as Ze } from "./TransitionManager-BD_yHXIb.js";
import { n as j, r as et, t as wn } from "./bindingValues-BuN2Qy2j.js";
import "./boxcollider-DfK5pGI3.js";
import { r as tt, t as Tn, u as X } from "./properties-C_pgb9zu.js";
import { n as En, r as Be, t as je } from "./names-CFkjAQeT.js";
import { d as nt, n as Mn, o as Cn, p as In, s as Rn } from "./AssetTypes-DUDo9FdH.js";
import { t as ue } from "./Utility-CviQuQTA.js";
import { r as xn } from "./assetRef-BeDJZkjy.js";
import { AnimationGroup as Rt } from "@babylonjs/core/Animations/animationGroup.js";
import { Matrix as kn, Quaternion as R, Vector3 as B } from "@babylonjs/core/Maths/math.vector.js";
import { Animation as H } from "@babylonjs/core/Animations/animation.js";
import { Observable as Ee } from "@babylonjs/core/Misc/observable.js";
import { Color3 as me, Color4 as ot } from "@babylonjs/core/Maths/math.color.js";
import { Material as re } from "@babylonjs/core/Materials/material.js";
import { AbstractMesh as W } from "@babylonjs/core/Meshes/abstractMesh.js";
import { TransformNode as se } from "@babylonjs/core/Meshes/transformNode.js";
import { PBRMaterial as de } from "@babylonjs/core/Materials/PBR/pbrMaterial.js";
import { GLTFLoader as Pn } from "@babylonjs/loaders/glTF/2.0/glTFLoader.js";
import { registerGLTFExtension as xt, unregisterGLTFExtension as kt } from "@babylonjs/loaders/glTF/2.0/glTFLoaderExtensionRegistry.js";
import { RawTexture as Me } from "@babylonjs/core/Materials/Textures/rawTexture.js";
import { Texture as Q } from "@babylonjs/core/Materials/Textures/texture.js";
import { AnimationKeyInterpolation as Fn } from "@babylonjs/core/Animations/animationKey.js";
import { SubMesh as Nn } from "@babylonjs/core/Meshes/subMesh.js";
import { InstancedMesh as Vn } from "@babylonjs/core/Meshes/instancedMesh.js";
import { InspectableType as rt } from "@babylonjs/core/Misc/iInspectable.js";
var st = class extends K {
  static behaviorType = "Animation";
  loadedGroups = /* @__PURE__ */ new Map();
  _activeGroup = null;
  _abortController = null;
  _completedAt = null;
  _sampling = !1;
  _sampledTime = 0;
  _externalGroup = null;
  _externalAbort = null;
  _externalPlaybackId = 0;
  constructor(t, e) {
    super(t, e), this.validate(this.getAuthored()), this._resolved = this._resolveAll();
  }
  validate(t) {
    const e = [];
    if (t.speed !== void 0 && (typeof t.speed != "number" || t.speed <= 0) && e.push({
      field: "speed",
      message: "Speed must be a positive number",
      code: "INVALID_SPEED"
    }), t.wrapMode !== void 0) {
      const n = Object.values(oe);
      n.includes(t.wrapMode) || e.push({
        field: "wrapMode",
        message: `Wrap mode must be one of: ${n.join(", ")}`,
        code: "INVALID_WRAP_MODE"
      });
    }
    return e;
  }
  async applyCommit(t, e) {
    this._activeGroup && "speed" in t && (this._activeGroup.speedRatio = this._resolved.speed ?? 1), ("src" in t || t.clip !== void 0 && t.clip !== e.clip) && (this._cancelExternalPlayback(), this._removeAllExternalClips(), this._resolved.src && await this._loadAndStoreExternalClip(this._resolved.src));
  }
  async load() {
    this._resolved.src && await this._loadAndStoreExternalClip(this._resolved.src);
  }
  async _loadAndStoreExternalClip(t) {
    const e = await this._loadAllExternalClips(t);
    for (const n of e) {
      const o = n.name.replace(/^External_/, "") || "Clip";
      this.loadedGroups.set(o, n);
    }
    e.length > 0 && y.debug(`[Animation] Loaded ${e.length} clip(s) from ${t}`);
  }
  onAttach() {
    this._registerEmbeddedClips();
  }
  onDetach() {
    this.stop(), this._disposeLoadedGroups(), this._disposeExternalGroup();
  }
  onPlayModeChanged(t) {
    t ? this._resolved.playAutomatically !== !1 && this.play().catch((e) => {
      y.warn(`[Animation] Auto-play failed for ${this.sceneObject.name}:`, e);
    }) : this.stop();
  }
  _disposeLoadedGroups() {
    this._sampling = !1, this._clearPlayback();
    for (const t of this.loadedGroups.values()) try {
      t.dispose();
    } catch {
    }
    this.loadedGroups.clear();
  }
  async play(t) {
    const e = t?.clip ?? this._resolved.clip, n = this._sampling;
    if (this._sampling = !1, this._activeGroup?.isStarted && !this._activeGroup.isPlaying && this._abortController && !this._abortController.signal.aborted) {
      const c = this._findAnimationGroup(e);
      if (!c || this._activeGroup === c) {
        t?.speed !== void 0 && (this._activeGroup.speedRatio = t.speed), this._completedAt = null;
        const l = this._activeGroup;
        l.onAnimationGroupEndObservable.addOnce(() => {
          const u = l.targetedAnimations[0]?.animation.framePerSecond || 30;
          this._completedAt = (l.to - l.from) / u;
        }), l.play();
        return;
      }
    }
    const o = t?.speed ?? this._resolved.speed ?? 1;
    let r;
    t?.loop !== void 0 ? r = t.loop : r = ((e ? this._resolved.clips?.find((c) => c.name === e) : void 0)?.wrap ?? this._resolved.wrapMode) === oe.Loop;
    const s = this._findAnimationGroup(e);
    if (!s) {
      y.warn(`[Animation] No animation group found for ${this.sceneObject.name}${e ? ` (clip: ${e})` : ""}`);
      return;
    }
    const a = s === this._activeGroup && s.isStarted && !s.isPlaying && !n ? s.getCurrentFrame() : void 0, i = a !== void 0 && (r || a < s.to) ? a : void 0;
    this._clearPlayback(), this._abortController = new AbortController(), this._activeGroup = s, await this._playAnimationGroup(s, r, o, this._abortController.signal, i);
  }
  pause() {
    this._activeGroup?.isPlaying && this._activeGroup.pause();
  }
  stop() {
    this._sampling = !1, this._rewind(), this._cancelExternalPlayback();
  }
  clearPlayback() {
    this._sampling = !1, this._clearPlayback(), this._cancelExternalPlayback();
  }
  seek(t) {
    if (this._sampling = !1, !this._activeGroup) {
      const o = this._findAnimationGroup(this._resolved.clip);
      if (!o) return;
      o.start(!1, this._resolved.speed ?? 1), o.pause(), this._activeGroup = o;
    }
    const e = this._activeGroup;
    e.isStarted || (e.start(!1, this._resolved.speed ?? 1), e.pause()), this._completedAt = null;
    const n = t * (e.targetedAnimations[0]?.animation?.framePerSecond ?? 30);
    e.goToFrame(Math.max(e.from, Math.min(n, e.to)));
  }
  sampleAt(t) {
    const e = this._findAnimationGroup(this._resolved.clip) ?? this._activeGroup;
    if (!e) return;
    this._sampledTime = t, this._sampling || (this._activeGroup && this._activeGroup !== e ? this._clearPlayback() : this._abortController && (this._abortController.abort(), this._abortController = null), this._sampling = !0), this._activeGroup = e, e.isStarted || e.start(!1, this._resolved.speed ?? 1, 0, e.to), e.isPlaying && e.pause(), this._completedAt = null;
    const n = e.targetedAnimations[0]?.animation?.framePerSecond ?? 30, o = e.to;
    let r = Math.max(0, t) * (this._resolved.speed ?? 1) * n;
    this._effectiveLoop(this._getClipName(e)) && o > 0 && r > o && (r %= o), e.goToFrame(Math.min(r, o));
  }
  isSampling() {
    return this._sampling;
  }
  _effectiveLoop(t) {
    return ((t ? this._resolved.clips?.find((e) => e.name === t) : void 0)?.wrap ?? this._resolved.wrapMode) === oe.Loop;
  }
  isPlaying() {
    return this._activeGroup?.isPlaying === !0 || this.isExternalPlaying();
  }
  setSpeed(t) {
    this._activeGroup && (this._activeGroup.speedRatio = t);
  }
  getPlaybackState() {
    const t = this._activeGroup ?? (this._externalGroup?.isStarted ? this._externalGroup : null);
    if (!t) return null;
    const e = t.targetedAnimations[0]?.animation.framePerSecond || 30, n = (t.to - t.from) / e;
    return {
      time: this._completedAt ?? t.getCurrentFrame() / e,
      duration: n,
      clipName: this._getClipName(t),
      playing: t.isPlaying
    };
  }
  getPlaybackTime() {
    return this.getPlaybackState();
  }
  getClipNames() {
    return [...this.loadedGroups.keys()];
  }
  getEmbeddedClipNames() {
    return [...this.sceneObject.animationClips.keys()];
  }
  getExternalClipNames() {
    const t = this.sceneObject.animationClips;
    return [...this.loadedGroups.keys()].filter((e) => !t.has(e));
  }
  getLoadedGroup(t) {
    return this.loadedGroups.get(t) ?? null;
  }
  removeExternalClip(t) {
    if (this.sceneObject.animationClips.has(t)) return;
    const e = this.loadedGroups.get(t);
    e && (this._activeGroup === e && this._clearPlayback(), this._externalGroup === e && this._cancelExternalPlayback(), e.dispose(), this.loadedGroups.delete(t));
  }
  _removeAllExternalClips() {
    for (const t of this.getExternalClipNames()) {
      const e = this.loadedGroups.get(t);
      e && (this._activeGroup === e && this._clearPlayback(), e.dispose(), this.loadedGroups.delete(t));
    }
  }
  _rewind() {
    this._stopActiveGroup(!1);
  }
  _clearPlayback() {
    this._stopActiveGroup(!0);
  }
  _stopActiveGroup(t) {
    this._abortController && (this._abortController.abort(), this._abortController = null), this._activeGroup && (this._activeGroup.isStarted || this._activeGroup.start(!1, 1), this._activeGroup.goToFrame(this._activeGroup.from), this._activeGroup.isPlaying && this._activeGroup.pause(), t && (this._activeGroup = null)), this._completedAt = null, this._resetSkeleton();
  }
  _resetSkeleton() {
    const t = this.sceneObject.transform.getChildMeshes(!1).find((e) => e.skeleton)?.skeleton;
    t && t.returnToRest();
  }
  _onBoundClipsReplaced(t) {
    const e = new Set(this.sceneObject.animationClips.values()), n = new Set([...t.values()].filter((r) => !e.has(r))), o = this._sampling && !!this._activeGroup && n.has(this._activeGroup);
    this._activeGroup && n.has(this._activeGroup) && (this._sampling = !1, this._clearPlayback());
    for (const [r, s] of [...this.loadedGroups]) n.has(s) && this.loadedGroups.delete(r);
    this._registerEmbeddedClips(), o && this.sampleAt(this._sampledTime);
  }
  _registerEmbeddedClips() {
    for (const [t, e] of this.sceneObject.animationClips) this.loadedGroups.set(t, e);
    y.debug(`[Animation] Found ${this.loadedGroups.size} embedded clips for ${this.sceneObject.name}`);
  }
  _getClipName(t) {
    for (const [e, n] of this.loadedGroups) if (n === t) return e;
    return t.name.replace(/^External_/, "");
  }
  _findAnimationGroup(t) {
    return this.loadedGroups.size ? t ? this.loadedGroups.get(t) ?? null : this.loadedGroups.values().next().value ?? null : null;
  }
  async _playAnimationGroup(t, e, n, o, r) {
    return new Promise((s) => {
      if (o.aborted) {
        s();
        return;
      }
      t.goToFrame(r ?? t.from), t.setWeightForAllAnimatables(1), t.speedRatio = Math.max(n, 0.01);
      let a = !1, i = null, c = null;
      const l = () => {
        i && o.removeEventListener("abort", i), c && clearTimeout(c);
      }, u = () => {
        a || (a = !0, l(), s());
      };
      if (!e) {
        const d = t.onAnimationGroupEndObservable.addOnce(() => {
          const g = t.targetedAnimations[0]?.animation.framePerSecond || 30;
          this._completedAt = (t.to - t.from) / g, u();
        });
        c = setTimeout(() => {
          !a && t.isPlaying && (t.stop(), t.onAnimationGroupEndObservable.remove(d), u());
        }, 3e4 / Math.max(n, 0.01));
      }
      i = () => {
        a || (t.isPlaying && t.stop(), u());
      }, o.addEventListener("abort", i), t.play(e);
    });
  }
  async playExternal(t, e) {
    const n = e?.speed ?? 1, o = e?.loop ?? !1;
    this._cancelExternalPlayback();
    const r = ++this._externalPlaybackId;
    this._externalAbort = new AbortController();
    const s = this._externalAbort.signal, a = await this._loadExternalClip(t, e?.clip);
    if (!a || this._externalPlaybackId !== r || s.aborted) {
      a?.dispose();
      return;
    }
    this._disposeExternalGroup(), this._externalGroup = a, e?.onStarted?.();
    try {
      await this._playAnimationGroup(a, o, n, s);
    } finally {
      this._externalPlaybackId === r && !s.aborted && !o && this._resetExternalTarget();
    }
  }
  isExternalPlaying() {
    return this._externalGroup?.isPlaying === !0;
  }
  _cancelExternalPlayback() {
    this._externalAbort && (this._externalAbort.abort(), this._externalAbort = null), this._externalGroup?.isPlaying && this._externalGroup.stop(), this._disposeExternalGroup(), this._resetExternalTarget();
  }
  _resetExternalTarget() {
    if (this._resolved.target === "@self") return;
    const t = this.sceneObject.animationRoot;
    t && Sn(t, "[Animation]");
  }
  _disposeExternalGroup() {
    if (this._externalGroup) {
      try {
        this._externalGroup.dispose();
      } catch {
      }
      this._externalGroup = null;
    }
  }
  async _loadAllExternalClips(t) {
    let e = !1;
    try {
      const n = await this.resources.getOrLoadContainer(t, this.scene);
      if (e = !0, !n.animationGroups.length)
        return y.warn(`[Animation] No animation groups in external source ${t}`), [];
      const o = this._resolved.target === "@self" ? this.sceneObject.transform : this.sceneObject.getOrCreateAnimationRoot(), r = [];
      for (const s of n.animationGroups) {
        const a = new Rt(`External_${s.name.replace(/^External_/, "")}`, this.scene);
        for (const i of s.targetedAnimations) a.addTargetedAnimation(i.animation.clone(), o);
        r.push(a);
      }
      return r;
    } catch (n) {
      return y.error(`[Animation] Failed to load external clips from ${t}: ${String(n)}`), [];
    } finally {
      e && this.resources.releaseContainer(t);
    }
  }
  async _loadExternalClip(t, e) {
    const n = await this._loadAllExternalClips(t);
    if (n.length === 0) return null;
    let o;
    if (e) {
      if (o = n.find((r) => r.name.replace(/^External_/, "") === e), !o) {
        y.warn(`[Animation] Clip "${e}" not found in ${t}. Available: ${n.map((r) => r.name.replace(/^External_/, "")).join(", ")}`);
        for (const r of n) r.dispose();
        return null;
      }
    } else o = n[0];
    for (const r of n) r !== o && r.dispose();
    return o;
  }
};
function at(t, e) {
  const n = [];
  if (t instanceof W && n.push(t), !e || e.size === 0)
    return n.push(...t.getChildMeshes(!1)), n;
  const o = (r) => {
    for (const s of r.getChildren())
      e.has(s) || (s instanceof W && n.push(s), o(s));
  };
  return o(t), n;
}
var b = {
  EVENT_ON_START: "event/onStart",
  EVENT_ON_TICK: "event/onTick",
  EVENT_SEND: "event/send",
  EVENT_RECEIVE: "event/receive",
  FLOW_BRANCH: "flow/branch",
  FLOW_SEQUENCE: "flow/sequence",
  FLOW_SET_DELAY: "flow/setDelay",
  FLOW_CANCEL_DELAY: "flow/cancelDelay",
  MATH_ADD: "math/add",
  MATH_SUB: "math/sub",
  MATH_MUL: "math/mul",
  MATH_DIV: "math/div",
  MATH_MIN: "math/min",
  MATH_MAX: "math/max",
  MATH_POW: "math/pow",
  MATH_FLOOR: "math/floor",
  MATH_RANDOM: "math/random",
  MATH_EQ: "math/eq",
  MATH_GT: "math/gt",
  MATH_GE: "math/ge",
  MATH_LT: "math/lt",
  MATH_LE: "math/le",
  MATH_NOT: "math/not",
  MATH_AND: "math/and",
  MATH_OR: "math/or",
  MATH_SELECT: "math/select",
  MATH_COMBINE3: "math/combine3",
  POINTER_GET: "pointer/get",
  POINTER_SET: "pointer/set",
  POINTER_INTERPOLATE: "pointer/interpolate",
  VARIABLE_GET: "variable/get",
  VARIABLE_SET: "variable/set",
  EVENT_ON_SELECT: "event/onSelect",
  EVENT_ON_HOVER_IN: "event/onHoverIn",
  EVENT_ON_HOVER_OUT: "event/onHoverOut",
  TRACE_ON_PROXIMITY: "trace/onProximity",
  TRACE_SET_ACTIVE: "trace/setActive",
  TRACE_GET_ACTIVE: "trace/getActive",
  TRACE_GET_CHILD_COUNT: "trace/getChildCount",
  TRACE_SET_ACTIVE_CHILD: "trace/setActiveChild",
  TRACE_PLAY_ANIMATION: "trace/playAnimation",
  TRACE_PLAY_ANIMATION_EXTERNAL: "trace/playAnimationExternal",
  TRACE_PLAY_VIDEO: "trace/playVideo",
  TRACE_PLAY_MEDIA: "trace/playMedia",
  TRACE_PAUSE_MEDIA: "trace/pauseMedia",
  TRACE_STOP_MEDIA: "trace/stopMedia",
  TRACE_SEEK_MEDIA: "trace/seekMedia",
  TRACE_SET_MEDIA_VOLUME: "trace/setMediaVolume",
  TRACE_IS_MEDIA_PLAYING: "trace/isMediaPlaying",
  TRACE_GET_MEDIA_VOLUME: "trace/getMediaVolume",
  TRACE_SET_BEHAVIOR_ENABLED: "trace/setBehaviorEnabled",
  TRACE_NAVIGATE: "trace/navigate",
  TRACE_GET_PROPERTY: "trace/getProperty",
  TRACE_SET_PROPERTY: "trace/setProperty",
  TRACE_TIME: "trace/time",
  TRACE_SET_STATE: "trace/setState",
  TRACE_GET_STATE: "trace/getState",
  TRACE_ON_STATE_CHANGE: "trace/onStateChange",
  PAGES_NEXT: "pages/next",
  PAGES_PREV: "pages/prev",
  PAGES_GET_ACTIVE_INDEX: "pages/getActiveIndex",
  PAGES_GET_PAGE_COUNT: "pages/getPageCount"
}, $e = "traceMacro", z = "macroId", De = "macroRole", Ns = "macro/", Ue = "event", He = "variable", q = /* @__PURE__ */ new Map(), Ce = /* @__PURE__ */ Symbol("macro-param-wired");
function Pt(t) {
  const e = q.get(t.name);
  e && e !== t && y.warn(`[macros] macro "${t.name}" re-registered — the previous definition is replaced`), q.set(t.name, t);
}
function Ft(t) {
  return q.get(t);
}
function it(t) {
  for (const e of q.values()) if (e.op === t) return e;
}
function Vs() {
  return [...q.values()];
}
function Gn(t, e, n) {
  return {
    [$e]: t,
    [z]: e,
    [De]: n
  };
}
function Nt(t, e, n = {}, o, r = {}) {
  const s = o ?? crypto.randomUUID(), a = r.shape ?? e, i = {};
  for (const [h, p] of Object.entries(a.params)) {
    if (p.kind !== "config") continue;
    const f = n[h];
    if (!(f === void 0 || f === Ce))
      for (const m of p.targets) (i[m.role] ??= {})[m.socket] = [f];
  }
  const c = [];
  for (const h of a.events ?? []) {
    const p = t._addEvent();
    c.push(p);
    for (const f of h.roles) (i[f] ??= {})[Ue] = [p];
  }
  const l = [];
  for (const h of a.variables ?? []) {
    const p = t._addVariable(Ln(e, s, h), h.type, h.initial);
    l.push(p);
    for (const f of h.roles) (i[f] ??= {})[He] = [p];
  }
  const u = {};
  for (const h of a.nodes) {
    u[h.role] = t._addNode(h.op, i[h.role] ?? {}, Gn(e.name, s, h.role));
    for (const [p, f] of Object.entries(h.constants ?? {})) t._setValue(u[h.role], p, f);
  }
  let d = !1;
  for (const [h, p] of Object.entries(a.params)) {
    const f = n[h];
    if (f === Ce) continue;
    const m = p.validateLiteral?.(f) ?? null;
    if (m !== null && (r.silent || y.error(`[macros] ${e.op}: ${h} ${m} — expansion not armed`), d = !0), !(f === void 0 || p.kind === "config"))
      for (const _ of p.targets) t._setValue(u[_.role], _.socket, f);
  }
  for (const h of a.valueWires ?? []) t._setValueRef(u[h.to], h.toSocket, u[h.from], h.socket);
  const g = d ? a.disarm : [];
  for (const h of a.wires)
    g.some((p) => p.from === h.from && p.socket === h.socket) || t._setFlow(u[h.from], h.socket, u[h.to], h.toSocket);
  return {
    macroId: s,
    nodes: u,
    events: c,
    variables: l
  };
}
function Ln(t, e, n) {
  return `${t.name}:${e}:${n.name}`;
}
var Bn = class {
  constructor(t) {
    this._graph = t;
  }
  _declarationIndex(t) {
    return Vt(this._graph, t);
  }
  _typeIndex(t) {
    const e = this._graph.types.findIndex((n) => n.signature === t);
    return e !== -1 ? e : (this._graph.types.push({ signature: t }), this._graph.types.length - 1);
  }
  _addNode(t, e, n) {
    const o = Object.entries(e), r = {};
    for (const [s, a] of o) r[s] = {
      type: this._typeIndex(ct(a[0])),
      value: [...a]
    };
    return this._graph.nodes.push({
      declaration: this._declarationIndex(t),
      ...o.length > 0 ? { configuration: r } : {},
      ...n ? { metadata: { ...n } } : {}
    }), this._graph.nodes.length - 1;
  }
  _setFlow(t, e, n, o = "in") {
    const r = this._graph.nodes[t];
    (r.flows ??= {})[e] = {
      node: n,
      socket: o
    };
  }
  _setValue(t, e, n) {
    const o = this._graph.nodes[t];
    (o.values ??= {})[e] = {
      type: this._typeIndex(ct(n)),
      value: [n]
    };
  }
  _setValueRef(t, e, n, o = "value") {
    const r = this._graph.nodes[t];
    (r.values ??= {})[e] = {
      node: n,
      socket: o
    };
  }
  _addEvent() {
    return (this._graph.events ??= []).push({ id: "" }), this._graph.events.length - 1;
  }
  _addVariable(t, e, n) {
    return this._graph.variables.push({
      name: t,
      type: this._typeIndex(e),
      value: [n]
    }), this._graph.variables.length - 1;
  }
};
function ct(t) {
  return typeof t == "boolean" ? "bool" : typeof t == "number" ? "float" : "string";
}
function Vt(t, e) {
  const n = t.declarations.findIndex((o) => o.op === e && !o.extensions);
  return n !== -1 ? n : (t.declarations.push({ op: e }), t.declarations.length - 1);
}
function Gt(t, e, n, o, r = {}) {
  const s = r.shape ?? e, a = new Bn(t), i = { ...n.literals };
  for (const l of Object.keys(n.wired)) i[l] = Ce;
  const c = Nt(a, e, i, o, r);
  for (const [l, u] of Object.entries(n.wired)) for (const d of s.params[l]?.targets ?? []) (t.nodes[c.nodes[d.role]].values ??= {})[d.socket] = { ...u };
  for (const [l, u] of Object.entries(n.outputs)) {
    const d = s.outputs[l];
    d && a._setFlow(c.nodes[d.role], d.socket, u.node, u.socket);
  }
  return c;
}
function Lt(t, e) {
  const n = (o) => e.get(o) ?? o;
  for (const o of t.nodes) {
    for (const r of Object.values(o.flows ?? {})) r.node = n(r.node);
    for (const r of Object.values(o.values ?? {})) "node" in r && (r.node = n(r.node));
  }
  for (const o of [t.inputFlowSockets, t.outputFlowSockets]) for (const r of Object.values(o ?? {})) r.node = n(r.node);
  for (const o of Object.values(t.inputValueSockets ?? {})) o.node !== void 0 && (o.node = n(o.node));
  for (const o of Object.values(t.outputValueSockets ?? {})) o.node = n(o.node);
}
function Bt(t) {
  const e = new Set(t.nodes.map((r) => r.declaration)), n = /* @__PURE__ */ new Map(), o = t.declarations.filter((r, s) => e.has(s) ? (n.set(s, n.size), !0) : !1);
  if (o.length !== t.declarations.length) {
    t.declarations = o;
    for (const r of t.nodes) r.declaration = n.get(r.declaration) ?? r.declaration;
  }
}
function lt(t, e, n, o, r) {
  if (r.size === 0) return;
  const s = /* @__PURE__ */ new Map(), a = (i, c) => r.has(c) ? !1 : (s.set(c, s.size), !0);
  e === "events" ? t.events = (t.events ?? []).filter(a) : t.variables = t.variables.filter(a);
  for (const i of t.nodes) {
    const c = t.declarations[i.declaration]?.op, l = i.configuration?.[n];
    if (!l || !c || !o.includes(c)) continue;
    const u = l.value[0];
    typeof u == "number" && (l.value = [s.get(u) ?? u]);
  }
}
var jt = [b.EVENT_SEND, b.EVENT_RECEIVE], $t = [b.VARIABLE_GET, b.VARIABLE_SET];
function Dt(t) {
  if (t !== void 0 && jt.includes(t)) return Ue;
  if (t !== void 0 && $t.includes(t)) return He;
}
function Ie(t, e) {
  return e ? t.declarations[e.declaration]?.op : void 0;
}
function jn(t, e) {
  const n = /* @__PURE__ */ new Map();
  return t.nodes.forEach((o, r) => {
    const s = o.metadata, a = s?.[$e];
    if (!s || typeof a != "string" || e !== void 0 && a !== e) return;
    const i = Ft(a), c = s[z], l = s[De];
    if (!i || typeof c != "string" || typeof l != "string") return;
    let u = n.get(a);
    u || n.set(a, u = /* @__PURE__ */ new Map());
    let d = u.get(c);
    d || u.set(c, d = {
      def: i,
      macroId: c,
      roles: {},
      duplicate: !1
    }), d.roles[l] !== void 0 ? d.duplicate = !0 : d.roles[l] = r;
  }), [...n.values()].flatMap((o) => [...o.values()]);
}
function $n(t, e, n) {
  const o = {}, r = {};
  for (const [a, i] of Object.entries(e.params)) {
    const c = i.targets[0];
    if (!c) continue;
    const l = t.nodes[n[c.role]];
    if (i.kind === "config") {
      const d = l.configuration?.[c.socket];
      d && d.value.length > 0 && (o[a] = d.value[0]);
      continue;
    }
    const u = l.values?.[c.socket];
    u && ("node" in u ? r[a] = { ...u } : u.value.length > 0 && (o[a] = u.value[0]));
  }
  const s = {};
  for (const [a, i] of Object.entries(e.outputs)) {
    const c = t.nodes[n[i.role]].flows?.[i.socket];
    c && (s[a] = { ...c });
  }
  return {
    literals: o,
    wired: r,
    outputs: s
  };
}
function V(t, e) {
  const n = t ?? [], o = e ?? [];
  return n.length === o.length && n.every((r, s) => Object.is(r, o[s]));
}
function J(t, e) {
  return t.types[e]?.signature;
}
var Dn = class {
  events = /* @__PURE__ */ new Map();
  variables = /* @__PURE__ */ new Map();
  constructor(t, e, n) {
    this._stored = t, this._scratch = e, this._members = n;
  }
  node(t, e) {
    const n = this._stored.nodes[t], o = this._scratch.nodes[e], r = Ie(this._stored, n);
    return r === void 0 || r !== Ie(this._scratch, o) ? !1 : this._configuration(r, n.configuration, o.configuration) && this._values(n.values, o.values) && this._flows(n.flows, o.flows);
  }
  tables() {
    for (const [t, e] of this.events) {
      const n = this._stored.events?.[t], o = this._scratch.events?.[e];
      if (!n || !o || (n.id ?? "") !== (o.id ?? "") || Object.keys(n.values ?? {}).length > 0 || Object.keys(o.values ?? {}).length > 0) return !1;
    }
    for (const [t, e] of this.variables) {
      const n = this._stored.variables[t], o = this._scratch.variables[e];
      if (!n || !o || !V(n.value, o.value) || J(this._stored, n.type) !== J(this._scratch, o.type)) return !1;
    }
    return !0;
  }
  _ref(t, e) {
    return (this._members.get(t) ?? t) === e;
  }
  _bind(t, e, n) {
    if (typeof e != "number" || typeof n != "number" || !Number.isInteger(e)) return !1;
    const o = t.get(e);
    if (o !== void 0) return o === n;
    for (const r of t.values()) if (r === n) return !1;
    return t.set(e, n), !0;
  }
  _configuration(t, e, n) {
    const o = (a) => Object.keys(a ?? {}).filter((i) => (a[i].value ?? []).length > 0).sort(), r = o(e);
    if (!V(r, o(n))) return !1;
    const s = Dt(t);
    return r.every((a) => {
      if (a === s) {
        const i = s === "event" ? this.events : this.variables;
        return this._bind(i, e[a].value[0], n[a].value[0]);
      }
      return V(e[a].value, n[a].value);
    });
  }
  _values(t, e) {
    const n = Object.keys(t ?? {}).sort();
    return V(n, Object.keys(e ?? {}).sort()) ? n.every((o) => {
      const r = t[o], s = e[o];
      return "node" in r || "node" in s ? "node" in r && "node" in s && this._ref(r.node, s.node) && (r.socket ?? "value") === (s.socket ?? "value") : J(this._stored, r.type) === J(this._scratch, s.type) && V(r.value, s.value);
    }) : !1;
  }
  _flows(t, e) {
    const n = Object.keys(t ?? {}).sort();
    return V(n, Object.keys(e ?? {}).sort()) ? n.every((o) => this._ref(t[o].node, e[o].node) && (t[o].socket ?? "in") === (e[o].socket ?? "in")) : !1;
  }
};
function Re(t, e) {
  return new Set(Object.values(t).map((n) => `${e[n.role]}:${n.socket}`));
}
function Un(t, e, n, o, r) {
  const s = Re(e.inputs, n), a = Re(e.outputs, n);
  for (const i of Object.values(t.inputFlowSockets ?? {})) if (o.has(i.node) && !s.has(`${i.node}:${i.socket}`)) return !1;
  for (const i of Object.values(t.outputFlowSockets ?? {})) if (o.has(i.node) && !a.has(`${i.node}:${i.socket}`)) return !1;
  if ([...Object.values(t.outputValueSockets ?? {}), ...Object.values(t.inputValueSockets ?? {})].some((i) => i.node !== void 0 && o.has(i.node))) return !1;
  for (let i = 0; i < t.nodes.length; i++) {
    if (o.has(i)) continue;
    const c = t.nodes[i];
    for (const d of Object.values(c.flows ?? {})) if (o.has(d.node) && !s.has(`${d.node}:${d.socket ?? "in"}`)) return !1;
    for (const d of Object.values(c.values ?? {})) if ("node" in d && o.has(d.node)) return !1;
    const l = Dt(Ie(t, c)), u = l ? c.configuration?.[l]?.value?.[0] : void 0;
    if (typeof u == "number" && (l === "event" ? r.events : r.variables).has(u))
      return !1;
  }
  return !0;
}
function Hn(t, e, n, o) {
  const { def: r, macroId: s, roles: a } = e;
  if (Object.keys(a).length !== n.nodes.length || n.nodes.some((f) => a[f.role] === void 0)) return null;
  const i = new Set(Object.values(a)), c = $n(t, n, a), l = Re(n.inputs, a);
  if (Object.values(c.outputs).filter((f) => i.has(f.node)).some((f) => !l.has(`${f.node}:${f.socket ?? "in"}`))) return null;
  const u = {
    ...t,
    types: [...t.types],
    declarations: [...t.declarations],
    variables: [...t.variables],
    events: [...t.events ?? []],
    nodes: [...t.nodes]
  }, d = Gt(u, r, c, s, {
    shape: n,
    silent: !0
  }), g = new Map(n.nodes.map((f) => [a[f.role], d.nodes[f.role]]));
  for (const [f, m] of Object.entries(n.outputs)) {
    const _ = c.outputs[f];
    !_ || !i.has(_.node) || (u.nodes[d.nodes[m.role]].flows[m.socket] = {
      node: g.get(_.node),
      socket: _.socket
    });
  }
  const h = new Dn(t, u, g);
  if (!n.nodes.every((f) => h.node(a[f.role], d.nodes[f.role])) || !h.tables() || h.events.size !== d.events.length || h.variables.size !== d.variables.length || !Un(t, n, a, i, h)) return null;
  const p = (f, m) => [...f].find(([, _]) => _ === m)[0];
  return {
    shape: n,
    instance: {
      macro: r.name,
      macroId: s,
      nodes: a,
      params: c.literals,
      wired: c.wired,
      outputs: c.outputs,
      events: d.events.map((f) => p(h.events, f)),
      variables: d.variables.map((f) => p(h.variables, f)),
      legacy: o
    }
  };
}
function Ut(t, e) {
  const n = [];
  for (const o of jn(t, e)) {
    if (o.duplicate) continue;
    const r = [[o.def, !1], ...(o.def.legacyShapes ?? []).map((s) => [s, !0])];
    for (const [s, a] of r) {
      const i = Hn(t, o, s, a);
      if (i) {
        n.push(i);
        break;
      }
    }
  }
  return n;
}
function Wn(t, e) {
  return Ut(t, e).map((n) => n.instance);
}
function xe(t, e = {}) {
  const n = Ut(t, e.only).filter((d) => (!e.legacyOnly || d.instance.legacy) && !Object.values(d.instance.nodes).some((g) => t.nodes[g].metadata?.traceSubgraph !== void 0));
  if (n.length === 0) return t;
  const o = structuredClone(t), r = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  for (const { instance: d, shape: g } of n) {
    const h = Ft(d.macro), p = d.nodes[g.entryRole];
    i.set(p, zn(o, h, g, d));
    for (const f of Object.values(d.nodes)) f !== p && r.add(f);
    for (const [f, m] of Object.entries(g.inputs)) {
      const _ = `${d.nodes[m.role]}:${m.socket}`;
      s.has(_) || s.set(_, {
        node: p,
        socket: f
      });
    }
    for (const [f, m] of Object.entries(g.outputs)) a.set(`${d.nodes[m.role]}:${m.socket}`, {
      node: p,
      socket: f
    });
    for (const f of d.events) c.add(f);
    for (const f of d.variables) l.add(f);
  }
  for (const [d, g] of i) o.nodes[d] = g;
  o.nodes.forEach((d, g) => {
    if (!r.has(g))
      for (const [h, p] of Object.entries(d.flows ?? {})) {
        const f = s.get(`${p.node}:${p.socket ?? "in"}`);
        f && (d.flows[h] = { ...f });
      }
  });
  for (const [d, g] of [[o.inputFlowSockets, s], [o.outputFlowSockets, a]]) for (const h of Object.values(d ?? {})) {
    const p = g.get(`${h.node}:${h.socket}`);
    p && Object.assign(h, p);
  }
  const u = /* @__PURE__ */ new Map();
  return o.nodes.forEach((d, g) => {
    r.has(g) || u.set(g, u.size);
  }), o.nodes = o.nodes.filter((d, g) => !r.has(g)), Lt(o, u), lt(o, "events", Ue, jt, c), lt(o, "variables", He, $t, l), Bt(o), o;
}
function zn(t, e, n, o) {
  const r = { declaration: Vt(t, e.op) }, s = {}, a = {};
  for (const [u, d] of Object.entries(n.params)) {
    const g = d.targets[0];
    if (!g) continue;
    const h = t.nodes[o.nodes[g.role]];
    if (d.kind === "config") {
      const p = h.configuration?.[g.socket];
      p && (a[u] = structuredClone(p));
    } else {
      const p = h.values?.[g.socket];
      p && (s[u] = structuredClone(p));
    }
  }
  Object.keys(a).length > 0 && (r.configuration = a), Object.keys(s).length > 0 && (r.values = s), Object.keys(o.outputs).length > 0 && (r.flows = Object.fromEntries(Object.entries(o.outputs).map(([u, d]) => [u, { ...d }])));
  const { [$e]: i, [De]: c, ...l } = t.nodes[o.nodes[n.entryRole]].metadata ?? {};
  return r.metadata = {
    ...l,
    [z]: o.macroId
  }, r;
}
function Gs(t) {
  const e = t.graph ? xe(t.graph) : t.graph, n = t.graphs ? t.graphs.map((o) => xe(o)) : t.graphs;
  return e === t.graph && (n === t.graphs || n.every((o, r) => o === t.graphs[r])) ? t : {
    ...t,
    ...e !== void 0 ? { graph: e } : {},
    ...n !== void 0 ? { graphs: n } : {}
  };
}
function ut(t) {
  const e = xe(t, { legacyOnly: !0 });
  if (!e.declarations.some((c) => it(c.op) !== void 0)) return e;
  const n = structuredClone(e), o = /* @__PURE__ */ new Set();
  for (const c of n.nodes) {
    const l = c.metadata?.traceMacro !== void 0 ? c.metadata?.[z] : void 0;
    typeof l == "string" && o.add(l);
  }
  const r = /* @__PURE__ */ new Map(), s = n.nodes.length;
  for (let c = 0; c < s; c++) {
    const l = n.nodes[c], u = it(n.declarations[l.declaration]?.op ?? "");
    if (!u) continue;
    const d = l.metadata?.[z], g = typeof d == "string" && d !== "" && !o.has(d) ? d : void 0, h = Gt(n, u, qn(u, l), g);
    if (o.add(h.macroId), l.metadata) {
      const p = n.nodes[h.nodes[u.entryRole]];
      p.metadata = {
        ...l.metadata,
        ...p.metadata
      };
    }
    r.set(c, {
      def: u,
      nodes: h.nodes
    });
  }
  for (const c of n.nodes) for (const [l, u] of Object.entries(c.flows ?? {})) {
    const d = r.get(u.node);
    if (!d) continue;
    const { def: g, nodes: h } = d, p = g.inputs[u.socket] ?? g.inputs[g.defaultInput];
    c.flows[l] = {
      node: h[p.role],
      socket: p.socket
    };
  }
  for (const c of Object.values(n.inputFlowSockets ?? {})) {
    const l = r.get(c.node);
    if (!l) continue;
    const { def: u, nodes: d } = l, g = u.inputs[c.socket] ?? u.inputs[u.defaultInput];
    Object.assign(c, {
      node: d[g.role],
      socket: g.socket
    });
  }
  for (const c of Object.values(n.outputFlowSockets ?? {})) {
    const l = r.get(c.node), u = l?.def.outputs[c.socket];
    l && u && Object.assign(c, {
      node: l.nodes[u.role],
      socket: u.socket
    });
  }
  const a = [];
  for (let c = 0; c < s; c++) {
    const l = r.get(c);
    l ? a.push(...l.def.nodes.map((u) => l.nodes[u.role])) : a.push(c);
  }
  const i = new Map(a.map((c, l) => [c, l]));
  for (const [c, { def: l, nodes: u }] of r) i.set(c, i.get(u[l.entryRole]));
  return n.nodes = a.map((c) => n.nodes[c]), Lt(n, i), Bt(n), n;
}
function qn(t, e) {
  const n = {}, o = {};
  for (const [s, a] of Object.entries(t.params)) {
    if (a.kind === "config") {
      const c = e.configuration?.[s];
      c && c.value.length > 0 && (n[s] = c.value[0]);
      continue;
    }
    const i = e.values?.[s];
    i && ("node" in i ? o[s] = { ...i } : i.value.length > 0 && (n[s] = i.value[0]));
  }
  const r = {};
  for (const s of Object.keys(t.outputs)) {
    const a = e.flows?.[s];
    a && (r[s] = { ...a });
  }
  return {
    literals: n,
    wired: o,
    outputs: r
  };
}
function Ls(t) {
  const e = t.graph ? ut(t.graph) : t.graph, n = t.graphs ? t.graphs.map((o) => ut(o)) : t.graphs;
  return e === t.graph && (n === t.graphs || n.every((o, r) => o === t.graphs[r])) ? t : {
    ...t,
    ...e !== void 0 ? { graph: e } : {},
    ...n !== void 0 ? { graphs: n } : {}
  };
}
var Ht = "interval", Wt = "macro/interval";
var zt = "cancel", We = "interval", qt = { [We]: {
  targets: [{
    role: "delay",
    socket: "duration"
  }],
  validateLiteral: (t) => typeof t == "number" && t > 0 && Number.isFinite(t) ? null : `must be a positive, finite number of seconds (got ${JSON.stringify(t)})`
} }, Yn = {
  nodes: [
    {
      role: "restart",
      op: b.FLOW_SEQUENCE
    },
    {
      role: "delay",
      op: b.FLOW_SET_DELAY
    },
    {
      role: "tick",
      op: b.FLOW_SEQUENCE
    }
  ],
  wires: [
    {
      from: "restart",
      socket: "0",
      to: "delay",
      toSocket: "cancel"
    },
    {
      from: "restart",
      socket: "1",
      to: "delay",
      toSocket: "in"
    },
    {
      from: "delay",
      socket: "done",
      to: "tick",
      toSocket: "in"
    },
    {
      from: "tick",
      socket: "1",
      to: "delay",
      toSocket: "in"
    }
  ],
  entryRole: "restart",
  inputs: {
    in: {
      role: "restart",
      socket: "in"
    },
    [zt]: {
      role: "delay",
      socket: "cancel"
    }
  },
  defaultInput: "in",
  outputs: {
    out: {
      role: "restart",
      socket: "2"
    },
    done: {
      role: "tick",
      socket: "0"
    }
  },
  params: qt,
  disarm: [{
    from: "restart",
    socket: "1"
  }]
}, Yt = {
  name: Ht,
  op: Wt,
  nodes: [
    {
      role: "receive",
      op: b.EVENT_RECEIVE
    },
    {
      role: "running",
      op: b.VARIABLE_GET
    },
    {
      role: "gate",
      op: b.FLOW_BRANCH
    },
    {
      role: "tick",
      op: b.FLOW_SEQUENCE
    },
    {
      role: "restart",
      op: b.FLOW_SEQUENCE
    },
    {
      role: "arm",
      op: b.VARIABLE_SET,
      constants: { value: !0 }
    },
    {
      role: "clear",
      op: b.VARIABLE_SET,
      constants: { value: !1 }
    },
    {
      role: "delay",
      op: b.FLOW_SET_DELAY
    },
    {
      role: "send",
      op: b.EVENT_SEND
    }
  ],
  wires: [
    {
      from: "receive",
      socket: "out",
      to: "gate",
      toSocket: "in"
    },
    {
      from: "gate",
      socket: "true",
      to: "tick",
      toSocket: "in"
    },
    {
      from: "tick",
      socket: "1",
      to: "delay",
      toSocket: "cancel"
    },
    {
      from: "tick",
      socket: "2",
      to: "delay",
      toSocket: "in"
    },
    {
      from: "restart",
      socket: "0",
      to: "delay",
      toSocket: "cancel"
    },
    {
      from: "restart",
      socket: "1",
      to: "delay",
      toSocket: "in"
    },
    {
      from: "restart",
      socket: "3",
      to: "arm",
      toSocket: "in"
    },
    {
      from: "delay",
      socket: "done",
      to: "send",
      toSocket: "in"
    }
  ],
  valueWires: [{
    from: "running",
    socket: "value",
    to: "gate",
    toSocket: "condition"
  }],
  events: [{ roles: ["send", "receive"] }],
  variables: [{
    name: "running",
    type: "bool",
    initial: !1,
    roles: [
      "running",
      "arm",
      "clear"
    ]
  }],
  entryRole: "restart",
  inputs: {
    in: {
      role: "restart",
      socket: "in"
    },
    [zt]: {
      role: "clear",
      socket: "in"
    }
  },
  defaultInput: "in",
  outputs: {
    out: {
      role: "restart",
      socket: "2"
    },
    done: {
      role: "tick",
      socket: "0"
    }
  },
  params: qt,
  disarm: [{
    from: "restart",
    socket: "1"
  }],
  legacyShapes: [Yn]
};
Pt(Yt);
function Bs(t, e, n) {
  const { macroId: o, nodes: r, events: s, variables: a } = Nt(t, Yt, { [We]: e }, n);
  return {
    macroId: o,
    receive: r.receive,
    tick: r.tick,
    restart: r.restart,
    delay: r.delay,
    send: r.send,
    clear: r.clear,
    event: s[0],
    variable: a[0]
  };
}
function js(t) {
  return Wn(t, Ht).filter((e) => !e.legacy).map((e) => {
    const n = e.params[We];
    return {
      macroId: e.macroId,
      restart: e.nodes.restart,
      delay: e.nodes.delay,
      tick: e.nodes.tick,
      receive: e.nodes.receive,
      send: e.nodes.send,
      clear: e.nodes.clear,
      event: e.events[0],
      variable: e.variables[0],
      ...typeof n == "number" ? { seconds: n } : {},
      ...e.outputs.done ? { doneTarget: e.outputs.done } : {},
      ...e.outputs.out ? { outTarget: e.outputs.out } : {}
    };
  });
}
var Kn = "toggleActive", Kt = "macro/toggle-active", Xn = "target", Qn = {
  name: Kn,
  op: Kt,
  nodes: [
    {
      role: "get",
      op: b.TRACE_GET_ACTIVE
    },
    {
      role: "not",
      op: b.MATH_NOT
    },
    {
      role: "set",
      op: b.TRACE_SET_ACTIVE
    }
  ],
  wires: [],
  valueWires: [{
    from: "get",
    socket: "value",
    to: "not",
    toSocket: "a"
  }, {
    from: "not",
    socket: "value",
    to: "set",
    toSocket: "state"
  }],
  entryRole: "set",
  inputs: { in: {
    role: "set",
    socket: "in"
  } },
  defaultInput: "in",
  outputs: { out: {
    role: "set",
    socket: "out"
  } },
  params: { [Xn]: {
    targets: [{
      role: "get",
      socket: "target"
    }, {
      role: "set",
      socket: "target"
    }],
    kind: "config",
    validateLiteral: (t) => typeof t == "string" && t.length > 0 ? null : "must be a scene object path"
  } },
  disarm: []
};
Pt(Qn);
var S = {
  name: "target",
  type: "transformPath",
  label: "Target",
  default: "",
  description: "TransformPath to the affected scene object."
}, dt = {
  ...S,
  label: "Parent",
  description: "TransformPath to the parent whose children are addressed."
}, T = ["in"], w = ["out"], fe = [
  {
    op: b.EVENT_ON_START,
    label: "On Start",
    category: "event",
    registration: "babylon-khr",
    docGroup: "Lifecycle",
    description: "Fires once when the scene enters play mode.",
    flowInputs: [],
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [],
    configFields: []
  },
  {
    op: b.EVENT_ON_TICK,
    label: "On Tick",
    category: "event",
    registration: "babylon-khr",
    docGroup: "Lifecycle",
    description: "Fires every frame while the scene is playing.",
    flowInputs: [],
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [{
      name: "timeSinceStart",
      type: "float",
      description: "Seconds since the scene started."
    }, {
      name: "deltaTime",
      type: "float",
      description: "Seconds since the previous tick."
    }],
    configFields: []
  },
  {
    op: b.EVENT_ON_SELECT,
    label: "On Select",
    category: "event",
    registration: "babylon-khr-extension",
    docGroup: "Pointer",
    description: "Fires when the target is clicked or tapped.",
    note: "Uses the KHR_node_selectability extension. The target must be selectable.",
    flowInputs: [],
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.EVENT_ON_HOVER_IN,
    label: "On Hover In",
    category: "event",
    registration: "babylon-khr-extension",
    docGroup: "Pointer",
    description: "Fires when the pointer enters the target.",
    note: "Uses the KHR_node_hoverability extension.",
    flowInputs: [],
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.EVENT_ON_HOVER_OUT,
    label: "On Hover Out",
    category: "event",
    registration: "babylon-khr-extension",
    docGroup: "Pointer",
    description: "Fires when the pointer leaves the target.",
    note: "Uses the KHR_node_hoverability extension.",
    flowInputs: [],
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.TRACE_ON_PROXIMITY,
    label: "On Proximity",
    category: "event",
    registration: "trace-extension",
    docGroup: "Spatial",
    description: "Fires when the camera enters or exits a radius around the target.",
    flowInputs: [],
    flowOutputs: ["enter", "exit"],
    dataInputs: [{
      name: "threshold",
      type: "float",
      description: "Radius in meters."
    }],
    dataOutputs: [{
      name: "distance",
      type: "float",
      description: "Current distance from the camera to the target."
    }],
    configFields: [S]
  },
  {
    op: b.TRACE_ON_STATE_CHANGE,
    label: "On State Change",
    category: "event",
    registration: "trace-extension",
    docGroup: "States",
    description: "Fires when the target's Properties active state changes.",
    flowInputs: [],
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [{
      name: "prevState",
      type: "string",
      description: "State name before the change (empty if cleared)."
    }, {
      name: "newState",
      type: "string",
      description: "State name after the change (empty if cleared)."
    }],
    configFields: [S]
  },
  {
    op: b.FLOW_BRANCH,
    label: "Branch",
    category: "execution",
    registration: "babylon-khr",
    docGroup: "Flow",
    description: "Routes execution to one of two outputs based on a boolean condition.",
    flowInputs: T,
    flowOutputs: ["true", "false"],
    dataInputs: [{
      name: "condition",
      type: "bool"
    }],
    dataOutputs: [],
    configFields: []
  },
  {
    op: b.FLOW_SEQUENCE,
    label: "Sequence",
    category: "execution",
    registration: "babylon-khr",
    docGroup: "Flow",
    description: "Runs each output flow in order. Use to fire multiple actions from one event.",
    note: "The runtime supports any number of outputs (one per connected flow). The catalog lists the default two — add more by wiring additional `out_N` sockets.",
    flowInputs: T,
    flowOutputs: ["0", "1"],
    dataInputs: [],
    dataOutputs: [],
    configFields: []
  },
  {
    op: b.FLOW_SET_DELAY,
    label: "Delay",
    category: "execution",
    registration: "babylon-khr",
    docGroup: "Flow",
    description: "Waits a number of seconds, then continues. Use to schedule a later action.",
    note: "`out` fires immediately; `done` fires after `duration` seconds. `cancel` aborts a pending delay. `err` fires if the duration is invalid (negative, NaN, or infinite).",
    flowInputs: ["in", "cancel"],
    flowOutputs: [
      "out",
      "done",
      "err"
    ],
    dataInputs: [{
      name: "duration",
      type: "float",
      description: "Delay in seconds before `done` fires."
    }],
    dataOutputs: [{
      name: "lastDelay",
      type: "int",
      description: "Reference to the delay just scheduled. Feed into Cancel Delay to cancel this specific delay."
    }],
    configFields: []
  },
  {
    op: Wt,
    label: "Interval",
    category: "execution",
    registration: "macro",
    docGroup: "Flow",
    description: "Fires repeatedly, every `interval` seconds, until cancelled. Canned composition — expands to standard KHR nodes (Delay, Sequence, Branch, a private flag variable and a private custom event), portable to any conformant viewer, no custom op and no flow cycle.",
    note: "Logical block backed by expansion (macros/interval.ts): the loop re-enters through a private internal custom event (`event/send` → `event/receive`), because the ratified KHR_interactivity spec forbids flow cycles. Fire-then-re-arm: each period the delay elapses, its event is delivered on the next frame (Babylon's KHR loader and the native runtime both defer custom events), the `done` chain fires, then the delay re-arms — so a period is `interval` plus one frame, the payload's synchronous cost and frame quantization, identical on every conformant client. `in` (re)starts: a pending cycle is cancelled first, then the delay arms; `out` continues immediately. `cancel` stops the loop exactly, even inside the one-frame delivery window (a private running flag gates the delivery). The delay reads `interval` each time it arms, so a re-trigger (or a wired value) applies the current value. Graph teardown stops it via the delay block's lifecycle. Authoring surfaces guard the period: `GraphBuilder.interval()` rejects non-positive/non-finite values, and lowering a `macro/interval` with an invalid literal expands with the loop unarmed (warns, never fires). A WIRED period cannot be checked at edit time: negative/NaN errs the delay at runtime, and a dynamic 0 degrades to once per frame. Recognition is metadata-based: editing the expansion away from its canonical wiring degrades it to plain nodes — they still execute, but no longer collapse to this block. Stored expansions in the pre-#896 cyclic shape are migrated when the graph is loaded.",
    flowInputs: ["in", "cancel"],
    flowOutputs: ["out", "done"],
    dataInputs: [{
      name: "interval",
      type: "float",
      description: "Seconds between firings."
    }],
    dataOutputs: [],
    configFields: []
  },
  {
    op: b.FLOW_CANCEL_DELAY,
    label: "Cancel Delay",
    category: "execution",
    registration: "babylon-khr",
    docGroup: "Flow",
    description: "Cancels a specific pending delay scheduled by a Delay node.",
    note: "Wire the source Delay node's `lastDelay` output into `delay` (usually stashed in a variable first). Alternatively, drive the Delay node's own `cancel` flow input to cancel all of that node's pending delays at once.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "delay",
      type: "int",
      description: "The lastDelay reference from the Delay node to cancel."
    }],
    dataOutputs: [],
    configFields: []
  },
  {
    op: b.TRACE_SET_ACTIVE,
    label: "Set Active",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Object",
    description: "Activate or deactivate a scene object. Inactive objects stop rendering and stop responding to input, along with their whole subtree. This is authored scene state, not glTF `KHR_node_visibility` (which is rendering only).",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "state",
      type: "bool",
      description: "true to show, false to hide."
    }],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: Kt,
    label: "Toggle Active",
    category: "execution",
    registration: "macro",
    docGroup: "Object",
    description: "Flip a scene object between active and inactive. Canned composition — expands to Get Active → Not → Set Active.",
    note: 'Logical block backed by expansion (macros/): reads the target\'s current active state, inverts it, and writes it back. Named for `active` rather than "visibility" because it toggles authored scene state — inactive objects stop rendering AND stop responding to input, subtree included — whereas glTF `KHR_node_visibility` is rendering only. Unlike Interval, this expansion uses TRACE_interactivity ops (`trace/getActive` / `trace/setActive`), since glTF has no standard pointer for this: it is portable across Trace clients rather than to every conformant viewer. Recognition is metadata-based: editing the expansion away from its canonical wiring degrades it to plain nodes — they still execute, but no longer collapse to this block.',
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [],
    configFields: [{
      ...S,
      description: "TransformPath to the object whose active state is flipped."
    }]
  },
  {
    op: b.TRACE_SET_BEHAVIOR_ENABLED,
    label: "Enable Behavior",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Object",
    description: "Switch a behavior's runtime effect on or off — e.g. start or stop Tethering/Facing.",
    note: "Works on RuntimeToggleable behaviors (Billboard, Tether, ViewAnchor). The authored `enabled` field on the behavior is the state at every play-mode start; disabling a Billboard applies its onExit (ease back / hold), disabling a Tether or ViewAnchor stops it in place and re-enabling re-runs its delay. Other behaviors warn and no-op.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "enabled",
      type: "bool",
      description: "true to enable, false to disable. Defaults to true."
    }],
    dataOutputs: [],
    configFields: [S, {
      name: "behavior",
      type: "string",
      label: "Behavior",
      default: "",
      description: 'Behavior type name on the target, e.g. "Tether" or "Billboard".'
    }]
  },
  {
    op: b.TRACE_GET_ACTIVE,
    label: "Get Active",
    category: "data",
    registration: "trace-extension",
    docGroup: "Object",
    description: "Read whether a scene object is currently active.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: [S]
  },
  {
    op: b.TRACE_GET_CHILD_COUNT,
    label: "Get Child Count",
    category: "data",
    registration: "trace-extension",
    docGroup: "Object",
    description: "Read the number of direct children under a parent.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: [dt]
  },
  {
    op: b.TRACE_SET_ACTIVE_CHILD,
    label: "Set Active Child",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Object",
    description: "Show one child of a parent and hide its siblings. Index is clamped to the child range.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "index",
      type: "float",
      description: "Zero-based index of the child to show."
    }],
    dataOutputs: [],
    configFields: [dt]
  },
  {
    op: b.TRACE_SET_STATE,
    label: "Set State",
    category: "execution",
    registration: "trace-extension",
    docGroup: "States",
    description: "Set the active state on the target AND every participating descendant in its state group (scoped fan-out, pruned at nested stateGroup boundaries). Empty string clears the state (reverts to base). Targeting a group owner switches the whole group.",
    note: "Scoped per STATE_SCOPE_SPEC.md — resolved live against the scene. Triggers any transitions defined on the Properties states; re-setting the current state is a no-op (R7).",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "state",
      type: "string"
    }],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.TRACE_GET_STATE,
    label: "Get State",
    category: "data",
    registration: "trace-extension",
    docGroup: "States",
    description: "Read the active state name from a target's Properties. Empty when no state is active.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "state",
      type: "string"
    }],
    configFields: [S]
  },
  {
    op: b.TRACE_GET_PROPERTY,
    label: "Get Property",
    category: "data",
    registration: "trace-extension",
    docGroup: "Properties",
    description: "Read a named property value from a target's Properties behavior.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "any"
    }],
    configFields: [S, {
      name: "property",
      type: "string",
      label: "Property",
      default: "",
      description: "Property name as declared on the Properties behavior."
    }]
  },
  {
    op: b.TRACE_SET_PROPERTY,
    label: "Set Property",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Properties",
    description: "Write a value to a named property on a target's Properties behavior. Animates when the declaration has a default transition.",
    note: "Optional `transition` config (`{ duration, easing }`) overrides the declaration's default transition for this edge; omitted → declaration default → snap.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "value",
      type: "any"
    }],
    dataOutputs: [],
    configFields: [S, {
      name: "property",
      type: "string",
      label: "Property",
      default: "",
      description: "Property name as declared on the Properties behavior."
    }]
  },
  {
    op: b.TRACE_TIME,
    label: "Time",
    category: "data",
    registration: "trace-extension",
    docGroup: "Lifecycle",
    description: "Read play-mode elapsed time. Pull-evaluated — re-reads on every access.",
    note: "Mirrors the `time.elapsed` system value available in `{expression}` bindings.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "elapsed",
      type: "float",
      description: "Seconds since play mode started (0 when not playing)."
    }],
    configFields: []
  },
  {
    op: b.POINTER_SET,
    label: "Set Transform",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Transform",
    description: "Write a transform component on the target.",
    note: "Value is a Vec3 for translation/scale or a quaternion [x, y, z, w] for rotation — typed `any` because the shape depends on the `property` config. Always a snap write; it cancels a running pointer/interpolate on the SAME pointer (target + property) only — other components’ interpolations continue (KHR rule). For animated writes use pointer/interpolate. Target resolution is strict, matching pointer/interpolate: an empty target means the host, but a non-empty path that does not resolve fires `err` instead of `out` rather than silently retargeting the host. An invalid value for the property fires `err` too, and nothing is written.",
    flowInputs: T,
    flowOutputs: ["out", "err"],
    dataInputs: [{
      name: "value",
      type: "any",
      description: "Vec3 for translation/scale, Vec4 quaternion for rotation."
    }],
    dataOutputs: [],
    configFields: [S, {
      name: "property",
      type: "transformProperty",
      label: "Property",
      default: "translation",
      description: "Which transform component to write."
    }]
  },
  {
    op: b.POINTER_INTERPOLATE,
    label: "Interpolate Transform",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Transform",
    description: "Animate a transform component on the target toward a value over a duration, easing along a cubic bezier.",
    note: "This IS the KHR-standard pointer/interpolate op (Trace overrides the implementation for TransformPath addressing, like pointer/set). `p1`/`p2` are CSS cubic-bezier control points — every Trace easing is one of these (see EASING_CONTROL_POINTS); missing → easeInOut. A new interpolation on the same pointer (target + property) REPLACES the running one and cancels its pending `done`; a pointer/set snap on the same pointer also cancels it. `duration` <= 0 → snap, `done` fires immediately after `out`. `err` fires instead of `out` when the target/property/value is invalid.",
    flowInputs: T,
    flowOutputs: [
      "out",
      "done",
      "err"
    ],
    dataInputs: [
      {
        name: "value",
        type: "any",
        description: "Vec3 for translation/scale, Vec4 quaternion for rotation."
      },
      {
        name: "duration",
        type: "float",
        description: "Interpolation length in seconds. <= 0 snaps."
      },
      {
        name: "p1",
        type: "float2",
        description: "First cubic-bezier control point [x1, y1]."
      },
      {
        name: "p2",
        type: "float2",
        description: "Second cubic-bezier control point [x2, y2]."
      }
    ],
    dataOutputs: [],
    configFields: [S, {
      name: "property",
      type: "transformProperty",
      label: "Property",
      default: "translation",
      description: "Which transform component to animate."
    }]
  },
  {
    op: b.POINTER_GET,
    label: "Get Transform",
    category: "data",
    registration: "trace-extension",
    docGroup: "Transform",
    description: "Read a transform component from the target.",
    note: "Output is a Vec3 for translation/scale or a quaternion [x, y, z, w] for rotation — typed `any` because the shape depends on the `property` config.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "any"
    }],
    configFields: [S, {
      name: "property",
      type: "transformProperty",
      label: "Property",
      default: "translation"
    }]
  },
  {
    op: b.TRACE_PLAY_ANIMATION,
    label: "Play Animation",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Animation",
    description: "Play an animation clip on a target with an Animation behavior.",
    note: "`out` fires immediately; `done` fires when the clip finishes (never, if looping).",
    flowInputs: T,
    flowOutputs: ["out", "done"],
    dataInputs: [{
      name: "speed",
      type: "float",
      description: "Playback rate. 1 = normal, negative = reverse."
    }, {
      name: "loop",
      type: "bool"
    }],
    dataOutputs: [],
    configFields: [S, {
      name: "clip",
      type: "string",
      label: "Clip",
      default: "",
      description: "Animation clip name. Empty plays the default clip."
    }]
  },
  {
    op: b.TRACE_PLAY_ANIMATION_EXTERNAL,
    label: "Play External Animation",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Animation",
    description: "Play an animation clip sourced from an external GLB.",
    flowInputs: T,
    flowOutputs: [
      "out",
      "started",
      "done"
    ],
    dataInputs: [{
      name: "speed",
      type: "float"
    }, {
      name: "loop",
      type: "bool"
    }],
    dataOutputs: [],
    configFields: [
      S,
      {
        name: "src",
        type: "string",
        label: "Source GLB",
        default: "",
        description: "URL of the GLB containing the clip."
      },
      {
        name: "clip",
        type: "string",
        label: "Clip",
        default: ""
      }
    ]
  },
  {
    op: b.TRACE_PLAY_MEDIA,
    label: "Play Media",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Media",
    description: "Play or resume media on any Playable target (Video, AudioClip, Animation, Pages).",
    note: "`src` is only honored on Video and AudioClip (they swap the URL before playback). `volume` is only honored on volume-capable targets.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [
      {
        name: "src",
        type: "string",
        description: "Optional URL swap (Video / AudioClip only)."
      },
      {
        name: "volume",
        type: "float",
        description: "0–1 (only honored on volume-capable targets)."
      },
      {
        name: "seek",
        type: "float",
        description: "Seek to seconds before playing. Negative = no seek."
      }
    ],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.TRACE_PAUSE_MEDIA,
    label: "Pause Media",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Media",
    description: "Pause media at the current position.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.TRACE_STOP_MEDIA,
    label: "Stop Media",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Media",
    description: "Stop media and reset to time 0.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.TRACE_SEEK_MEDIA,
    label: "Seek Media",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Media",
    description: "Seek to a specific time without changing play state.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "time",
      type: "float",
      description: "Seconds from the start of the media."
    }],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.TRACE_SET_MEDIA_VOLUME,
    label: "Set Media Volume",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Media",
    description: "Set the volume on a Video or AudioClip target.",
    note: "No-op on targets that do not implement PlayableVolume (Animation, Pages).",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "volume",
      type: "float",
      description: "Volume in the range 0–1."
    }],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.TRACE_IS_MEDIA_PLAYING,
    label: "Is Media Playing",
    category: "data",
    registration: "trace-extension",
    docGroup: "Media",
    description: "Whether the target's media is currently playing (pull-evaluated).",
    note: "True while playback runs on the resolved Playable (Video, AudioClip, Animation…). False for unresolvable targets and Playables without playback state (Pages). Feed into flow/branch for a Play/Pause toggle that stays true to reality — including media that ended on its own.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: [S]
  },
  {
    op: b.TRACE_GET_MEDIA_VOLUME,
    label: "Get Media Volume",
    category: "data",
    registration: "trace-extension",
    docGroup: "Media",
    description: "Read the target's current volume, 0–1 (pull-evaluated).",
    note: 'Reads the underlying media element (Video, AudioClip). Returns 1 — the element default — for targets without a volume control, so "no volume" reads as unmuted.',
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: [S]
  },
  {
    op: b.TRACE_PLAY_VIDEO,
    label: "Play Video",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Media",
    description: "Legacy video playback. Prefer Play Media for new graphs.",
    deprecated: !0,
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [
      {
        name: "play",
        type: "bool"
      },
      {
        name: "volume",
        type: "float"
      },
      {
        name: "seek",
        type: "float"
      }
    ],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.PAGES_NEXT,
    label: "Pages Next",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Pages",
    description: "Advance to the next page on a Pages behavior.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "wrap",
      type: "bool",
      description: "When true, wraps from the last page back to the first."
    }, {
      name: "animate",
      type: "bool"
    }],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.PAGES_PREV,
    label: "Pages Prev",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Pages",
    description: "Go back one page on a Pages behavior.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "wrap",
      type: "bool"
    }, {
      name: "animate",
      type: "bool"
    }],
    dataOutputs: [],
    configFields: [S]
  },
  {
    op: b.PAGES_GET_ACTIVE_INDEX,
    label: "Get Page Index",
    category: "data",
    registration: "trace-extension",
    docGroup: "Pages",
    description: "Read the zero-based index of the currently active page.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: [S]
  },
  {
    op: b.PAGES_GET_PAGE_COUNT,
    label: "Get Page Count",
    category: "data",
    registration: "trace-extension",
    docGroup: "Pages",
    description: "Read the total number of pages.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: [S]
  },
  {
    op: b.TRACE_NAVIGATE,
    label: "Navigate",
    category: "execution",
    registration: "trace-extension",
    docGroup: "Navigation",
    description: "Open a URL.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "url",
      type: "string"
    }],
    dataOutputs: [],
    configFields: []
  },
  {
    op: b.MATH_MIN,
    label: "Minimum",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "The smaller of a and b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_MAX,
    label: "Maximum",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "The larger of a and b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_POW,
    label: "Power",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a raised to the power b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_LE,
    label: "Less Than or Equal",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "True when a is less than or equal to b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: []
  },
  {
    op: b.MATH_ADD,
    label: "Add",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a + b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_SUB,
    label: "Subtract",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a − b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_MUL,
    label: "Multiply",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a × b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_DIV,
    label: "Divide",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a ÷ b. Result is undefined when b is zero.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_FLOOR,
    label: "Floor",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "Largest integer ≤ a.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_RANDOM,
    label: "Random",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "Random float in [min, max).",
    note: "Re-evaluates every time the output is pulled — chain through `variable/set` if you need a stable value across a frame.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "min",
      type: "float"
    }, {
      name: "max",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "float"
    }],
    configFields: []
  },
  {
    op: b.MATH_EQ,
    label: "Equal",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a equals b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "any"
    }, {
      name: "b",
      type: "any"
    }],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: []
  },
  {
    op: b.MATH_GT,
    label: "Greater Than",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a > b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: []
  },
  {
    op: b.MATH_GE,
    label: "Greater or Equal",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a ≥ b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: []
  },
  {
    op: b.MATH_LT,
    label: "Less Than",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a < b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "float"
    }, {
      name: "b",
      type: "float"
    }],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: []
  },
  {
    op: b.MATH_NOT,
    label: "NOT",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "Boolean negation.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "bool"
    }],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: []
  },
  {
    op: b.MATH_AND,
    label: "AND",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a AND b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "bool"
    }, {
      name: "b",
      type: "bool"
    }],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: []
  },
  {
    op: b.MATH_OR,
    label: "OR",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "a OR b.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [{
      name: "a",
      type: "bool"
    }, {
      name: "b",
      type: "bool"
    }],
    dataOutputs: [{
      name: "value",
      type: "bool"
    }],
    configFields: []
  },
  {
    op: b.MATH_SELECT,
    label: "Select",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "Returns a when condition is true, b otherwise.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [
      {
        name: "condition",
        type: "bool"
      },
      {
        name: "a",
        type: "any"
      },
      {
        name: "b",
        type: "any"
      }
    ],
    dataOutputs: [{
      name: "value",
      type: "any"
    }],
    configFields: []
  },
  {
    op: b.MATH_COMBINE3,
    label: "Combine Vec3",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Math",
    description: "Pack three floats into a Vec3.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [
      {
        name: "a",
        type: "float"
      },
      {
        name: "b",
        type: "float"
      },
      {
        name: "c",
        type: "float"
      }
    ],
    dataOutputs: [{
      name: "value",
      type: "float3"
    }],
    configFields: []
  },
  {
    op: b.VARIABLE_GET,
    label: "Get Variable",
    category: "data",
    registration: "babylon-khr",
    docGroup: "Variables",
    description: "Read a graph-scoped variable. Resolves by index — see the Variables panel.",
    note: "Socket type is `any` because the actual type comes from `GraphData.variables[index].type` (bool, float, float3, etc.). Pull evaluation: this re-reads on every access — if a downstream chain writes via `variable/set` and then reads back, you may see the already-updated value.",
    flowInputs: [],
    flowOutputs: [],
    dataInputs: [],
    dataOutputs: [{
      name: "value",
      type: "any"
    }],
    configFields: [{
      name: "variable",
      type: "number",
      label: "Variable Index",
      default: 0,
      description: "Index into the graph variables[] array."
    }]
  },
  {
    op: b.VARIABLE_SET,
    label: "Set Variable",
    category: "execution",
    registration: "babylon-khr",
    docGroup: "Variables",
    description: "Write a graph-scoped variable.",
    note: "Socket type is `any` because the actual type comes from `GraphData.variables[index].type`.",
    flowInputs: T,
    flowOutputs: w,
    dataInputs: [{
      name: "value",
      type: "any"
    }],
    dataOutputs: [],
    configFields: [{
      name: "variable",
      type: "number",
      label: "Variable Index",
      default: 0
    }]
  }
], Jn = [{
  op: b.EVENT_SEND,
  label: "Send Event",
  category: "execution",
  registration: "babylon-khr",
  docGroup: "Events",
  description: "Sends a custom event. Every Receive Event node for the same event runs, in node order, before `out` continues.",
  note: "Internal events (no id) are private to the graph; delivery is deferred to the next frame in both the native runtime and Babylon's KHR loader (the spec leaves timing to the application).",
  flowInputs: T,
  flowOutputs: w,
  dataInputs: [],
  dataOutputs: [],
  configFields: [{
    name: "event",
    type: "number",
    label: "Event Index",
    default: 0,
    description: "Index into the graph's custom events."
  }]
}, {
  op: b.EVENT_RECEIVE,
  label: "Receive Event",
  category: "event",
  registration: "babylon-khr",
  docGroup: "Events",
  description: "Fires when its custom event is sent.",
  flowInputs: [],
  flowOutputs: w,
  dataInputs: [],
  dataOutputs: [],
  configFields: [{
    name: "event",
    type: "number",
    label: "Event Index",
    default: 0,
    description: "Index into the graph's custom events."
  }]
}], Zn = new Map([...fe, ...Jn].map((t) => [t.op, t]));
function eo(t) {
  return Zn.get(t);
}
function $s(t) {
  return fe.filter((e) => e.category === t);
}
function Ds(t) {
  return fe.filter((e) => e.docGroup === t);
}
var N = "TRACE_materials_occlusion", to = new Ee();
function no(t, e = {}) {
  const n = t.metadata ??= {}, o = n.gltf ??= {}, r = o.extensions ??= {};
  r[N] = { ...e }, to.notifyObservers(t);
}
function Us(t) {
  const e = t.metadata, n = e?.gltf;
  if (!n?.extensions || n.extensions.TRACE_materials_occlusion === void 0) return;
  const o = { ...n.extensions };
  delete o[N], t.metadata = {
    ...e,
    gltf: {
      ...n,
      extensions: o
    }
  };
}
function Z(t) {
  return t?.metadata?.gltf?.extensions?.[N] !== void 0;
}
function oo(t, e) {
  t.forceDepthWrite = !0, t.backFaceCulling = !e, t.transparencyMode = re.MATERIAL_OPAQUE, t.alpha = 1;
}
var ro = class {
  name = N;
  enabled;
  order = 200;
  _loader;
  constructor(t) {
    this._loader = t, this.enabled = this._loader.isExtensionUsed(N);
  }
  dispose() {
    this._loader = null;
  }
  loadMaterialPropertiesAsync(t, e, n) {
    return Pn.LoadExtensionAsync(t, e, this.name, async (o, r) => {
      await this._loader.loadMaterialPropertiesAsync(t, e, n), oo(n, e.doubleSided === !0), no(n, r);
    });
  }
};
kt(N);
xt(N, !0, (t) => new ro(t));
var so = 1179937895, ao = 1313821514, io = 5130562;
function Xt(t) {
  const e = new DataView(t.buffer, t.byteOffset, t.byteLength);
  if (t.byteLength >= 12 && e.getUint32(0, !0) === so) {
    let o = 12, r = null, s = null;
    for (; o + 8 <= t.byteLength; ) {
      const a = e.getUint32(o, !0), i = e.getUint32(o + 4, !0), c = t.subarray(o + 8, o + 8 + a);
      i === ao && !r ? r = JSON.parse(new TextDecoder().decode(c)) : i === io && !s && (s = c), o += 8 + a;
    }
    if (!r) throw new Error("GLB has no JSON chunk");
    return {
      json: r,
      bin: s
    };
  }
  const n = JSON.parse(new TextDecoder().decode(t));
  if (!n || typeof n != "object" || Array.isArray(n)) throw new Error("not a glTF file");
  return {
    json: n,
    bin: null
  };
}
function x(t) {
  return t !== null && typeof t == "object" && !Array.isArray(t) ? t : void 0;
}
function co(t) {
  const e = /^data:[^;,]*(;base64)?,(.*)$/s.exec(t);
  if (!e) return null;
  if (!e[1]) return new TextEncoder().encode(decodeURIComponent(e[2]));
  const n = atob(e[2]), o = new Uint8Array(n.length);
  for (let r = 0; r < n.length; r++) o[r] = n.charCodeAt(r);
  return o;
}
async function Qt(t, e) {
  return Promise.all((Array.isArray(t.json.buffers) ? t.json.buffers : []).map(async (n, o) => {
    const r = x(n)?.uri;
    return typeof r != "string" ? o === 0 ? t.bin : null : r.startsWith("data:") ? co(r) : e ? e(r) : null;
  }));
}
var lo = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, uo = {
  5120: 1,
  5121: 1,
  5122: 2,
  5123: 2,
  5125: 4,
  5126: 4
};
function fo(t, e, n, o) {
  switch (n) {
    case 5120: {
      const r = t.getInt8(e);
      return o ? Math.max(r / 127, -1) : r;
    }
    case 5121: {
      const r = t.getUint8(e);
      return o ? r / 255 : r;
    }
    case 5122: {
      const r = t.getInt16(e, !0);
      return o ? Math.max(r / 32767, -1) : r;
    }
    case 5123: {
      const r = t.getUint16(e, !0);
      return o ? r / 65535 : r;
    }
    case 5125:
      return t.getUint32(e, !0);
    case 5126:
      return t.getFloat32(e, !0);
    default:
      throw new Error(`unknown componentType ${n}`);
  }
}
function ge(t, e, n, o, r, s, a, i, c, l) {
  const u = x(t.bufferViews?.[n]);
  if (!u) throw new Error(`bufferView ${n} does not exist`);
  const d = e[u.buffer];
  if (!d) throw new Error(`buffer ${String(u.buffer)} is not available`);
  const g = uo[a];
  if (!g) throw new Error(`unknown componentType ${a}`);
  const h = g * s, p = !l && typeof u.byteStride == "number" && u.byteStride > 0 ? u.byteStride : h, f = (typeof u.byteOffset == "number" ? u.byteOffset : 0) + o, m = new DataView(d.buffer, d.byteOffset, d.byteLength);
  for (let _ = 0; _ < r; _++) for (let v = 0; v < s; v++) c[_ * s + v] = fo(m, f + _ * p + v * g, a, i);
}
function ft(t, e, n) {
  const o = x(t.accessors?.[n]);
  if (!o) throw new Error(`accessor ${n} does not exist`);
  const r = lo[o.type], s = o.count;
  if (!r || !Number.isInteger(s) || s < 0) throw new Error(`accessor ${n} is malformed`);
  const a = o.componentType, i = o.normalized === !0, c = new Float32Array(s * r);
  Number.isInteger(o.bufferView) && ge(t, e, o.bufferView, typeof o.byteOffset == "number" ? o.byteOffset : 0, s, r, a, i, c);
  const l = x(o.sparse);
  if (l && Number.isInteger(l.count) && l.count > 0) {
    const u = l.count, d = x(l.indices) ?? {}, g = x(l.values) ?? {}, h = new Uint32Array(u);
    ge(t, e, d.bufferView, typeof d.byteOffset == "number" ? d.byteOffset : 0, u, 1, d.componentType, !1, h, !0);
    const p = new Float32Array(u * r);
    ge(t, e, g.bufferView, typeof g.byteOffset == "number" ? g.byteOffset : 0, u, r, a, i, p, !0);
    for (let f = 0; f < u; f++) c.set(p.subarray(f * r, (f + 1) * r), h[f] * r);
  }
  return {
    data: c,
    count: s,
    components: r
  };
}
function po(t, e, n, o) {
  const r = x(x(t.animations?.[n])?.samplers?.[o]);
  if (!r) throw new Error(`animation ${n} has no sampler ${o}`);
  const s = r.interpolation ?? "LINEAR";
  if (s !== "LINEAR" && s !== "STEP" && s !== "CUBICSPLINE") throw new Error(`sampler interpolation "${s}" is not glTF`);
  return {
    input: ft(t, e, r.input).data,
    output: ft(t, e, r.output).data,
    interpolation: s
  };
}
var Jt = "traceDriver";
function Zt(t) {
  return t.metadata?.[Jt]?.driver;
}
function ho(t, e) {
  t.metadata = {
    ...t.metadata && typeof t.metadata == "object" ? t.metadata : {},
    [Jt]: { driver: e }
  };
}
function mo(t) {
  return t._internalMetadata?.gltf?.fileNames;
}
function go(t) {
  return t._internalMetadata?.gltf?.primitiveOfNode;
}
function _e(t, e, n) {
  if (!t) return;
  const o = t, r = o._internalMetadata = o._internalMetadata ?? {}, s = r.gltf = r.gltf ?? {};
  s.fileNames = e, n !== void 0 && (s.primitiveOfNode = n);
}
function _o(t) {
  t.animations?.forEach((e, n) => {
    const o = e.extras?.trace?.driver, r = e._babylonAnimationGroup;
    if (!o || typeof o.node != "string" || typeof o.target != "string" || !r) return;
    let s = 1 / 0, a = -1 / 0;
    for (const i of e.samplers ?? []) {
      const c = t.accessors?.[i.input ?? -1];
      typeof c?.min?.[0] == "number" && (s = Math.min(s, c.min[0])), typeof c?.max?.[0] == "number" && (a = Math.max(a, c.max[0]));
    }
    Number.isFinite(s) || (s = 0), Number.isFinite(a) || (a = r.to / (r.targetedAnimations[0]?.animation.framePerSecond ?? 60)), ho(r, {
      node: o.node,
      target: o.target,
      index: n,
      inputMin: s,
      inputMax: a
    });
  });
}
var vo = class {
  name = je;
  enabled = !0;
  _loader;
  constructor(t) {
    this._loader = t;
  }
  onReady() {
    const t = this._loader?.gltf;
    if (t && _o(t), !t?.nodes?.length) return;
    const e = Be(t);
    t.nodes.forEach((n, o) => {
      _e(n._babylonTransformNode, e), _e(n._babylonTransformNodeForSkin, e);
      for (const r of n._primitiveBabylonMeshes ?? []) _e(r, e, o);
    });
  }
  dispose() {
    this._loader = null;
  }
};
kt(je);
xt(je, !1, (t) => new vo(t));
function Y(t) {
  return t._internalMetadata?.gltf?.pointers ?? [];
}
function yo(t) {
  return t && typeof t == "object" && Object.getPrototypeOf(t) === Object.prototype ? { ...t } : t;
}
function Hs(t, ...e) {
  const n = /* @__PURE__ */ new Map(), o = [...t.transformNodes, ...t.meshes];
  for (const i of o) {
    if (Y(i).length === 0) continue;
    const c = Object.freeze({ __gltfPointerCarry: !0 });
    n.set(c, {
      source: i,
      original: i.metadata
    }), i.metadata = c;
  }
  let r;
  try {
    r = t.instantiateModelsToScene(...e);
  } finally {
    for (const { source: i, original: c } of n.values()) i.metadata = c;
  }
  const s = new Set(o), a = (i) => {
    const c = i.metadata, l = c && typeof c == "object" ? n.get(c) : void 0;
    l && (i.metadata = yo(l.original));
    const u = i;
    if (Y(i).length === 0) {
      let d = l?.source;
      if (!d && i.getClassName() === "InstancedMesh") {
        const g = i.sourceMesh;
        g && s.has(g) && (d = g);
      }
      d && d !== i && (u._internalMetadata = d._internalMetadata);
    }
    for (const d of i.getChildren()) a(d);
  };
  for (const i of r.rootNodes) a(i);
  return r;
}
function ke(t, e) {
  Object.assign(e, {
    gammaSpace: t.gammaSpace,
    level: t.level,
    wrapU: t.wrapU,
    wrapV: t.wrapV,
    wrapR: t.wrapR,
    anisotropicFilteringLevel: t.anisotropicFilteringLevel,
    coordinatesIndex: t.coordinatesIndex,
    coordinatesMode: t.coordinatesMode,
    optimizeUVAllocation: t.optimizeUVAllocation,
    uOffset: t.uOffset,
    vOffset: t.vOffset,
    uScale: t.uScale,
    vScale: t.vScale,
    uAng: t.uAng,
    vAng: t.vAng,
    wAng: t.wAng,
    uRotationCenter: t.uRotationCenter,
    vRotationCenter: t.vRotationCenter,
    wRotationCenter: t.wRotationCenter,
    homogeneousRotationInUVTransform: t.homogeneousRotationInUVTransform
  }), e.updateSamplingMode(t.samplingMode);
}
function bo(t, e) {
  let n = !1;
  for (let o = 0; o < t.length; o += 4)
    e.roughness && t[o + 1] !== 255 && (t[o + 1] = 255, n = !0), e.metallic && t[o + 2] !== 255 && (t[o + 2] = 255, n = !0);
  return n;
}
var pt = 5e3, Oo = 50;
async function Ao(t) {
  const e = Date.now() + pt;
  for (; !t.isReady(); ) {
    if (Date.now() >= e)
      return y.warn(`[FactorTexture] "${t.name}" did not load within ${pt / 1e3} s; nothing was read from it`), !1;
    await new Promise((n) => setTimeout(n, Oo));
  }
  return !0;
}
async function So(t) {
  let e;
  try {
    e = await t.readPixels();
  } catch {
    return null;
  }
  if (!(e instanceof Uint8Array) || e.length === 0) return null;
  let n = 0, o = 0;
  for (let s = 0; s < e.length; s += 4)
    n += e[s + 1], o += e[s + 2];
  const r = e.length / 4 * 255;
  return {
    roughness: n / r,
    metallic: o / r
  };
}
var ht = (t) => Math.min(1, Math.max(0, t)), mt = (t) => typeof t == "number" && Number.isFinite(t) ? t : 1;
async function Ws(t) {
  const e = t.metallicTexture;
  if (e && !await Ao(e)) return {};
  const n = e ? await So(e) : null;
  return {
    roughness: ht(mt(t.roughness) * (n?.roughness ?? 1)),
    metallic: ht(mt(t.metallic) * (n?.metallic ?? 1))
  };
}
async function wo(t, e) {
  if (!t.isReady())
    return y.warn(`[FactorTexture] "${t.name}" is not loaded yet; its factor override keeps multiplying the texture`), null;
  const n = await t.readPixels();
  if (!(n instanceof Uint8Array))
    return y.warn(`[FactorTexture] Can't read "${t.name}" back; its factor override keeps multiplying the texture`), null;
  if (!bo(n, e)) return null;
  const { width: o, height: r } = t.getSize(), s = Me.CreateRGBATexture(n, o, r, t.getScene(), !t.noMipmap, !1, t.samplingMode);
  return s.name = `${t.name} (factor override)`, s;
}
var ze = "traceTransparencyOwned";
function gt(t) {
  const e = t.metadata?.[ze];
  return e && typeof e == "object" ? e : null;
}
function zs(t) {
  const e = t.metadata;
  if (!e?.traceTransparencyOwned) return;
  const { [ze]: n, ...o } = e;
  t.metadata = o;
}
var qe = "traceAuthoredTransparency";
function To(t) {
  const e = t.metadata ?? {};
  if (e.traceAuthoredTransparency) return;
  const n = {
    alpha: t.alpha,
    transparencyMode: t.transparencyMode,
    needDepthPrePass: t.needDepthPrePass
  };
  t.metadata = {
    ...e,
    [qe]: n
  };
}
function Eo(t) {
  const e = t.metadata;
  if (!e?.traceAuthoredTransparency) return;
  const { [qe]: n, ...o } = e;
  t.metadata = o;
}
function Mo(t) {
  const e = t.metadata?.[qe];
  return e && typeof e == "object" ? e : {
    alpha: t.alpha,
    transparencyMode: t.transparencyMode,
    needDepthPrePass: t.needDepthPrePass
  };
}
function qs(t) {
  const e = {
    alpha: t.alpha,
    transparencyMode: t.transparencyMode,
    needDepthPrePass: t.needDepthPrePass
  };
  t.metadata = {
    ...t.metadata ?? {},
    [ze]: e
  };
}
function ve(t, e) {
  const n = t.clone(e);
  if (n) {
    t instanceof de && n instanceof de && t.metallicTexture instanceof Me && n.metallicTexture instanceof Me && ke(t.metallicTexture, n.metallicTexture);
    const o = new Set(t.getActiveTextures()), r = new Set(n.getActiveTextures().filter((s) => !o.has(s)));
    n.onDisposeObservable.addOnce(() => {
      for (const s of r) s.dispose();
    });
  }
  return n;
}
var ae = /* @__PURE__ */ new Map();
function Co(t, e) {
  return ae.set(t, e), () => {
    ae.get(t) === e && ae.delete(t);
  };
}
function Ys(t) {
  for (const e of ae.values()) if (e(t)) return !0;
  return !1;
}
var Io = "TRACE_interactivity", Ro = {
  "trace/onProximity": { threshold: [5] },
  "trace/setActive": { state: [!1] },
  "trace/setBehaviorEnabled": { enabled: [!0] },
  "trace/setActiveChild": { index: [0] },
  "trace/setState": { state: [""] },
  "trace/playAnimation": {
    speed: [1],
    loop: [!1]
  },
  "trace/playAnimationExternal": {
    speed: [1],
    loop: [!1]
  },
  "trace/playVideo": {
    play: [!1],
    volume: [-1],
    seek: [-1]
  },
  "trace/playMedia": {
    src: [""],
    volume: [-1],
    seek: [-1]
  },
  "trace/seekMedia": { time: [0] },
  "trace/setMediaVolume": { volume: [1] },
  "trace/navigate": { url: [""] },
  "pages/next": {
    wrap: [!0],
    animate: [!1]
  },
  "pages/prev": {
    wrap: [!0],
    animate: [!1]
  },
  "pointer/interpolate": { duration: [0] }
};
function xo(t) {
  if (t.startsWith("trace/")) return t.slice(6);
  const [e, n] = t.split("/");
  return n ? e + n.charAt(0).toUpperCase() + n.slice(1) : t;
}
function ko() {
  const t = /* @__PURE__ */ new Map();
  for (const e of fe) {
    if (e.registration !== "trace-extension") continue;
    const n = {};
    for (const s of e.dataInputs) n[s.name] = s.type;
    const o = {};
    for (const s of e.dataOutputs) o[s.name] = s.type;
    const r = Ro[e.op] ?? {};
    t.set(e.op, {
      graphOp: e.op,
      wireOp: xo(e.op),
      inputs: n,
      outputs: o,
      defaults: r
    });
  }
  return t;
}
var en = ko(), Po = new Map([...en.values()].map((t) => [t.wireOp, t]));
function Fo(t) {
  return en.get(t);
}
function No(t) {
  return Po.get(t);
}
function Vo(t) {
  switch (t) {
    case "string":
    case "color":
      return "custom";
    case "any":
      return;
    default:
      return t;
  }
}
function Go(t) {
  return [...Object.values(t.inputs), ...Object.values(t.outputs)].every((e) => e !== "any");
}
function Ks(t) {
  if (!Go(t)) return;
  const e = (n) => Object.fromEntries(Object.entries(n).map(([o, r]) => [o, Vo(r)]));
  return {
    inputValueSockets: e(t.inputs),
    outputValueSockets: e(t.outputs)
  };
}
var tn = /* @__PURE__ */ new Set([
  "event/onSelect",
  "event/onHoverIn",
  "event/onHoverOut"
]), nn = /* @__PURE__ */ new Set([
  "pointer/get",
  "pointer/set",
  "pointer/interpolate"
]), on = /* @__PURE__ */ new Set([
  "trace/onProximity",
  "trace/setActive",
  "trace/getActive",
  "trace/getChildCount",
  "trace/setActiveChild",
  "trace/getProperty",
  "trace/setProperty",
  "trace/setState",
  "trace/getState",
  "trace/onStateChange",
  "trace/playAnimation",
  "trace/playAnimationExternal",
  "trace/playVideo",
  "trace/playMedia",
  "trace/pauseMedia",
  "trace/stopMedia",
  "trace/seekMedia",
  "trace/setMediaVolume",
  "trace/isMediaPlaying",
  "trace/getMediaVolume",
  "trace/setBehaviorEnabled",
  "pages/next",
  "pages/prev",
  "pages/getActiveIndex",
  "pages/getPageCount"
]);
function ye(t, e) {
  if (!t || t === "$self") return e.pathToIndex.get(e.hostFqtp) ?? null;
  if (t === "$root") {
    const r = e.hostFqtp.split("/")[0];
    return r ? e.pathToIndex.get(r) ?? null : null;
  }
  if (t === "$parent") {
    const r = e.hostFqtp.split("/");
    r.pop();
    const s = r.join("/");
    return s ? e.pathToIndex.get(s) ?? null : null;
  }
  if (t.startsWith("/")) return e.pathToIndex.get(t.slice(1)) ?? null;
  if (t.startsWith("./")) {
    const r = `${e.hostFqtp}/${t.slice(2)}`;
    return e.pathToIndex.get(r) ?? null;
  }
  if (t.startsWith("../")) {
    const r = e.hostFqtp.split("/");
    let s = t;
    for (; s.startsWith("../"); ) {
      if (r.length === 0) return null;
      r.pop(), s = s.slice(3);
    }
    const a = s ? `${r.join("/")}/${s}` : r.join("/");
    return e.pathToIndex.get(a) ?? null;
  }
  const n = e.hostFqtp.split("/");
  n.pop();
  const o = n.length > 0 ? `${n.join("/")}/${t}` : t;
  if (e.pathToIndex.has(o)) return e.pathToIndex.get(o);
  for (const [r, s] of e.pathToIndex) if (r === t || r.endsWith(`/${t}`)) return s;
  return null;
}
function Lo(t, e) {
  const n = [];
  let o = t;
  const r = /* @__PURE__ */ new Set();
  for (; o !== void 0 && !r.has(o); )
    r.add(o), n.unshift(e.nameOf(o) ?? `Node_${o}`), o = e.parentOf(o);
  return n.join("/");
}
function be(t, e) {
  if (t < 0 || t >= e.nodeCount) return `/Node_${t}`;
  if (t === e.hostIndex) return "$self";
  const n = _t(e.hostIndex, e), o = _t(t, e);
  if (o.length > n.length) {
    let i = !0;
    for (let c = 0; c < n.length; c++) if (o[c] !== n[c]) {
      i = !1;
      break;
    }
    if (i) return "./" + o.slice(n.length).map((c) => e.nameOf(c) ?? `Node_${c}`).join("/");
  }
  let r = 0;
  const s = Math.min(n.length, o.length);
  for (let i = 0; i < s && n[i] === o[i]; i++) r = i + 1;
  if (r === 0) return "/" + Lo(t, e);
  const a = n.length - r;
  return "../".repeat(a) + o.slice(r).map((i) => e.nameOf(i) ?? `Node_${i}`).join("/");
}
function _t(t, e) {
  const n = [];
  let o = t;
  const r = /* @__PURE__ */ new Set();
  for (; o !== void 0 && !r.has(o); )
    r.add(o), n.unshift(o), o = e.parentOf(o);
  return n;
}
var Bo = /* @__PURE__ */ new Set([
  "translation",
  "rotation",
  "scale"
]);
function jo(t, e, n) {
  if (!e) return e;
  if (tn.has(t)) {
    const o = e.target;
    if (!o && e.nodeIndex !== void 0) return e;
    const r = o?.value?.[0], s = ye(typeof r == "string" ? r : "", n);
    return s === null ? vt(e) : {
      ...vt(e),
      nodeIndex: {
        type: 0,
        value: [s]
      }
    };
  }
  if (nn.has(t)) {
    if (!e.target && e.pointer !== void 0) return e;
    const o = e.target?.value?.[0], r = e.property?.value?.[0], s = typeof o == "string" ? o : "", a = typeof r == "string" ? r : "translation", i = ye(s, n);
    if (i === null || !Bo.has(a)) return e;
    const c = { ...e };
    return delete c.target, delete c.property, c.pointer = {
      type: 0,
      value: [`/nodes/${i}/${a}`]
    }, c;
  }
  if (on.has(t)) {
    const o = e.target?.value?.[0];
    if (typeof o != "string") return e;
    const r = ye(o, n);
    return r === null ? e : {
      ...e,
      target: {
        type: 0,
        value: [r]
      }
    };
  }
  return e;
}
function $o(t, e, n) {
  if (!e) return e;
  if (tn.has(t)) {
    const o = e.nodeIndex?.value?.[0], r = typeof o == "number" ? o : Number(o);
    if (!Number.isInteger(r)) return e;
    const s = be(r, n), a = { ...e };
    return delete a.nodeIndex, a.target = {
      type: 0,
      value: [s]
    }, a;
  }
  if (nn.has(t)) {
    const o = e.pointer?.value?.[0];
    if (typeof o != "string") return e;
    const r = Do(o);
    if (!r) return e;
    const s = { ...e };
    return delete s.pointer, s.target = {
      type: 0,
      value: [be(r.nodeIndex, n)]
    }, s.property = {
      type: 0,
      value: [r.property]
    }, s;
  }
  if (on.has(t)) {
    const o = e.target?.value?.[0];
    return typeof o != "number" || !Number.isInteger(o) ? e : {
      ...e,
      target: {
        type: 0,
        value: [be(o, n)]
      }
    };
  }
  return e;
}
function vt(t) {
  const e = { ...t };
  return delete e.target, e;
}
function Do(t) {
  const e = t.match(/^\/nodes\/(\d+)\/([^/]+)$/);
  if (!e) return null;
  const n = Number.parseInt(e[1], 10);
  return Number.isInteger(n) ? {
    nodeIndex: n,
    property: e[2]
  } : null;
}
function Xs(t, e, n) {
  const o = e[t.declaration];
  return o ? jo(o, t.configuration, n) : t.configuration;
}
function Uo(t, e, n) {
  const o = e[t.declaration];
  return o ? $o(o, t.configuration, n) : t.configuration;
}
var Ho = /* @__PURE__ */ new Set([
  "bool",
  "int",
  "float",
  "float2",
  "float3",
  "float4",
  "float2x2",
  "float3x3",
  "float4x4",
  "ref"
]);
function Wo(t) {
  return Ho.has(t);
}
var Qs = class {
  _entries = [];
  _index = /* @__PURE__ */ new Map();
  index(t) {
    const e = this._index.get(t);
    if (e !== void 0) return e;
    const n = Wo(t) ? { signature: t } : {
      signature: "custom",
      extensions: { [Io]: { type: t } }
    }, o = this._entries.length;
    return this._entries.push(n), this._index.set(t, o), o;
  }
  get entries() {
    return this._entries;
  }
};
function zo(t) {
  return t.signature !== "custom" ? t.signature : t.extensions?.TRACE_interactivity?.type === "color" ? "color" : "string";
}
function Js(t, e) {
  const n = t.graphs[t.graph ?? 0];
  return n ? rn(n, e) : {
    types: [],
    declarations: [],
    variables: [],
    events: [],
    nodes: []
  };
}
function Zs(t, e) {
  return {
    graphs: t.graphs.map((n) => rn(n, e)),
    activeGraph: t.graph ?? 0
  };
}
function rn(t, e) {
  const n = (t.types ?? []).map((l) => ({ signature: zo(l) })), o = (t.declarations ?? []).map((l) => {
    const u = { op: qo(l) };
    return l.extensions?.TRACE_subgraph && (u.extensions = { TRACE_subgraph: { ...l.extensions.TRACE_subgraph } }), u;
  }), r = (t.variables ?? []).map((l, u) => ({
    name: l.name ?? `var_${u}`,
    type: l.type,
    value: l.value ? [...l.value] : []
  })), s = (t.events ?? []).map((l) => ({
    id: l.id ?? "",
    ...l.values ? { values: Object.fromEntries(Object.entries(l.values).map(([u, d]) => [u, {
      type: d.type,
      value: d.value ? [...d.value] : []
    }])) } : {}
  })), a = o.map((l) => l.op), i = (t.declarations ?? []).map((l) => l.extension === "TRACE_interactivity" || !!l.extensions?.TRACE_subgraph), c = {
    types: n,
    declarations: o,
    variables: r,
    events: s,
    nodes: (t.nodes ?? []).map((l) => Ko(l, a, i, e))
  };
  return t.inputFlowSockets && (c.inputFlowSockets = Object.fromEntries(Object.entries(t.inputFlowSockets).map(([l, u]) => [l, u]))), t.outputFlowSockets && (c.outputFlowSockets = Object.fromEntries(Object.entries(t.outputFlowSockets).map(([l, u]) => [l, u]))), t.inputValueSockets && (c.inputValueSockets = Object.fromEntries(Object.entries(t.inputValueSockets).map(([l, u]) => [l, u]))), t.outputValueSockets && (c.outputValueSockets = Object.fromEntries(Object.entries(t.outputValueSockets).map(([l, u]) => [l, u]))), c;
}
function qo(t) {
  return t.extensions?.TRACE_subgraph ? t.op : t.extension === "TRACE_interactivity" ? No(t.op)?.graphOp ?? `trace/${t.op}` : t.op;
}
var Yo = /* @__PURE__ */ new Set([
  "pointer/get",
  "pointer/set",
  "pointer/interpolate"
]);
function Ko(t, e, n, o) {
  const r = { declaration: t.declaration };
  if (t.configuration) {
    const a = {};
    for (const [i, c] of Object.entries(t.configuration)) a[i] = {
      type: 0,
      value: c.value ? [...c.value] : []
    };
    r.configuration = o ? Uo({
      ...r,
      configuration: a
    }, e, o) ?? a : a;
  }
  if (t.values) {
    const a = {};
    for (const [i, c] of Object.entries(t.values)) "node" in c ? a[i] = {
      node: c.node,
      socket: c.socket ?? "value"
    } : a[i] = {
      type: c.type,
      value: c.value ? [...c.value] : []
    };
    r.values = a;
  }
  if (t.flows) {
    const a = {};
    for (const [i, c] of Object.entries(t.flows)) a[i] = {
      node: c.node,
      socket: c.socket ?? "in"
    };
    r.flows = a;
  }
  t.extras && Object.keys(t.extras).length > 0 && (r.metadata = { ...t.extras });
  const s = e[t.declaration];
  return s && n[t.declaration] && Xo(r, s), s === "variable/set" && Qo(r), s && Yo.has(s) && Jo(r), r;
}
function Xo(t, e) {
  if (!t.values) return;
  const n = Fo(e)?.defaults ?? {};
  for (const [o, r] of Object.entries(t.values)) {
    if ("node" in r) continue;
    const s = r.value ?? [], a = n[o];
    (s.length === 0 || a && JSON.stringify(s) === JSON.stringify(a)) && delete t.values[o];
  }
  Object.keys(t.values).length === 0 && delete t.values;
}
function Qo(t) {
  const e = t.configuration?.variables?.value;
  if (!e || e.length !== 1 || t.configuration?.variable) return;
  const n = e[0], { variables: o, ...r } = t.configuration;
  t.configuration = {
    ...r,
    variable: {
      type: 0,
      value: [n]
    }
  };
  const s = String(n);
  if (t.values?.[s]) {
    const { [s]: a, ...i } = t.values;
    t.values = {
      ...i,
      value: a
    };
  }
}
function Jo(t) {
  const e = t.configuration;
  if (!e) return;
  if (e.target && e.property && !e.pointer) {
    const { type: r, ...s } = e;
    t.configuration = s;
    return;
  }
  const n = e.pointer?.value?.[0];
  if (typeof n != "string") return;
  const o = n.replace(/\{([^{}/]+)\}/g, (r, s) => {
    const a = t.values?.[s], i = a && !("node" in a) ? a.value?.[0] : void 0;
    return typeof i == "number" && Number.isInteger(i) ? `[${s}]` : r;
  });
  o !== n && (e.pointer = {
    ...e.pointer,
    value: [o]
  });
}
function yt(t) {
  return t.declarations.some((e) => e.extensions?.TRACE_subgraph !== void 0);
}
var pe = "traceSubgraph", Ye = "traceSubgraphIndex", Ke = "traceSubgraphOf";
function Zo(t, e) {
  const n = t.findIndex((o) => o.signature === e.signature);
  return n !== -1 ? n : (t.push({ ...e }), t.length - 1);
}
function er(t, e) {
  if (!e.extensions) {
    const n = t.findIndex((o) => o.op === e.op && !o.extensions);
    if (n !== -1) return n;
  }
  return t.push(structuredClone(e)), t.length - 1;
}
function tr(t, e) {
  if (!e.has(t)) return t;
  for (let n = 2; ; n++) {
    const o = `${t}__${n}`;
    if (!e.has(o)) return o;
  }
}
function k(t, e) {
  return t.get(e) ?? e;
}
function nr(t, e) {
  return eo(t)?.dataInputs?.some((n) => n.name === e) ?? !1;
}
function or(t) {
  for (const e of [
    t.entry,
    t.values,
    t.exit
  ]) {
    const n = Object.values(e)[0];
    if (n) return n.node;
  }
}
function rr(t, e, n = []) {
  if (!yt(t)) return t;
  const o = e.indexOf(t), r = o === -1 ? n : [...n, o], s = structuredClone(t), a = new Set(s.variables.map((u) => u.name)), i = /* @__PURE__ */ new Map(), c = s.nodes.length;
  for (let u = 0; u < c; u++) {
    const d = s.nodes[u], g = s.declarations[d.declaration]?.extensions?.TRACE_subgraph;
    if (!g) continue;
    if (g.asset !== void 0) {
      y.error(`[inlineSubgraphs] node ${u}: external-asset subgraph (asset ${g.asset}) cannot be flattened — exported KHR will carry TRACE_subgraph and will not run in a conformant viewer`);
      continue;
    }
    if (r.includes(g.graph)) {
      y.error(`[inlineSubgraphs] node ${u}: recursive subgraph (graph ${g.graph}) cannot be flattened — exported KHR will carry TRACE_subgraph and will not run in a conformant viewer`);
      continue;
    }
    const h = e[g.graph];
    if (!h) {
      y.error(`[inlineSubgraphs] node ${u}: subgraph references invalid graph index ${g.graph} — left unflattened`);
      continue;
    }
    const p = rr(h, e, r);
    if (yt(p)) {
      y.error(`[inlineSubgraphs] node ${u}: subgraph ${g.graph} is not fully flattenable — left intact, so exported KHR will carry TRACE_subgraph`);
      continue;
    }
    i.set(u, sr(s, p, d, a, {
      op: s.declarations[d.declaration].op,
      instanceId: crypto.randomUUID()
    }));
  }
  if (i.size === 0) return t;
  ar(s, i), n.length === 0 && (delete s.inputFlowSockets, delete s.outputFlowSockets, delete s.inputValueSockets, delete s.outputValueSockets);
  const l = s.nodes.length - t.nodes.length;
  return y.log(`[inlineSubgraphs] flattened ${i.size} invocation(s), ${l >= 0 ? "+" : ""}${l} nodes`), s;
}
function sr(t, e, n, o, r) {
  const s = e.types.map((f) => Zo(t.types, f)), a = e.declarations.map((f) => er(t.declarations, f)), i = t.events ??= [], c = (e.events ?? []).map((f) => {
    if (f.id) {
      const _ = i.findIndex((v) => v.id === f.id);
      if (_ !== -1) return _;
    }
    const m = structuredClone(f);
    if (m.values) for (const _ of Object.values(m.values)) _.type = s[_.type] ?? _.type;
    return i.push(m), i.length - 1;
  }), l = e.variables.map((f) => {
    const m = tr(f.name, o);
    return o.add(m), t.variables.push({
      ...structuredClone(f),
      name: m,
      type: s[f.type] ?? f.type
    }), t.variables.length - 1;
  }), u = e.variables.map((f, m) => ({
    name: f.name,
    parentIndex: l[m]
  })), d = e.nodes.map((f, m) => {
    const _ = structuredClone(f);
    if (_.declaration = a[f.declaration] ?? _.declaration, r) {
      const v = m === 0 ? {
        op: r.op,
        nodeCount: e.nodes.length,
        iface: {
          ...e.inputFlowSockets ? { inputFlowSockets: structuredClone(e.inputFlowSockets) } : {},
          ...e.outputFlowSockets ? { outputFlowSockets: structuredClone(e.outputFlowSockets) } : {},
          ...e.inputValueSockets ? { inputValueSockets: structuredClone(e.inputValueSockets) } : {},
          ...e.outputValueSockets ? { outputValueSockets: structuredClone(e.outputValueSockets) } : {}
        },
        variables: u,
        ...c.length > 0 ? { events: [...c] } : {}
      } : void 0;
      _.metadata = {
        ..._.metadata,
        [pe]: r.instanceId,
        [Ye]: m,
        ...v ? { [Ke]: v } : {}
      };
    }
    if (_.configuration) for (const v of Object.values(_.configuration)) v.type = s[v.type] ?? v.type;
    if (_.values)
      for (const v of Object.values(_.values)) "type" in v && (v.type = s[v.type] ?? v.type);
    return t.nodes.push(_), t.nodes.length - 1;
  });
  for (let f = 0; f < e.nodes.length; f++) {
    const m = t.nodes[d[f]];
    if (m.flows) for (const A of Object.values(m.flows)) A.node = d[A.node] ?? A.node;
    if (m.values)
      for (const A of Object.values(m.values)) "node" in A && (A.node = d[A.node] ?? A.node);
    const _ = e.declarations[e.nodes[f].declaration]?.op, v = m.configuration?.variable;
    if (v && (_ === b.VARIABLE_GET || _ === b.VARIABLE_SET)) {
      const A = Number(v.value[0]);
      v.value = [l[A] ?? A];
    }
    const O = m.configuration?.event;
    if (O && (_ === b.EVENT_SEND || _ === b.EVENT_RECEIVE)) {
      const A = Number(O.value[0]);
      O.value = [c[A] ?? A];
    }
  }
  for (const f of Object.keys(e.inputValueSockets ?? {})) {
    const m = n.values?.[f];
    if (m)
      for (let _ = 0; _ < e.nodes.length; _++) {
        const v = e.nodes[_], O = v.values?.[f];
        if (O && "node" in O) continue;
        const A = e.declarations[v.declaration]?.op;
        if (!A || !nr(A, f)) continue;
        const E = t.nodes[d[_]];
        (E.values ??= {})[f] = { ...m };
      }
  }
  for (const [f, m] of Object.entries(e.outputFlowSockets ?? {})) {
    const _ = n.flows?.[f];
    if (!_) continue;
    const v = t.nodes[d[m.node]];
    v && ((v.flows ??= {})[m.socket] = { ..._ });
  }
  const g = {};
  for (const [f, m] of Object.entries(e.inputFlowSockets ?? {})) g[f] = {
    node: d[m.node],
    socket: m.socket
  };
  const h = {};
  for (const [f, m] of Object.entries(e.outputFlowSockets ?? {})) h[f] = {
    node: d[m.node],
    socket: m.socket
  };
  const p = {};
  for (const [f, m] of Object.entries(e.outputValueSockets ?? {})) p[f] = {
    node: d[m.node],
    socket: m.socket
  };
  return {
    entry: g,
    exit: h,
    values: p
  };
}
function ar(t, e) {
  for (const i of t.nodes) {
    if (i.flows) for (const c of Object.keys(i.flows)) {
      const l = i.flows[c], u = e.get(l.node);
      if (!u) continue;
      const d = u.entry[l.socket] ?? u.entry.in;
      d ? i.flows[c] = { ...d } : (y.warn(`[inlineSubgraphs] flow into socket "${l.socket}" has no entry point in the spliced body — wire dropped`), delete i.flows[c]);
    }
    if (i.values) for (const c of Object.keys(i.values)) {
      const l = i.values[c];
      if (!("node" in l)) continue;
      const u = e.get(l.node);
      if (!u) continue;
      const d = u.values[l.socket];
      d && (i.values[c] = {
        node: d.node,
        socket: d.socket
      });
    }
  }
  for (const [i, c] of Object.entries(t.outputValueSockets ?? {})) {
    const l = e.get(c.node)?.values[c.socket];
    l && (t.outputValueSockets[i] = {
      ...c,
      node: l.node,
      socket: l.socket
    });
  }
  for (const [i, c] of Object.entries(t.outputFlowSockets ?? {})) {
    const l = e.get(c.node)?.exit[c.socket];
    l && (t.outputFlowSockets[i] = {
      node: l.node,
      socket: l.socket
    });
  }
  for (const [i, c] of Object.entries(t.inputFlowSockets ?? {})) {
    const l = e.get(c.node), u = l?.entry[c.socket] ?? l?.entry.in;
    u && (t.inputFlowSockets[i] = {
      node: u.node,
      socket: u.socket
    });
  }
  const n = /* @__PURE__ */ new Map();
  let o = 0;
  for (let i = 0; i < t.nodes.length; i++) e.has(i) || n.set(i, o++);
  for (const [i, c] of e) {
    const l = or(c);
    l !== void 0 && n.set(i, k(n, l));
  }
  t.nodes = t.nodes.filter((i, c) => !e.has(c));
  for (const i of t.nodes) {
    if (i.flows) for (const c of Object.values(i.flows)) c.node = k(n, c.node);
    if (i.values)
      for (const c of Object.values(i.values)) "node" in c && (c.node = k(n, c.node));
  }
  for (const i of [t.inputFlowSockets, t.outputFlowSockets])
    if (i)
      for (const c of Object.values(i)) c.node = k(n, c.node);
  if (t.inputValueSockets)
    for (const i of Object.values(t.inputValueSockets)) i.node !== void 0 && (i.node = k(n, i.node));
  if (t.outputValueSockets) for (const i of Object.values(t.outputValueSockets)) i.node = k(n, i.node);
  const r = new Set(t.nodes.map((i) => i.declaration)), s = /* @__PURE__ */ new Map(), a = [];
  for (let i = 0; i < t.declarations.length; i++)
    r.has(i) && (s.set(i, a.length), a.push(t.declarations[i]));
  t.declarations = a;
  for (const i of t.nodes) i.declaration = k(s, i.declaration);
}
function ir(t) {
  return t.nodes.some((e) => typeof e.metadata?.[pe] == "string");
}
function cr(t) {
  const e = /* @__PURE__ */ new Map();
  for (let o = 0; o < t.nodes.length; o++) {
    const r = t.nodes[o].metadata, s = r?.[pe];
    if (!r || typeof s != "string") continue;
    const a = r[Ye];
    let i = e.get(s);
    if (i || (i = {
      members: /* @__PURE__ */ new Map(),
      broken: !1
    }, e.set(s, i)), typeof a != "number" || i.members.has(a)) {
      i.broken = !0;
      continue;
    }
    i.members.set(a, o);
    const c = r[Ke];
    a === 0 && c && typeof c == "object" && (i.manifest = c);
  }
  const n = [];
  for (const [o, r] of e) {
    if (r.broken || !r.manifest) continue;
    const s = r.manifest.nodeCount;
    if (typeof s != "number" || r.members.size !== s) continue;
    const a = [];
    let i = !0;
    for (let c = 0; c < s; c++) {
      const l = r.members.get(c);
      if (l === void 0) {
        i = !1;
        break;
      }
      a.push(l);
    }
    i && n.push({
      instanceId: o,
      manifest: r.manifest,
      members: a
    });
  }
  return n;
}
function sn(t) {
  if (!t.metadata) return t;
  const e = { ...t.metadata };
  delete e[pe], delete e[Ye], delete e[Ke];
  const n = { ...t };
  return Object.keys(e).length > 0 ? n.metadata = e : delete n.metadata, n;
}
function lr(t, e) {
  const { members: n, manifest: o } = e, r = /* @__PURE__ */ new Map();
  n.forEach((m, _) => r.set(m, _));
  const s = [], a = [], i = (m) => {
    const _ = s.findIndex((v) => v.signature === m.signature);
    return _ === -1 ? s.push({ ...m }) - 1 : _;
  }, c = (m) => {
    if (!m.extensions) {
      const _ = a.findIndex((v) => v.op === m.op && !v.extensions);
      if (_ !== -1) return _;
    }
    return a.push(structuredClone(m)) - 1;
  }, l = [], u = /* @__PURE__ */ new Map();
  for (const m of o.variables) {
    const _ = t.variables[m.parentIndex];
    if (!_) return null;
    u.set(m.parentIndex, l.length), l.push({
      ...structuredClone(_),
      name: m.name,
      type: i(t.types[_.type] ?? { signature: "float" })
    });
  }
  const d = (m) => m === "variable/get" || m === "variable/set", g = [], h = /* @__PURE__ */ new Map();
  for (const m of o.events ?? []) {
    const _ = t.events?.[m];
    if (!_) return null;
    const v = structuredClone(_);
    if (v.values) for (const O of Object.values(v.values)) O.type = i(t.types[O.type] ?? { signature: "string" });
    h.set(m, g.length), g.push(v);
  }
  const p = (m) => m === "event/send" || m === "event/receive", f = [];
  for (const m of n) {
    const _ = t.nodes[m], v = structuredClone(sn(_)), O = t.declarations[_.declaration]?.op ?? "";
    if (v.declaration = c(t.declarations[_.declaration] ?? { op: O }), v.configuration) {
      for (const C of Object.values(v.configuration)) C.type = i(t.types[C.type] ?? { signature: "string" });
      const A = v.configuration.variable;
      if (A && d(O)) {
        const C = u.get(Number(A.value[0]));
        if (C === void 0) return null;
        A.value = [C];
      }
      const E = v.configuration.event;
      if (E && p(O)) {
        const C = h.get(Number(E.value[0]));
        if (C === void 0) return null;
        E.value = [C];
      }
    }
    if (v.flows) for (const [A, E] of Object.entries(v.flows)) {
      const C = r.get(E.node);
      if (C !== void 0) {
        E.node = C;
        continue;
      }
      if (!Object.entries(o.iface.outputFlowSockets ?? {}).some(([, Je]) => Je.node === r.get(m) && Je.socket === A)) return null;
      delete v.flows[A];
    }
    if (v.values) for (const A of Object.values(v.values)) if ("node" in A) {
      const E = r.get(A.node);
      if (E === void 0) return null;
      A.node = E;
    } else A.type = i(t.types[A.type] ?? { signature: "string" });
    f.push(v);
  }
  return {
    types: s,
    declarations: a,
    variables: l,
    events: g,
    nodes: f,
    ...o.iface.inputFlowSockets ? { inputFlowSockets: structuredClone(o.iface.inputFlowSockets) } : {},
    ...o.iface.outputFlowSockets ? { outputFlowSockets: structuredClone(o.iface.outputFlowSockets) } : {},
    ...o.iface.inputValueSockets ? { inputValueSockets: structuredClone(o.iface.inputValueSockets) } : {},
    ...o.iface.outputValueSockets ? { outputValueSockets: structuredClone(o.iface.outputValueSockets) } : {}
  };
}
function ea(t) {
  if (!ir(t)) return null;
  const e = cr(t);
  if (e.length === 0) return null;
  const n = structuredClone(t), o = [], r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  for (const p of e) {
    if (p.members.some((v) => r.has(v))) continue;
    const f = lr(n, p);
    if (!f) {
      y.log(`[recollapseSubgraphs] instance ${p.instanceId}: not reconstructable — left flat`);
      continue;
    }
    const m = o.push(f), _ = p.members[0];
    for (const v of p.members) r.set(v, {
      entry: _,
      group: p,
      graphIndex: m
    });
    for (const v of p.manifest.variables) s.add(v.parentIndex);
    for (const v of p.manifest.events ?? []) n.events?.[v]?.id || a.add(v);
  }
  if (o.length === 0) return null;
  for (const [, { entry: p, group: f, graphIndex: m }] of r) {
    const _ = n.nodes[p];
    if (_.metadata?.traceSubgraphOf === void 0) continue;
    const v = n.declarations.push({
      op: f.manifest.op,
      extensions: { TRACE_subgraph: { graph: m } }
    }) - 1, O = sn(_).metadata;
    n.nodes[p] = {
      declaration: v,
      ...O ? { metadata: O } : {}
    };
  }
  for (const [, { entry: p, group: f }] of r) for (const [m, _] of Object.entries(f.manifest.iface.outputFlowSockets ?? {})) {
    const v = f.members[_.node];
    if (v === void 0) continue;
    const O = t.nodes[v]?.flows?.[_.socket];
    !O || f.members.includes(O.node) || ((n.nodes[p].flows ??= {})[m] = { ...O });
  }
  const i = (p) => r.get(p);
  for (let p = 0; p < n.nodes.length; p++) {
    if (r.has(p) && n.nodes[p].declaration !== void 0 && i(p)?.entry !== p) continue;
    const f = n.nodes[p];
    if (f.flows) for (const [m, _] of Object.entries(f.flows)) {
      const v = i(_.node);
      if (!v || v.group.members.includes(p)) continue;
      const O = v.group.members.indexOf(_.node), A = Object.entries(v.group.manifest.iface.inputFlowSockets ?? {}).find(([, E]) => E.node === O && E.socket === _.socket);
      f.flows[m] = {
        node: v.entry,
        socket: A?.[0] ?? "in"
      };
    }
    if (f.values) for (const [m, _] of Object.entries(f.values)) {
      if (!("node" in _)) continue;
      const v = i(_.node);
      if (!v || v.group.members.includes(p)) continue;
      const O = v.group.members.indexOf(_.node), A = Object.entries(v.group.manifest.iface.outputValueSockets ?? {}).find(([, E]) => E.node === O && E.socket === _.socket);
      f.values[m] = {
        node: v.entry,
        socket: A?.[0] ?? _.socket
      };
    }
  }
  const c = /* @__PURE__ */ new Set();
  for (const [, { entry: p, group: f }] of r) for (const m of f.members) m !== p && c.add(m);
  const l = /* @__PURE__ */ new Map();
  let u = 0;
  for (let p = 0; p < n.nodes.length; p++) c.has(p) || l.set(p, u++);
  for (const [, { entry: p }] of r) for (const f of c) l.set(f, l.get(p) ?? 0);
  n.nodes = n.nodes.filter((p, f) => !c.has(f));
  for (const p of n.nodes) {
    if (p.flows) for (const f of Object.values(p.flows)) f.node = l.get(f.node) ?? f.node;
    if (p.values)
      for (const f of Object.values(p.values)) "node" in f && (f.node = l.get(f.node) ?? f.node);
  }
  if (s.size > 0) {
    const p = /* @__PURE__ */ new Map(), f = [];
    for (let m = 0; m < n.variables.length; m++)
      s.has(m) || (p.set(m, f.length), f.push(n.variables[m]));
    n.variables = f;
    for (const m of n.nodes) {
      const _ = n.declarations[m.declaration]?.op, v = m.configuration?.variable;
      if (!v || _ !== "variable/get" && _ !== "variable/set") continue;
      const O = Number(v.value[0]);
      v.value = [p.get(O) ?? O];
    }
  }
  if (a.size > 0) {
    const p = /* @__PURE__ */ new Map(), f = [];
    (n.events ?? []).forEach((m, _) => {
      a.has(_) || (p.set(_, f.length), f.push(m));
    }), n.events = f;
    for (const m of n.nodes) {
      const _ = n.declarations[m.declaration]?.op, v = m.configuration?.event;
      if (!v || _ !== "event/send" && _ !== "event/receive") continue;
      const O = Number(v.value[0]);
      v.value = [p.get(O) ?? O];
    }
  }
  const d = new Set(n.nodes.map((p) => p.declaration)), g = /* @__PURE__ */ new Map(), h = [];
  for (let p = 0; p < n.declarations.length; p++)
    d.has(p) && (g.set(p, h.length), h.push(n.declarations[p]));
  n.declarations = h;
  for (const p of n.nodes) p.declaration = g.get(p.declaration) ?? p.declaration;
  return y.log(`[recollapseSubgraphs] recovered ${o.length} subgraph invocation(s)`), {
    graphs: [n, ...o],
    activeGraph: 0
  };
}
var ur = "animation-binding-unbound";
Co("TRACE_animation_binding", (t) => t.animationBinding !== void 0);
var Oe = /* @__PURE__ */ new WeakMap(), bt = /* @__PURE__ */ new WeakMap();
async function Pe(t) {
  const e = await fetch(t);
  if (!e.ok) throw new Error(`${e.status} ${e.statusText}`);
  return new Uint8Array(await e.arrayBuffer());
}
async function dr(t, e) {
  const n = Xt(t), o = await Qt(n, async (r) => {
    if (!e) return null;
    try {
      return await Pe(new URL(r, e).href);
    } catch {
      return null;
    }
  });
  return {
    json: n.json,
    names: Be(n.json),
    buffers: o
  };
}
async function fr(t, e) {
  const n = t.getAsset(e);
  if (n) {
    let a = Oe.get(n);
    a || (a = n.arrayBuffer().then((g) => {
      const h = Xt(new Uint8Array(g));
      return {
        contents: h,
        names: Be(h.json)
      };
    }), Oe.set(n, a), a.catch(() => Oe.delete(n)));
    const { contents: i, names: c } = await a, l = t.getAssetSourceUrl(e) ?? t.resolveAssetUrl(e) ?? (t.isLocal(e) ? void 0 : e), u = t.getAssetBaseUrl(e) ?? l, d = await Qt(i, async (g) => {
      const h = /^(?:[a-z][a-z0-9+.-]*:|\/)/i.test(g) ? t.getAsset(g) : t.resolveExternalAssetBlob(e.slice(0, e.lastIndexOf("/") + 1) + g) ?? t.resolveExternalAssetBlob(g);
      if (h) return new Uint8Array(await h.arrayBuffer());
      try {
        return await Pe(new URL(g, u).href);
      } catch {
        return null;
      }
    });
    return {
      json: i.json,
      names: c,
      buffers: d
    };
  }
  const o = t.resolveAssetUrl(e) ?? (t.isLocal(e) ? void 0 : e);
  if (!o) return Promise.reject(/* @__PURE__ */ new Error(`"${e}" is neither held locally nor resolvable to a URL`));
  let r = bt.get(t);
  r || (r = /* @__PURE__ */ new Map(), bt.set(t, r));
  let s = r.get(o);
  if (!s) {
    const a = r;
    s = Pe(o).then((i) => dr(i, o)), a.set(o, s), s.catch(() => a.delete(o));
  }
  return s;
}
var pr = /^\/nodes\/(\d+)$/;
function an(t) {
  const e = new Set(t.getChildren().map((a) => a.transform)), n = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), s = [t.transform];
  for (; s.length > 0; ) {
    const a = s.pop();
    if (a !== t.transform && e.has(a)) continue;
    const i = mo(a);
    i && n.add(i);
    const c = go(a);
    if (c !== void 0 && a instanceof W) {
      const l = r.get(c) ?? [];
      l.push(a), r.set(c, l);
    }
    if (a instanceof se) for (const l of Y(a)) {
      const u = pr.exec(l);
      u && !o.has(Number(u[1])) && o.set(Number(u[1]), a);
    }
    s.push(...a.getChildren());
  }
  return n.size === 0 ? null : n.size > 1 ? { error: `its instance holds nodes from ${n.size} files` } : {
    names: [...n][0],
    nodes: o,
    primitives: r
  };
}
function Xe(t) {
  const e = (r) => Y(r).some((s) => s.startsWith("/meshes/")), n = (r) => Y(r).some((s) => s.startsWith("/nodes/")), o = [];
  t instanceof W && e(t) && o.push(t);
  for (const r of t.getChildren()) r instanceof W && e(r) && !n(r) && o.push(r);
  return o;
}
function hr(t, e) {
  return {
    set visible(n) {
      const o = n >= 0.5;
      for (const r of e) r.inheritVisibility = !0;
      t.isVisible = o;
      for (const r of e) r.isVisible = o;
    },
    get visible() {
      return t.isVisible ? 1 : 0;
    }
  };
}
function Ae(t, e) {
  return e === "rotation" ? (t.rotationQuaternion || (t.rotationQuaternion = R.FromEulerVector(t.rotation)), {
    target: t,
    property: "rotationQuaternion",
    type: H.ANIMATIONTYPE_QUATERNION,
    width: 4
  }) : {
    target: t,
    property: e === "translation" ? "position" : "scaling",
    type: H.ANIMATIONTYPE_VECTOR3,
    width: 3
  };
}
function mr(t, e) {
  const n = [];
  for (const o of t) {
    const r = o.morphTargetManager;
    if (!r || e < 0 || e >= r.numTargets) continue;
    const s = r.getTarget(e);
    n.push({
      target: s,
      property: "influence",
      type: H.ANIMATIONTYPE_FLOAT,
      width: 1
    });
  }
  return n;
}
function gr(t) {
  const e = /* @__PURE__ */ new Map(), n = t.names;
  for (const [o, r] of t.nodes) {
    const s = n.nodeMesh[o];
    if (s === void 0) continue;
    const a = t.primitives.get(o) ?? Xe(r);
    n.morphTargetNames[s]?.forEach((i, c) => {
      if (i === null) return;
      const l = e.get(i) ?? [];
      l.push(...mr(a, c)), e.set(i, l);
    });
  }
  return e;
}
function _r(t, e, n, o) {
  const r = t.input.length, s = n ? n.count : e, a = t.interpolation === "CUBICSPLINE", i = t.output, c = (d, g) => {
    if (n) return i[d + n.index] * g;
    if (e === 1) return i[d] * g;
    if (e === 3) return B.FromArray(i, d).scaleInPlace(g);
    const h = R.FromArray(i, d).scaleInPlace(g);
    return o ? o.multiply(h) : h;
  }, l = 1 / 60, u = [];
  for (let d = 0; d < r; d++) {
    const g = t.input[d] * 60;
    if (a) {
      const h = d * s * 3;
      u.push({
        frame: g,
        inTangent: c(h, l),
        value: c(h + s, 1),
        outTangent: c(h + 2 * s, l)
      });
    } else {
      const h = {
        frame: g,
        value: c(d * s, 1)
      };
      t.interpolation === "STEP" && (h.interpolation = Fn.STEP), u.push(h);
    }
  }
  return u;
}
function Ot(t, e, n) {
  const o = new H(t, e.property, 60, e.type);
  return o.setKeys(n, !0), o;
}
var At = /* @__PURE__ */ new WeakMap(), Se = /* @__PURE__ */ new WeakMap();
function ee(t, e) {
  t.includes(e) || t.push(e);
}
var St = "RestRelativeBinding";
function vr(t) {
  const e = t.getBehavior(St)?.getData() ?? t._getBehaviorData()?.find((n) => n["@type"] === St);
  return new Set(Array.isArray(e?.nodes) ? e.nodes.filter((n) => typeof n == "string") : []);
}
async function yr(t) {
  const e = (Se.get(t) ?? 0) + 1;
  Se.set(t, e);
  const n = t.animationBinding?.sources ?? [];
  if (n.length === 0) {
    t.boundAnimationClips.size > 0 && t._setBoundAnimationClips(/* @__PURE__ */ new Map()), At.delete(t);
    return;
  }
  const o = await Promise.all(n.map((l) => fr(t.resources, l.src).then((u) => ({
    ok: !0,
    value: u
  }), (u) => ({
    ok: !1,
    error: u instanceof Error ? u.message : String(u)
  }))));
  if (Se.get(t) !== e || t.transform.isDisposed()) return;
  const r = an(t), s = r && !("error" in r) ? r : null, a = {
    instance: s,
    morphs: s ? gr(s) : /* @__PURE__ */ new Map(),
    restRelative: vr(t)
  }, i = /* @__PURE__ */ new Map(), c = [];
  n.forEach((l, u) => {
    const d = {
      src: l.src,
      clips: [],
      bound: 0,
      missing: [],
      unaddressable: [],
      unsupported: [],
      problems: []
    };
    c.push(d);
    const g = o[u];
    if (!g.ok) {
      d.problems.push(`could not read the source: ${g.error}`);
      return;
    }
    r && "error" in r && d.problems.push(r.error), !s && l.root === void 0 && d.problems.push("the target has no loaded glTF instance to bind to");
    const h = En(g.value.json, g.value.names, l.root);
    h.rootMissing && d.problems.push(`the source has no node named "${l.root}"`);
    for (const p of h.animations) {
      const f = br(t, g.value, p, d, a);
      if (f) {
        if (p.name === null) {
          d.problems.push(`animation ${p.index} has no unique name and cannot be selected`), f.dispose();
          continue;
        }
        if (i.has(p.name)) {
          d.problems.push(`animation "${p.name}" is already bound by an earlier source`), f.dispose();
          continue;
        }
        t.ownAnimationClips.has(p.name) && d.problems.push(`animation "${p.name}" is also one of the target's own clips, which comes first`), i.set(p.name, f), d.clips.push(p.name);
      }
    }
  }), t._setBoundAnimationClips(i), At.set(t, c);
  for (const l of c) {
    l.missing.length && y.debug(`[TRACE_animation_binding] "${t.name}" ← ${l.src}: no ${l.missing.map((d) => `"${d}"`).join(", ")} here.`);
    const u = [];
    l.unaddressable.length && u.push(`in the source, ${l.unaddressable.join("; ")}`), l.unsupported.length && u.push(`not animatable inside an instance here: ${l.unsupported.join(", ")}`), u.push(...l.problems), u.length !== 0 && y.warn(`[TRACE_animation_binding] ${ur}: "${t.name}" ← ${l.src}: ${l.bound} channel(s) bound; ${u.join("; ")}.`);
  }
}
var wt = {
  translation: [
    0,
    0,
    0
  ],
  rotation: [
    0,
    0,
    0,
    1
  ],
  scale: [
    1,
    1,
    1
  ]
};
function br(t, e, n, o, r) {
  const s = /* @__PURE__ */ new Map(), a = (p) => {
    let f = s.get(p);
    if (!f) {
      try {
        f = po(e.json, e.buffers, n.index, p);
      } catch (m) {
        return o.problems.push(`animation ${n.index} sampler ${p}: ${m instanceof Error ? m.message : String(m)}`), null;
      }
      s.set(p, f);
    }
    return f;
  };
  for (const p of n.dropped) p.reason === "unnamed" ? ee(o.unaddressable, p.detail) : p.reason === "unsupported" ? ee(o.unsupported, p.detail) : o.problems.push(`channel ${p.channel}: ${p.detail}`);
  const i = n.name ?? `animation${n.index}`, c = [];
  let l = null;
  const u = () => l ??= t.getOrCreateAnimationRoot(), d = (p, f, m) => {
    const _ = a(p.sampler);
    if (!_) return;
    const v = p.kind === "morph" ? p.component : void 0;
    c.push({
      animation: Ot(`${i}_channel${p.channel}_${c.length}`, f, _r(_, f.width, v, m)),
      target: f.target
    });
  }, g = /* @__PURE__ */ new Set();
  for (const p of n.channels) {
    if (p.kind === "root") {
      d(p, Ae(u(), p.path)), g.add(p.path), o.bound++;
      continue;
    }
    const f = r.instance;
    if (!f) continue;
    if (p.kind === "morph") {
      const O = r.morphs.get(p.target);
      if (!O?.length) {
        ee(o.missing, `weights/${p.target}`);
        continue;
      }
      for (const A of O) d(p, A);
      o.bound++;
      continue;
    }
    const m = f.names, _ = m.nodeByName.get(p.node), v = _ !== void 0 ? f.nodes.get(_) : void 0;
    if (_ === void 0 || !v) {
      ee(o.missing, p.node);
      continue;
    }
    if (p.path === "visible") d(p, {
      target: hr(v, f.primitives.get(_) ?? Xe(v)),
      property: "visible",
      type: H.ANIMATIONTYPE_FLOAT,
      width: 1
    });
    else {
      const O = p.path === "rotation" && r.restRelative.has(p.node) ? R.FromArray(m.nodeRest[_].rotation) : void 0;
      d(p, Ae(v, p.path), O);
    }
    o.bound++;
  }
  if (g.size > 0) for (const p of [
    "translation",
    "rotation",
    "scale"
  ]) {
    if (g.has(p)) continue;
    const f = Ae(u(), p), m = f.width === 4 ? R.FromArray(wt[p]) : B.FromArray(wt[p]);
    c.push({
      animation: Ot(`${i}_rootRest_${p}`, f, [{
        frame: 0,
        value: m
      }]),
      target: f.target
    });
  }
  if (c.length === 0) return null;
  const h = new Rt(i, t.babylonScene);
  for (const p of c) h.addTargetedAnimation(p.animation, p.target);
  return h.normalize(0), h;
}
function Fe(t, e, n) {
  const o = e._children, r = n.indexOf(t);
  if (!(!o || r < 0 || r === n.length - 1) && !(o.length !== n.length || o[o.length - 1] !== t)) {
    for (let s = 0; s < o.length - 1; s++) if (o[s] !== n[s < r ? s : s + 1]) return;
    o.pop(), o.splice(r, 0, t);
  }
}
function Or(t) {
  if (!(t instanceof Vn)) return t;
  const e = t.sourceMesh, n = t.parent, o = t.name, r = n?.getChildren() ?? [], s = e.clone(o, n);
  return s.isPickable = t.isPickable, s.enablePointerMoveEvents = t.enablePointerMoveEvents, s.position.copyFrom(t.position), s.scaling.copyFrom(t.scaling), t.rotationQuaternion ? s.rotationQuaternion = t.rotationQuaternion.clone() : s.rotation.copyFrom(t.rotation), t.dispose(), n && Fe(s, n, r.map((a) => a === t ? s : a)), s;
}
var Ar = 2e3, Sr = 16, wr = 1e4;
async function Tr(t, e) {
  const n = () => {
    try {
      if (!t._storeEffectOnSubMeshes) return t.isReady(e);
      const r = new Nn(0, 0, 0, 0, 0, e, void 0, !1, !1);
      return t.isReadyForSubMesh(e, r);
    } catch {
      return !0;
    }
  }, o = Date.now() + Ar;
  for (; !n() && Date.now() < o; ) await new Promise((r) => setTimeout(r, Sr));
}
var Er = class M extends K {
  static behaviorType = "Renderer";
  _lastPickThrough = !1;
  _meshesObserver = null;
  _originalMaterials = {};
  _materialContainerPaths = [];
  static MATERIAL_CONTAINER_OPTS = { allMaterials: !0 };
  _clonedMaterials = /* @__PURE__ */ new Map();
  _loadedSrcBySlot = /* @__PURE__ */ new Map();
  _materialWork = /* @__PURE__ */ new Set();
  _originalTransparencyModes = /* @__PURE__ */ new Map();
  _originalAlphas = /* @__PURE__ */ new Map();
  _authoredUvScale = /* @__PURE__ */ new WeakMap();
  _colorAlpha = /* @__PURE__ */ new Map();
  _opacitySlots = /* @__PURE__ */ new Set();
  _originalAlbedo = /* @__PURE__ */ new Map();
  _originalPbrFactors = /* @__PURE__ */ new Map();
  _factorTextures = /* @__PURE__ */ new Map();
  _derivedFactorTextures = /* @__PURE__ */ new Map();
  _factorCopySources = /* @__PURE__ */ new Map();
  _factorLoadWaits = /* @__PURE__ */ new Map();
  _authoredAlbedo = /* @__PURE__ */ new Map();
  _meshSlots = /* @__PURE__ */ new Map();
  _prefetchedContainers = /* @__PURE__ */ new Map();
  static TINT_HEX_RE = wn;
  static TEXTURE_PROPERTIES = [
    "albedoTexture",
    "bumpTexture",
    "metallicTexture",
    "roughnessTexture",
    "ambientTexture",
    "emissiveTexture",
    "opacityTexture",
    "reflectionTexture",
    "microSurfaceTexture"
  ];
  constructor(e, n) {
    super(e, n);
    const o = this.validate(n);
    o.length > 0 && y.warn(`[Renderer] Invalid initial data for ${e.name}:`, o);
  }
  async load() {
    y.debug(`[Renderer] Loading renderer component for ${this.sceneObject.name}`);
    const e = this._resolved.materials || [];
    y.debug(`[Renderer] Number of materials: ${e.length}`);
    for (const n of this._materialContainerPaths) this._releaseMaterialContainer(n);
    this._materialContainerPaths = [], this._prefetchedContainers.clear(), await this.prefetchMaterialContainers();
  }
  onAttach() {
    y.debug(`[Renderer] onAttach for ${this.sceneObject.name}`), this.sceneObject.onOwnedMeshesChangedObservable.remove(this._meshesObserver), this._meshesObserver = this.sceneObject.onOwnedMeshesChangedObservable.add(() => this.refreshMeshes()), this._releaseFactorTextures();
    for (const e of [...this._clonedMaterials.keys()]) this.restoreOriginalMaterial(e);
    this._clonedMaterials.clear(), this._loadedSrcBySlot.clear(), this._originalAlbedo.clear(), this._originalPbrFactors.clear(), this._authoredAlbedo.clear(), this.captureOriginalMaterials(), this.assignPrefetchedMaterials(), this.applyAllMaterialProperties(), this._syncModelPins(), this._applyCastShadows(), this._applyOpacity(), this._applyTint(), this._lastPickThrough = this._resolved.pickThrough === !0, this._lastPickThrough && this.sceneObject.traceScene.refreshMeshPickability?.(this.sceneObject), this._trackMaterialWork(this._loadResolvedUnfetchedSources());
  }
  _trackMaterialWork(e) {
    this._materialWork.add(e);
    const n = () => {
      this._materialWork.delete(e);
    };
    return e.then(n, n), e;
  }
  async _settleMaterialWork(e) {
    for (; this._materialWork.size > 0; ) {
      const n = e - Date.now();
      if (n <= 0) {
        y.warn(`[Renderer] ${this.sceneObject.name}: material loads still running at the export's deadline; baking the materials on the meshes now`);
        return;
      }
      let o;
      await Promise.race([Promise.allSettled([...this._materialWork]), new Promise((r) => {
        o = setTimeout(r, n);
      })]), clearTimeout(o);
    }
  }
  async _loadResolvedUnfetchedSources() {
    const e = this._materialsBySlotLastWins(this._resolved.materials || []), n = await Promise.all(e.map(async (o, r) => {
      const s = o.targetMaterialIndex ?? 0;
      if (!j(o.src) || o.src === this._loadedSrcBySlot.get(s)) return !1;
      let a = "failed";
      try {
        a = await this.loadAndAssignMaterial(r, o);
      } catch (i) {
        y.error(`[Renderer] Error loading resolved material at slot ${s}:`, i);
      }
      return a === "detached" || this.attachedNode === null || a === "superseded" ? !1 : (this.applyMaterialProperties(s, this._liveMaterialForSlot(s) ?? o), !0);
    }));
    this.attachedNode !== null && n.includes(!0) && (this._syncModelPins(), this._applyCastShadows(), this._applyOpacity(), this._applyTint());
  }
  _releaseLoadedSrc(e) {
    this._releaseMaterialContainer(e);
    const n = this._materialContainerPaths.indexOf(e);
    n !== -1 && this._materialContainerPaths.splice(n, 1);
  }
  _acquireMaterialContainer(e) {
    return this.resources.getOrLoadContainer(e, this.scene, void 0, M.MATERIAL_CONTAINER_OPTS);
  }
  _releaseMaterialContainer(e) {
    this.resources.releaseContainer(e, M.MATERIAL_CONTAINER_OPTS);
  }
  async prefetchMaterialContainers() {
    y.debug(`[Renderer] Prefetching material containers for ${this.sceneObject.name}`);
    const e = this._resolved.materials || [];
    await Promise.all(e.map(async (n, o) => {
      if (j(n.src))
        try {
          y.debug(`[Renderer] Prefetching material from: ${n.src}`);
          const r = await this._acquireMaterialContainer(n.src);
          this._materialContainerPaths.push(n.src), this._prefetchedContainers.set(o, r);
        } catch (r) {
          y.error(`[Renderer] Error prefetching material at index ${o}:`, r);
        }
    })), await this._prefetchBoundMaterialVariants();
  }
  async _prefetchBoundMaterialVariants() {
    const e = /* @__PURE__ */ new Set();
    for (const o of this.getAuthored().materials || []) for (const r of this._boundMaterialVariants(o)) e.add(r);
    const n = [...e].filter((o) => !this._materialContainerPaths.includes(o));
    await Promise.allSettled(n.map(async (o) => {
      try {
        await this._acquireMaterialContainer(o), this._materialContainerPaths.push(o);
      } catch (r) {
        y.warn(`[Renderer] Error prefetching bound material variant ${o}:`, r);
      }
    }));
  }
  _boundMaterialVariants(e) {
    const n = e.src?.match(G);
    if (!n) return [];
    const o = $(n), r = An(this.sceneObject, o);
    return r ? r.getDeclaredValues(o).filter((s) => typeof s == "string" && s !== "" && !he(s)) : [];
  }
  async prepareBoundMaterialVariants() {
    if (this.attachedNode === null) return;
    await this._prefetchBoundMaterialVariants();
    const e = [];
    for (const n of this.getAuthored().materials || []) {
      const o = this.getSlotMesh(n.targetMaterialIndex ?? 0);
      if (o)
        for (const r of this._boundMaterialVariants(n)) {
          const s = this.resources.peekLoadedContainer(r, M.MATERIAL_CONTAINER_OPTS)?.materials[0];
          s && e.push(Tr(s, o));
        }
    }
    await Promise.all(e);
  }
  assignPrefetchedMaterials() {
    const e = this._resolved.materials || [];
    for (const [n, o] of e.entries()) {
      if (!o.src) continue;
      const r = this._prefetchedContainers.get(n);
      if (!r) continue;
      const s = o.targetMaterialIndex ?? 0;
      y.debug(`[Renderer] Assigning prefetched material at index ${n} to slot ${s}`);
      let a = this.getSlotMesh(s);
      if (!a) {
        y.error(`[Renderer] No mesh found at slot ${s}`);
        continue;
      }
      if (r.materials.length === 0) {
        y.warn(`[Renderer] No materials found in ${o.src}`);
        continue;
      }
      a = this.ensureMaterialAssignable(a);
      const i = r.materials[0], c = ve(i, `${this.sceneObject.name}_mat${s}`);
      if (!c) {
        y.warn(`[Renderer] Failed to clone material from ${o.src}`);
        continue;
      }
      this._clonedMaterials.get(s)?.dispose(), this._clonedMaterials.set(s, c), this._loadedSrcBySlot.set(s, o.src), a.material = c, y.debug(`[Renderer] Assigned cloned material ${c.name} to mesh at index ${s}`);
    }
    this._prefetchedContainers.clear();
  }
  applyAllMaterialProperties() {
    const e = this._materialsBySlotLastWins(this._resolved.materials || []);
    y.debug(`[Renderer] Applying properties to ${e.length} materials`);
    for (const n of e) this.applyMaterialProperties(n.targetMaterialIndex ?? 0, n);
  }
  async loadAndAssignMaterial(e, n) {
    if (!n.src) return "failed";
    const o = n.targetMaterialIndex ?? 0;
    if (y.debug(`[Renderer] Loading replacement material at index ${e} for slot ${o}`), !this.getSlotMesh(o))
      return y.error(`[Renderer] No mesh found at slot ${o}`), "failed";
    y.debug(`[Renderer] Loading material from: ${n.src}`);
    let r;
    try {
      r = await this._acquireMaterialContainer(n.src);
    } catch (s) {
      return y.error(`[Renderer] Error loading material from ${n.src}:`, s), this.attachedNode === null ? "detached" : "failed";
    }
    return this.attachedNode === null ? (this._releaseMaterialContainer(n.src), "detached") : this._assignAcquiredMaterial(o, n.src, r);
  }
  _assignLoadedMaterial(e) {
    if (!e.src) return null;
    const n = this.resources.peekLoadedContainer(e.src, M.MATERIAL_CONTAINER_OPTS);
    if (!n) return null;
    const o = e.targetMaterialIndex ?? 0;
    return this.getSlotMesh(o) ? (this._acquireMaterialContainer(e.src), this._assignAcquiredMaterial(o, e.src, n)) : (y.error(`[Renderer] No mesh found at slot ${o}`), "failed");
  }
  _assignAcquiredMaterial(e, n, o) {
    if (this._liveMaterialForSlot(e)?.src !== n)
      return this._releaseMaterialContainer(n), "superseded";
    const r = this.getSlotMesh(e);
    if (!r)
      return this._releaseMaterialContainer(n), "superseded";
    if (o.materials.length === 0)
      return y.warn(`[Renderer] No materials found in ${n}`), this._releaseMaterialContainer(n), "failed";
    const s = o.materials[0], a = ve(s, `${this.sceneObject.name}_mat${e}`);
    if (!a)
      return y.warn(`[Renderer] Failed to clone material from ${n}`), this._releaseMaterialContainer(n), "failed";
    const i = this.ensureMaterialAssignable(r);
    this._captureOriginalIfAbsent(e, i);
    const c = this._clonedMaterials.get(e);
    c && (c.dispose(), this._originalAlbedo.delete(c), this._originalPbrFactors.delete(c), this._authoredAlbedo.delete(c));
    const l = this._loadedSrcBySlot.get(e);
    return this._materialContainerPaths.push(n), this._clonedMaterials.set(e, a), this._loadedSrcBySlot.set(e, n), l !== void 0 && this._releaseLoadedSrc(l), i.material = a, y.debug(`[Renderer] Assigned cloned material ${a.name} to mesh at index ${e}`), "assigned";
  }
  getMeshes() {
    return this.sceneObject.getOwnedMeshes();
  }
  getSlotMesh(e) {
    if (this.attachedNode === null) return;
    const n = this._meshSlots.get(e);
    if (n && !n.isDisposed()) return n;
    const o = this.getMeshes()[e];
    if (!(!o || o.isDisposed()) && !M._isHelperMesh(o)) {
      for (const [r, s] of this._meshSlots) if (s === o && r !== e) return;
      return this._meshSlots.set(e, o), o;
    }
  }
  static _isHelperMesh(e) {
    const n = e.name;
    return n.startsWith("__") || n.endsWith("__collider") || n.endsWith("__selection");
  }
  _liveMaterialForSlot(e) {
    let n;
    for (const o of this._resolved.materials ?? []) (o.targetMaterialIndex ?? 0) === e && (n = o);
    return n;
  }
  _materialsBySlotLastWins(e) {
    const n = /* @__PURE__ */ new Map();
    for (const o of e) n.set(o.targetMaterialIndex ?? 0, o);
    return [...n.values()];
  }
  _isOwnClone(e) {
    for (const n of this._clonedMaterials.values()) if (n === e) return !0;
    return !1;
  }
  _captureOriginalIfAbsent(e, n) {
    if (this._originalMaterials[e] !== void 0) return;
    const o = n.material;
    !o || this._isOwnClone(o) || (this._originalMaterials[e] = o.name);
  }
  _syncModelPins() {
    const e = this.getMeshes().length;
    for (let n = 0; n < e; n++) this.getSlotMesh(n);
  }
  _applyCastShadows() {
    const e = this._resolved.castShadows !== !1;
    for (const n of this._meshSlots.values())
      n.metadata || (n.metadata = {}), n.metadata.castShadows = e;
  }
  _wholeOpacity() {
    const e = this._resolved.opacity;
    return typeof e == "number" ? Math.max(0, Math.min(1, e)) : 1;
  }
  static _slotOpacityOf(e) {
    const n = e?.opacity;
    return typeof n == "number" && Number.isFinite(n) ? Math.max(0, Math.min(1, n)) : null;
  }
  _driveOpacity(e) {
    const n = this._clonedMaterials.has(e) ? M._slotOpacityOf(this._liveMaterialForSlot(e)) : null;
    return this._wholeOpacity() * (n ?? 1);
  }
  _applyOpacity() {
    for (const [e, n] of this._meshSlots) {
      const o = n.material;
      if (!o) continue;
      if (Z(o)) {
        this._opacitySlots.delete(e);
        continue;
      }
      const r = this._driveOpacity(e), s = r < 1, a = this._colorAlpha.get(e) ?? M._ownColorAlpha(n);
      if (a !== void 0) {
        o.alpha = a * r, o.needDepthPrePass = o.alpha > 0;
        continue;
      }
      if (!s) {
        if (!this._opacitySlots.delete(e)) continue;
        this._restoreAuthoredTransparency(e, o);
        continue;
      }
      this._captureAuthoredTransparency(e, o), o.alpha = r, o.transparencyMode = re.MATERIAL_ALPHABLEND, o.needDepthPrePass = o.alpha > 0, this._opacitySlots.add(e);
    }
  }
  _clearColorAlpha(e, n) {
    this._colorAlpha.delete(n) && (this._driveOpacity(n) < 1 || this._restoreAuthoredTransparency(n, e));
  }
  _captureAuthoredTransparency(e, n) {
    if (gt(n) || (To(n), this._originalTransparencyModes.has(e))) return;
    const o = Mo(n);
    this._originalTransparencyModes.set(e, o.transparencyMode), this._originalAlphas.set(e, o.alpha);
  }
  _restoreAuthoredTransparency(e, n) {
    const o = gt(n);
    if (o) {
      n.alpha = o.alpha, n.transparencyMode = o.transparencyMode, n.needDepthPrePass = o.needDepthPrePass;
      return;
    }
    n.alpha = this._originalAlphas.get(e) ?? 1;
    const r = this._originalTransparencyModes.get(e);
    r !== void 0 && (n.transparencyMode = r), n.needDepthPrePass = !1, Eo(n);
  }
  _applyTint() {
    const e = typeof this._resolved.tint == "string" ? this._resolved.tint.trim() : "";
    let n = null;
    if (e) {
      if (!M.TINT_HEX_RE.test(e)) {
        y.warn(`[Renderer] Ignoring invalid tint "${e}" — expected #RRGGBB or #RRGGBBAA hex`);
        return;
      }
      const r = ot.FromHexString(e);
      n = new me(r.r, r.g, r.b);
    }
    const o = /* @__PURE__ */ new Set();
    for (const r of this._meshSlots.values()) {
      const s = r.material;
      if (!s || o.has(s) || (o.add(s), Z(s))) continue;
      const a = s.albedoColor;
      if (!a) continue;
      let i = this._originalAlbedo.get(s);
      i || (i = a.clone(), this._originalAlbedo.set(s, i)), s.albedoColor = n ? i.multiply(n) : i.clone();
    }
  }
  _restoreTint() {
    for (const [e, n] of this._originalAlbedo) e.albedoColor = n.clone();
    this._originalAlbedo.clear();
  }
  ensureMaterialAssignable(e) {
    const n = Or(e);
    if (n === e) return e;
    for (const [o, r] of this._meshSlots) if (r === e) {
      this._meshSlots.set(o, n);
      break;
    }
    return n;
  }
  captureOriginalMaterials() {
    const e = this.getMeshes();
    this._originalMaterials = {}, this._meshSlots = /* @__PURE__ */ new Map(), e.forEach((n, o) => {
      this._meshSlots.set(o, n), n.material && (this._originalMaterials[o] = n.material.name);
    }), y.debug(`[Renderer] Captured ${Object.keys(this._originalMaterials).length} original materials for ${this.sceneObject.name}`);
  }
  getOriginalMaterials() {
    return this._originalMaterials;
  }
  getMeshSlots() {
    return this._meshSlots;
  }
  refreshMeshes() {
    this.attachedNode !== null && (this._syncModelPins(), this._applyCastShadows(), this._applyOpacity());
  }
  static _ownColorAlpha(e) {
    const n = e.metadata?.colorAlpha;
    return typeof n == "number" && n < 1 ? n : void 0;
  }
  getReplacementAlbedoHex(e) {
    if (!this._loadedSrcBySlot.has(e)) return null;
    const n = this.getSlotMesh(e)?.material;
    if (!n) return null;
    const o = this._authoredAlbedo.get(n) ?? this._originalAlbedo.get(n);
    if (o) return o.toHexString();
    const r = n.albedoColor;
    return r ? r.toHexString() : null;
  }
  getBaseSlotMaterial(e) {
    const n = tt(() => this._resolveAll()).materials?.find((r) => (r.targetMaterialIndex ?? 0) === e)?.src ?? "", o = n === (this._loadedSrcBySlot.get(e) ?? "") ? this.getSlotMesh(e)?.material : n ? this.resources.peekLoadedContainer(n, M.MATERIAL_CONTAINER_OPTS)?.materials[0] : this.scene.getMaterialByName(this._originalMaterials[e] ?? "");
    return o instanceof de ? o : null;
  }
  restoreOriginalMaterial(e) {
    const n = this._clonedMaterials.get(e);
    if (!n) return;
    const o = this.getSlotMesh(e), r = this._originalMaterials[e];
    if (o && r) {
      const a = this.scene.getMaterialByName(r);
      a ? o.material = a : (y.warn(`[Renderer] Original material "${r}" not found in scene for slot ${e}`), o.material = null);
    }
    n.dispose(), this._clonedMaterials.delete(e);
    const s = this._loadedSrcBySlot.get(e);
    s !== void 0 && (this._loadedSrcBySlot.delete(e), this._releaseLoadedSrc(s)), this._originalTransparencyModes.delete(e), this._originalAlphas.delete(e), this._colorAlpha.delete(e), this._opacitySlots.delete(e), this._originalAlbedo.delete(n), this._originalPbrFactors.delete(n), this._authoredAlbedo.delete(n), y.debug(`[Renderer] Restored original material for slot ${e}`);
  }
  applyMaterialProperties(e, n) {
    let o = this.getSlotMesh(e);
    if (!o || !o.material) return;
    const r = et(n.baseColorFactor, "Renderer.baseColorFactor"), s = r !== null, a = !!n.texture_transform?.scale, i = M._factorChannelsOf(n), c = i.roughness, l = i.metallic, u = et(n.emissiveFactor, "Renderer.emissiveFactor"), d = u !== null, g = M._slotOpacityOf(n);
    if (!s && !a && !c && !l && !d && !(g !== null && g < 1) && !j(n.src)) {
      this.restoreOriginalMaterial(e);
      return;
    }
    let h = this._clonedMaterials.get(e);
    if (h && o.material !== h) {
      const v = o.material, O = this._authoredAlbedo.get(h);
      O && !this._authoredAlbedo.has(v) && this._authoredAlbedo.set(v, O.clone());
      const A = this._originalPbrFactors.get(h);
      A && !this._originalPbrFactors.has(v) && this._originalPbrFactors.set(v, { ...A }), this._seedAuthoredUvScale(h, v), h = v;
    }
    if (!h) {
      o = this.ensureMaterialAssignable(o);
      const v = o.material;
      this._captureOriginalIfAbsent(e, o);
      const O = ve(v, `${this.sceneObject.name}_mat${e}`);
      if (!O) {
        y.warn(`[Renderer] Failed to clone material for property override at slot ${e}`);
        return;
      }
      const A = this._originalAlbedo.get(v);
      A && (O.albedoColor = A.clone()), this._clonedMaterials.set(e, O), o.material = O, h = O;
    }
    if (Z(h)) {
      this._colorAlpha.delete(e), this._opacitySlots.delete(e);
      return;
    }
    const p = h;
    if (s && p.albedoColor && !this._authoredAlbedo.has(h)) {
      const v = this._originalAlbedo.get(h) ?? p.albedoColor;
      this._authoredAlbedo.set(h, v.clone());
    }
    let f = !1;
    if (s) try {
      const v = ot.FromHexString(r);
      h.albedoColor = new me(v.r, v.g, v.b).toLinearSpace(), f = !0, v.a < 1 ? (this._captureAuthoredTransparency(e, h), this._colorAlpha.set(e, v.a), this._opacitySlots.delete(e), h.alpha = v.a * this._driveOpacity(e), h.transparencyMode = re.MATERIAL_ALPHABLEND, h.needDepthPrePass = h.alpha > 0) : this._clearColorAlpha(h, e);
    } catch (v) {
      y.error(`[Renderer] Failed to parse color ${n.baseColorFactor}:`, v);
    }
    else {
      const v = this._authoredAlbedo.get(h);
      v && (h.albedoColor = v.clone(), f = !0), this._clearColorAlpha(h, e);
    }
    f && this._originalAlbedo.delete(h);
    const m = h;
    (c || l || d) && !this._originalPbrFactors.has(h) && this._originalPbrFactors.set(h, {
      roughness: m.roughness,
      metallic: m.metallic,
      emissive: m.emissiveColor.clone()
    });
    const _ = this._originalPbrFactors.get(h);
    c ? m.roughness = n.roughnessFactor : _ && (m.roughness = _.roughness), l ? m.metallic = n.metallicFactor : _ && (m.metallic = _.metallic), this._applyFactorTexture(m, i), d ? m.emissiveColor = me.FromHexString(u.slice(0, 7)).toLinearSpace() : _ && (m.emissiveColor = _.emissive.clone()), this.applyUvScale(h, a ? n.texture_transform.scale : null);
  }
  _seedAuthoredUvScale(e, n) {
    for (const o of M.TEXTURE_PROPERTIES) {
      const r = e[o], s = n[o];
      if (!(r instanceof Q) || !(s instanceof Q)) continue;
      const a = this._authoredUvScale.get(r);
      a && !this._authoredUvScale.has(s) && this._authoredUvScale.set(s, a);
    }
  }
  applyUvScale(e, n) {
    const o = e;
    for (const r of M.TEXTURE_PROPERTIES) {
      const s = o[r];
      if (!(s instanceof Q)) continue;
      if (n) {
        this._authoredUvScale.has(s) || this._authoredUvScale.set(s, [s.uScale, s.vScale]), [s.uScale, s.vScale] = n;
        continue;
      }
      const a = this._authoredUvScale.get(s);
      a && ([s.uScale, s.vScale] = a, this._authoredUvScale.delete(s));
    }
  }
  _applyFactorTexture(e, n) {
    const o = `${n.metallic ? "m" : ""}${n.roughness ? "r" : ""}`, r = this._factorTextures.get(e);
    if (r?.mask === o) return;
    r && this._withdrawFactorTexture(e);
    const s = e.metallicTexture;
    if (!(s instanceof Q)) return;
    let a = s;
    const i = this._factorCopySources.get(a.getInternalTexture()?.uniqueId ?? -1);
    if (i) {
      const h = i.clone();
      ke(a, h), e.onDisposeObservable.addOnce(() => h.dispose()), e.metallicTexture = h, a = h;
    }
    const c = a.getInternalTexture();
    if (!o || !c) return;
    if (!a.isReady()) {
      this._applyFactorTexturesWhenLoaded(a);
      return;
    }
    const l = `${c.uniqueId}:${o}`, u = this._derivedFactorTextures.get(l);
    if (u === void 0) {
      this._derivedFactorTextures.set(l, null);
      const h = a.clone(), p = a.name;
      this._trackMaterialWork(wo(a, n).then((f) => this._storeFactorTexture(l, h, f), (f) => {
        h.dispose(), y.warn(`[Renderer] Reading "${p}" back failed; its factor override keeps multiplying: ${String(f)}`);
      }));
      return;
    }
    if (!u) return;
    const d = u.clone();
    d.name = u.name, ke(a, d);
    const g = e.onDisposeObservable.addOnce(() => this._withdrawFactorTexture(e));
    this._factorTextures.set(e, {
      mask: o,
      authored: a,
      worn: d,
      onDispose: g
    }), e.metallicTexture = d;
  }
  _storeFactorTexture(e, n, o) {
    const r = o?.getInternalTexture();
    if (!o || !r || this.attachedNode === null || this._derivedFactorTextures.get(e) !== null) {
      o?.dispose(), n.dispose();
      return;
    }
    this._derivedFactorTextures.set(e, o), this._factorCopySources.set(r.uniqueId, n), this._applyFactorTexturesToWornMaterials();
  }
  _applyFactorTexturesWhenLoaded(e) {
    if (this._factorLoadWaits.has(e)) return;
    const n = e.onLoadObservable.addOnce(() => {
      this._factorLoadWaits.delete(e), this._applyFactorTexturesToWornMaterials();
    });
    this._factorLoadWaits.set(e, n);
  }
  _applyFactorTexturesToWornMaterials() {
    for (const e of this._materialsBySlotLastWins(this._resolved.materials || [])) {
      const n = e.targetMaterialIndex ?? 0;
      if (!this._clonedMaterials.has(n)) continue;
      const o = this.getSlotMesh(n)?.material;
      !(o instanceof de) || Z(o) || this._applyFactorTexture(o, M._factorChannelsOf(e));
    }
  }
  static _factorChannelsOf(e) {
    return {
      metallic: typeof e.metallicFactor == "number",
      roughness: typeof e.roughnessFactor == "number"
    };
  }
  _withdrawFactorTexture(e) {
    const n = this._factorTextures.get(e);
    if (!n) return;
    this._factorTextures.delete(e), e.onDisposeObservable.remove(n.onDispose);
    const o = e;
    o.metallicTexture === n.worn && (o.metallicTexture = n.authored), n.worn.dispose();
  }
  _releaseFactorTextures() {
    for (const [e, n] of this._factorLoadWaits) e.onLoadObservable.remove(n);
    this._factorLoadWaits.clear();
    for (const e of [...this._factorTextures.keys()]) this._withdrawFactorTexture(e);
    for (const e of this._derivedFactorTextures.values()) e?.dispose();
    this._derivedFactorTextures.clear();
    for (const e of this._factorCopySources.values()) e.dispose();
    this._factorCopySources.clear();
  }
  update() {
  }
  onDetach() {
    y.debug(`[Renderer] Detaching renderer for ${this.sceneObject.name}`), this.sceneObject.onOwnedMeshesChangedObservable.remove(this._meshesObserver), this._meshesObserver = null, this._restoreTint();
    for (const e of this._originalTransparencyModes.keys()) {
      const n = this._meshSlots.get(e);
      n?.material && this._restoreAuthoredTransparency(e, n.material);
    }
    this._releaseFactorTextures();
    for (const e of [...this._clonedMaterials.keys()]) this.restoreOriginalMaterial(e);
    this._clonedMaterials.clear(), this._loadedSrcBySlot.clear();
    for (const e of this._meshSlots.values()) {
      const n = M._ownColorAlpha(e);
      n === void 0 || !e.material || (e.material.alpha = n, e.material.transparencyMode = re.MATERIAL_ALPHABLEND, e.material.needDepthPrePass = !1);
    }
    for (const e of this._materialContainerPaths) this._releaseMaterialContainer(e);
    this._materialContainerPaths = [], this._meshSlots.clear(), this._originalTransparencyModes.clear(), this._originalAlphas.clear(), this._colorAlpha.clear(), this._opacitySlots.clear();
  }
  dispose() {
    y.debug(`[Renderer] Disposing renderer for ${this.sceneObject.name}`);
  }
  validate(e) {
    const n = [];
    return e["@type"] !== "Renderer" && n.push({
      field: "@type",
      message: `Expected "@type" to be "Renderer", got "${String(e["@type"])}"`
    }), e.pickThrough !== void 0 && typeof e.pickThrough != "boolean" && !(typeof e.pickThrough == "string" && he(e.pickThrough)) && n.push({
      field: "pickThrough",
      message: "pickThrough must be a boolean or property binding"
    }), e.materials && (Array.isArray(e.materials) ? e.materials.forEach((o, r) => {
      o.src && typeof o.src != "string" && n.push({
        field: `materials[${r}].src`,
        message: "src must be a string"
      }), o.targetMaterialIndex !== void 0 && typeof o.targetMaterialIndex != "number" && n.push({
        field: `materials[${r}].targetMaterialIndex`,
        message: "targetMaterialIndex must be a number"
      }), typeof o.opacity == "number" && !(o.opacity >= 0 && o.opacity <= 1) && n.push({
        field: `materials[${r}].opacity`,
        message: "opacity must be between 0 and 1"
      });
    }) : n.push({
      field: "materials",
      message: "materials must be an array"
    })), e.opacity !== void 0 && typeof e.opacity == "number" && (e.opacity < 0 || e.opacity > 1) && n.push({
      field: "opacity",
      message: "opacity must be between 0 and 1"
    }), typeof e.tint == "string" && e.tint !== "" && !he(e.tint) && !M.TINT_HEX_RE.test(e.tint) && n.push({
      field: "tint",
      message: "tint must be a #RRGGBB or #RRGGBBAA hex color (alpha is ignored)"
    }), n;
  }
  async showBaseMaterialsForBake(e = Date.now() + wr) {
    await this._settleMaterialWork(e);
    const n = tt(() => this._resolveAll());
    if (JSON.stringify(n) === JSON.stringify(this._resolved)) return null;
    const o = async () => {
      this._resolved = this._resolveAll(), await this.applyCommit(this._resolved, this.getAuthored());
    };
    this._resolved = n;
    try {
      await this.applyCommit(n, this.getAuthored());
    } catch (r) {
      throw await o(), r;
    }
    return await this._settleMaterialWork(e), o;
  }
  applyCommit(e, n) {
    return this._trackMaterialWork(this._applyRendererCommit(e, n));
  }
  async _applyRendererCommit(e, n) {
    if (y.debug(`[Renderer] Applying commit for ${this.sceneObject.name}`), this.attachedNode === null) return;
    const o = this._resolved.pickThrough === !0;
    o !== this._lastPickThrough && (this._lastPickThrough = o, this.sceneObject.traceScene.refreshMeshPickability?.(this.sceneObject));
    const r = this._materialsBySlotLastWins(this._resolved.materials || []), s = new Map((n.materials || []).map((i) => [i.targetMaterialIndex ?? 0, i])), a = new Map(r.map((i) => [i.targetMaterialIndex ?? 0, i]));
    for (const i of s.keys()) a.has(i) || this.restoreOriginalMaterial(i);
    for (const i of [...this._loadedSrcBySlot.keys()]) {
      const c = a.get(i);
      c && !j(c.src) && this.restoreOriginalMaterial(i);
    }
    (await Promise.all(r.map(async (i, c) => {
      const l = i.targetMaterialIndex ?? 0, u = this._loadedSrcBySlot.get(l), d = j(i.src);
      let g = null;
      if (d && i.src !== u) {
        g = "failed";
        try {
          g = this._assignLoadedMaterial(i) ?? await this.loadAndAssignMaterial(c, i);
        } catch (h) {
          y.error(`[Renderer] Error hot-reloading material at index ${c}:`, h);
        }
        if (g === "detached" || g === "superseded") return g;
      }
      return this.applyMaterialProperties(l, this._liveMaterialForSlot(l) ?? i), g;
    }))).includes("detached") || this.attachedNode === null || (this._syncModelPins(), this._applyCastShadows(), this._applyOpacity(), this._applyTint());
  }
  serialize() {
    const e = this.getAuthored().materials || [], n = /* @__PURE__ */ new Map();
    for (const a of e) {
      const i = a.targetMaterialIndex ?? 0, c = a.src && a.src.trim() !== "", l = a.baseColorFactor, u = a.texture_transform && a.texture_transform.scale && (a.texture_transform.scale[0] !== 1 || a.texture_transform.scale[1] !== 1), d = a.roughnessFactor !== void 0, g = a.metallicFactor !== void 0, h = a.emissiveFactor, p = a.opacity !== void 0;
      if (c || l || u || d || g || h || p) {
        const f = n.get(i) || { targetMaterialIndex: i };
        c && (f.src = a.src), l && (f.baseColorFactor = a.baseColorFactor), u && (f.texture_transform = { scale: a.texture_transform.scale }), d && (f.roughnessFactor = a.roughnessFactor), g && (f.metallicFactor = a.metallicFactor), h && (f.emissiveFactor = a.emissiveFactor), p && (f.opacity = a.opacity), n.set(i, f);
      }
    }
    const o = Array.from(n.values()).filter((a) => (a.opacity === 1 && delete a.opacity, Object.keys(a).some((i) => i !== "targetMaterialIndex"))), r = { "@type": "Renderer" };
    o.length > 0 && (r.materials = o), this.getAuthored().castShadows !== void 0 && (r.castShadows = this.getAuthored().castShadows);
    const s = this.getAuthored();
    return s.pickThrough !== void 0 && (r.pickThrough = s.pickThrough), s.opacity !== void 0 && s.opacity !== 1 && (r.opacity = s.opacity), s.tint && (r.tint = s.tint), r;
  }
};
function Tt(t) {
  return 440 * Math.pow(2, (t - 69) / 12);
}
var te = class extends K {
  static behaviorType = "Synth";
  _audioManager = null;
  _activeVoices = /* @__PURE__ */ new Set();
  _positionObserver = null;
  _lastPosX = 0;
  _lastPosY = 0;
  _lastPosZ = 0;
  onDetach() {
    this._stopAll(), this._removePositionObserver(), this._audioManager = null;
  }
  onPlayModeChanged(t) {
    t ? this._resolved.playOnStart && this._playDefault() : this._stopAll();
  }
  validate(t) {
    const e = [];
    return t.note !== void 0 && (t.note < 0 || t.note > 127) && e.push({
      field: "note",
      message: "MIDI note must be 0–127"
    }), t.frequency !== void 0 && (t.frequency < 20 || t.frequency > 2e4) && e.push({
      field: "frequency",
      message: "Frequency must be 20–20000 Hz"
    }), t.attack !== void 0 && t.attack < 0 && e.push({
      field: "attack",
      message: "Attack time must be >= 0"
    }), t.decay !== void 0 && t.decay < 0 && e.push({
      field: "decay",
      message: "Decay time must be >= 0"
    }), t.release !== void 0 && t.release < 0 && e.push({
      field: "release",
      message: "Release time must be >= 0"
    }), t.minDistance !== void 0 && t.minDistance < 0 && e.push({
      field: "minDistance",
      message: "Min distance must be >= 0"
    }), t.maxDistance !== void 0 && t.maxDistance < 0 && e.push({
      field: "maxDistance",
      message: "Max distance must be >= 0"
    }), e;
  }
  playNote(t, e) {
    const n = Tt(Math.round(Math.max(0, Math.min(127, t))));
    this._playTone(n, e);
  }
  playFrequency(t, e) {
    const n = Math.max(20, Math.min(2e4, t));
    this._playTone(n, e);
  }
  stop() {
    this._releaseAll();
  }
  _getAudioManager() {
    return this._audioManager || (this._audioManager = this.sceneObject.traceScene.getAudioManager()), this._audioManager;
  }
  _playDefault() {
    const t = this._resolved.frequency ?? Tt(this._resolved.note ?? 60);
    this._playTone(t);
  }
  _playTone(t, e) {
    const n = this._getAudioManager();
    if (!n) return;
    const o = n.getContext(), r = o.currentTime, s = e?.waveform ?? this._resolved.waveform ?? "sine", a = e?.volume ?? this._resolved.volume ?? 0.5, i = this._resolved.attack ?? 0.01, c = this._resolved.decay ?? 0.1, l = this._resolved.sustain ?? 0.7, u = this._resolved.release ?? 0.3, d = e?.duration ?? this._resolved.duration ?? 0.5, g = this._resolved.spatial ?? !0, h = o.createOscillator();
    h.type = s, h.frequency.setValueAtTime(t, r);
    const p = o.createGain();
    p.gain.setValueAtTime(0, r), p.gain.linearRampToValueAtTime(a, r + i), p.gain.linearRampToValueAtTime(a * l, r + i + c), h.connect(p);
    let f = null;
    if (g) {
      f = o.createPanner(), f.panningModel = "HRTF", f.distanceModel = "inverse", f.refDistance = this._resolved.minDistance ?? 1, f.maxDistance = this._resolved.maxDistance ?? 50, f.rolloffFactor = this._resolved.rolloff ?? 1;
      const _ = this.sceneObject.transform.getAbsolutePosition();
      f.positionX.setValueAtTime(_.x, r), f.positionY.setValueAtTime(_.y, r), f.positionZ.setValueAtTime(_.z, r), p.connect(f), f.connect(n.getDestination()), this._ensurePositionObserver();
    } else p.connect(n.getDestination());
    h.start(r);
    const m = {
      oscillator: h,
      gain: p,
      panner: f,
      releaseTimeout: null
    };
    if (this._activeVoices.add(m), d > 0) {
      const _ = r + i + c + d;
      m.releaseTimeout = window.setTimeout(() => {
        this._releaseVoice(m);
      }, (i + c + d) * 1e3), p.gain.setValueAtTime(a * l, _), p.gain.linearRampToValueAtTime(0, _ + u), h.stop(_ + u + 0.01), h.onended = () => {
        this._cleanupVoice(m);
      };
    }
  }
  _releaseVoice(t) {
    if (!this._activeVoices.has(t)) return;
    t.releaseTimeout !== null && (clearTimeout(t.releaseTimeout), t.releaseTimeout = null);
    const e = this._getAudioManager();
    if (!e) {
      this._cleanupVoice(t);
      return;
    }
    const n = e.getContext().currentTime, o = this._resolved.release ?? 0.3;
    t.gain.gain.cancelScheduledValues(n), t.gain.gain.setValueAtTime(t.gain.gain.value, n), t.gain.gain.linearRampToValueAtTime(0, n + o), t.oscillator.stop(n + o + 0.01), t.oscillator.onended = () => {
      this._cleanupVoice(t);
    };
  }
  _releaseAll() {
    for (const t of [...this._activeVoices]) this._releaseVoice(t);
  }
  _stopAll() {
    for (const t of [...this._activeVoices]) {
      t.releaseTimeout !== null && clearTimeout(t.releaseTimeout);
      try {
        t.oscillator.stop();
      } catch {
      }
      t.oscillator.disconnect(), t.gain.disconnect(), t.panner?.disconnect();
    }
    this._activeVoices.clear(), this._removePositionObserver();
  }
  _cleanupVoice(t) {
    this._activeVoices.delete(t), t.oscillator.disconnect(), t.gain.disconnect(), t.panner?.disconnect(), this._activeVoices.size === 0 && this._removePositionObserver();
  }
  _ensurePositionObserver() {
    this._positionObserver || !this.scene || (this._positionObserver = this.scene.onBeforeRenderObservable.add(() => {
      const t = this.sceneObject.transform.getAbsolutePosition(), e = t.x - this._lastPosX, n = t.y - this._lastPosY, o = t.z - this._lastPosZ;
      if (!(e * e + n * n + o * o < 1e-6)) {
        this._lastPosX = t.x, this._lastPosY = t.y, this._lastPosZ = t.z;
        for (const r of this._activeVoices) r.panner && (r.panner.positionX.value = t.x, r.panner.positionY.value = t.y, r.panner.positionZ.value = t.z);
      }
    }));
  }
  _removePositionObserver() {
    this._positionObserver && this.scene && (this.scene.onBeforeRenderObservable.remove(this._positionObserver), this._positionObserver = null);
  }
}, we = 180 / Math.PI, Te = Math.PI / 180, cn = class ie {
  constructor(e, n, o) {
    this._sceneObject = e, this._traceScene = n, this._callerType = o;
  }
  get name() {
    return this._sceneObject.name;
  }
  get path() {
    return this._sceneObject.getPath();
  }
  get active() {
    return this._sceneObject.transform.isEnabled();
  }
  set active(e) {
    this._sceneObject.transform.setEnabled(e);
  }
  get position() {
    const e = this._sceneObject.transform.position;
    return {
      x: e.x,
      y: e.y,
      z: e.z
    };
  }
  set position(e) {
    this._sceneObject.transform.position.set(e.x, e.y, e.z);
  }
  get rotation() {
    const e = this._sceneObject.transform, n = e.rotationQuaternion?.toEulerAngles() ?? e.rotation;
    return {
      x: n.x * we,
      y: n.y * we,
      z: n.z * we
    };
  }
  set rotation(e) {
    this._sceneObject.transform.rotation.set(e.x * Te, e.y * Te, e.z * Te), this._sceneObject.transform.rotationQuaternion = null;
  }
  get scale() {
    const e = this._sceneObject.transform.scaling;
    return {
      x: e.x,
      y: e.y,
      z: e.z
    };
  }
  set scale(e) {
    this._sceneObject.transform.scaling.set(e.x, e.y, e.z);
  }
  get worldPosition() {
    const e = this._sceneObject.transform.getAbsolutePosition();
    return {
      x: e.x,
      y: e.y,
      z: e.z
    };
  }
  getParent() {
    const e = this._sceneObject.getParent();
    return e ? new ie(e, this._traceScene) : null;
  }
  getChildren() {
    return this._sceneObject.getChildren().map((e) => new ie(e, this._traceScene));
  }
  findChild(e) {
    const n = this._traceScene.resolveSceneObject(`./${e}`, this._sceneObject);
    return n ? new ie(n, this._traceScene) : null;
  }
  getProp(e) {
    return this._sceneObject.getBehavior(Tn)?.getValue(e);
  }
  getBehavior(e) {
    const n = this._sceneObject.getBehaviors().find((o) => o.name === e);
    return n ? {
      type: n.name,
      data: Object.freeze(structuredClone(n.getData()))
    } : null;
  }
  setBehavior(e, n) {
    this._sceneObject.setBehavior(e, n).catch((o) => {
      y.error("[Script] setBehavior error:", o);
    });
  }
  playAnimation(e, n) {
    const o = this._sceneObject.getBehavior(st);
    o && o.play({
      clip: e,
      speed: n?.speed,
      loop: n?.loop
    });
  }
  stopAnimation() {
    const e = this._sceneObject.getBehavior(st);
    e && e.stop();
  }
  playNote(e, n) {
    const o = this._sceneObject.getBehavior(te);
    o ? o.playNote(e, n) : this._autoAddSynthAndPlay("playNote", e, n);
  }
  playFrequency(e, n) {
    const o = this._sceneObject.getBehavior(te);
    o ? o.playFrequency(e, n) : this._autoAddSynthAndPlay("playFrequency", e, n);
  }
  stopSynth() {
    const e = this._sceneObject.getBehavior(te);
    e && e.stop();
  }
  setColor(e, n) {
    const o = this._sceneObject.getBehavior(Er);
    if (o) {
      const r = o.getData(), s = n ?? 0;
      for (r.materials || (r.materials = []); r.materials.length <= s; ) r.materials.push({});
      r.materials[s].baseColorFactor = e, o.commit(r);
    }
  }
  _autoAddSynthAndPlay(e, n, o) {
    this._sceneObject.addBehavior("Synth", {}).then(() => {
      const r = this._sceneObject.getBehavior(te);
      r && r[e](n, o);
    }).catch((r) => {
      y.error("[Script] Failed to auto-add Synth behavior:", r);
    });
  }
  dispatch(e) {
    for (const n of this._sceneObject.getBehaviors()) Cr(n) && n.name !== this._callerType && n.fireEvent(e).catch((o) => {
      y.error("[Script] dispatch to ScriptBehavior error:", o);
    });
  }
}, Mr = class {
  constructor(t) {
    this._traceScene = t;
  }
  find(t) {
    const e = this._traceScene.resolveSceneObject(t);
    return e ? new cn(e, this._traceScene) : null;
  }
  get isPlaying() {
    return this._traceScene.isPlayMode();
  }
  get cameraPosition() {
    const t = this._traceScene.getCamera();
    return t ? {
      x: t.position.x,
      y: t.position.y,
      z: t.position.z
    } : {
      x: 0,
      y: 0,
      z: 0
    };
  }
  get cameraForward() {
    const t = this._traceScene.getCamera();
    if (!t) return {
      x: 0,
      y: 0,
      z: -1
    };
    const e = t.getForwardRay().direction;
    return {
      x: e.x,
      y: e.y,
      z: e.z
    };
  }
};
function Cr(t) {
  return t !== null && typeof t == "object" && "fireEvent" in t && typeof t.fireEvent == "function";
}
function Ir(t, e, n, o, r) {
  return {
    data: { ...n },
    self: new cn(t, e, r),
    scene: new Mr(e),
    time: Object.freeze(o),
    log: {
      info: (...s) => console.log(`[Script:${r}]`, ...s),
      warn: (...s) => console.warn(`[Script:${r}]`, ...s),
      error: (...s) => console.error(`[Script:${r}]`, ...s)
    }
  };
}
var Rr = class extends K {
  _scriptInstance = null;
  _renderObserver = null;
  _startTime = 0;
  _started = !1;
  constructor(t, e, n) {
    super(t, e), this._factory = n, t.traceScene.scriptRegistry?.executionEnabled === !1 && (this._factory = void 0);
  }
  load() {
    if (this._factory)
      try {
        this._scriptInstance = this._factory();
      } catch (t) {
        y.error(`[ScriptBehavior:${this._resolved["@type"]}] Factory error:`, t);
      }
  }
  onAttach(t) {
    this._startTime = performance.now() / 1e3, this.sceneObject.traceScene.isPlayMode() && this._fireStart(), this._scriptInstance?.onUpdate && this.scene && this._registerUpdateObserver();
  }
  onDetach() {
    this._teardown();
  }
  fireStart() {
    this._fireStart();
  }
  fireStop() {
    this._teardown();
  }
  async fireSelect(t) {
    const e = t ? this._scriptInstance?.onSelect : this._scriptInstance?.onSelectExit;
    if (!e || !this._started) return;
    const n = performance.now() / 1e3 - this._startTime, o = this._buildContext(0, n);
    try {
      await e(o);
    } catch (r) {
      y.error(`[ScriptBehavior:${this._resolved["@type"]}] onSelect error:`, r);
    }
  }
  async fireHover(t) {
    const e = t ? this._scriptInstance?.onHover : this._scriptInstance?.onHoverExit;
    if (!e || !this._started) return;
    const n = performance.now() / 1e3 - this._startTime, o = this._buildContext(0, n);
    try {
      await e(o);
    } catch (r) {
      y.error(`[ScriptBehavior:${this._resolved["@type"]}] onHover error:`, r);
    }
  }
  async fireEvent(t) {
    if (!this._scriptInstance?.onEvent || !this._started) return;
    const e = performance.now() / 1e3 - this._startTime, n = this._buildContext(0, e);
    try {
      await this._scriptInstance.onEvent(n, t);
    } catch (o) {
      y.error(`[ScriptBehavior:${this._resolved["@type"]}] onEvent error:`, o);
    }
  }
  reloadFactory(t) {
    if (this._factory) {
      this._teardown(), this._factory = t;
      try {
        this._scriptInstance = this._factory();
      } catch (e) {
        y.error(`[ScriptBehavior:${this._resolved["@type"]}] Factory error during reload:`, e), this._scriptInstance = null;
        return;
      }
      this._scriptInstance?.onUpdate && this.scene && this._registerUpdateObserver(), this.sceneObject.traceScene.isPlayMode() && this._fireStart();
    }
  }
  _teardown() {
    if (this._started && this._scriptInstance?.onDestroy) {
      const t = performance.now() / 1e3 - this._startTime, e = this._buildContext(0, t);
      try {
        this._scriptInstance.onDestroy(e);
      } catch (n) {
        y.error(`[ScriptBehavior:${this._resolved["@type"]}] onDestroy error:`, n);
      }
    }
    this._renderObserver && this.scene && (this.scene.onBeforeRenderObservable.remove(this._renderObserver), this._renderObserver = null), this._started = !1;
  }
  _fireStart() {
    if (!(this._started || !this._scriptInstance) && (this._started = !0, this._startTime = performance.now() / 1e3, this._scriptInstance.onUpdate && this.scene && !this._renderObserver && this._registerUpdateObserver(), this._scriptInstance.onStart)) {
      const t = this._buildContext(0, 0);
      try {
        const e = this._scriptInstance.onStart(t);
        e instanceof Promise && e.catch((n) => y.error(`[ScriptBehavior:${this._resolved["@type"]}] onStart error:`, n));
      } catch (e) {
        y.error(`[ScriptBehavior:${this._resolved["@type"]}] onStart error:`, e);
      }
    }
  }
  _registerUpdateObserver() {
    !this.scene || !this._scriptInstance?.onUpdate || (this._renderObserver && this.scene.onBeforeRenderObservable.remove(this._renderObserver), this._renderObserver = this.scene.onBeforeRenderObservable.add(() => {
      if (!this.scene || !this._started || !this._scriptInstance?.onUpdate) return;
      const t = this.scene.getEngine().getDeltaTime() / 1e3, e = performance.now() / 1e3 - this._startTime, n = this._buildContext(t, e);
      try {
        this._scriptInstance.onUpdate(n);
      } catch (o) {
        y.error(`[ScriptBehavior:${this._resolved["@type"]}] onUpdate error:`, o), this._renderObserver && this.scene && (this.scene.onBeforeRenderObservable.remove(this._renderObserver), this._renderObserver = null);
      }
    }));
  }
  _buildContext(t, e) {
    return Ir(this.sceneObject, this.sceneObject.traceScene, this._resolved, {
      deltaTime: t,
      elapsed: e
    }, this._resolved["@type"]);
  }
}, xr = [
  "trace",
  "glz",
  "tracex",
  "zip",
  "real",
  "glxf"
], kr = ["gltf", "glb"];
function ta(t) {
  return kr.includes(t);
}
function Pr(t) {
  return xr.includes(t);
}
function Fr(t) {
  return !!t && Pr(ue.getFileExtensionFromSrc(t));
}
var Nr = [
  "trace",
  "zip",
  "tracex",
  "glxf",
  "real"
];
function na(t) {
  return Nr.includes(t);
}
function Vr(t) {
  return t.constructor.cmsManaged === !0;
}
var Ne = null;
function Gr(t) {
  Ne = t;
}
function Lr(t, e) {
  t.translation && (e.position = new B(t.translation[0], t.translation[1], t.translation[2])), t.rotation && (e.rotationQuaternion = new R(t.rotation[0], t.rotation[1], t.rotation[2], t.rotation[3])), t.scale && (e.scaling = new B(t.scale[0], t.scale[1], t.scale[2]));
}
var Br = class ce {
  transform;
  name;
  _sceneObjectData;
  babylonScene;
  behaviors;
  _src;
  extensionsUsed;
  _resetAssetTransform = !1;
  _assetInstantiated = !1;
  _standInFileSrc;
  onOwnedMeshesChangedObservable = new Ee();
  onBehaviorAddedObservable = new Ee();
  _animationRoot = null;
  _animationLayer = null;
  _effectiveActive = !0;
  _enabledStateObserver = null;
  _animationClips = /* @__PURE__ */ new Map();
  _boundAnimationClips = /* @__PURE__ */ new Map();
  _drivenAnimationClips = [];
  _mergedAnimationClips = null;
  _resources;
  _config;
  _eventTarget;
  _traceScene;
  _propertyNames = /* @__PURE__ */ new Set();
  _subscribedProperties = /* @__PURE__ */ new Map();
  _resolvedActive = !0;
  _activeOverride;
  _cueActive;
  _activeTransformChannels = /* @__PURE__ */ new Set();
  _sceneRef = !1;
  _contentRefSrc = null;
  _contentRefName = void 0;
  _contentRef = null;
  _srcName = void 0;
  get src() {
    return this._src;
  }
  get srcName() {
    return this._srcName;
  }
  _setSrcNameInternal(e) {
    this._srcName = e;
  }
  get isSceneReference() {
    return this._sceneRef || Fr(this._src);
  }
  _setSceneRefInternal(e) {
    this._sceneRef = e;
  }
  get contentRef() {
    if (this._contentRefSrc !== this._src || this._contentRefName !== this._srcName) {
      this._contentRefSrc = this._src, this._contentRefName = this._srcName;
      const e = xn(this._src);
      this._contentRef = e ? {
        assetId: e,
        ...this._srcName ? { name: this._srcName } : {}
      } : null;
    }
    return this._contentRef;
  }
  _setSrcInternal(e) {
    this._src = e, this._sceneObjectData.src = e;
  }
  get active() {
    return this._cueActive ?? this._activeOverride ?? this._resolvedActive;
  }
  get authoredActive() {
    return this._resolvedActive;
  }
  get effectiveActive() {
    return this._effectiveActive;
  }
  setActive(e) {
    this._sceneObjectData.active = e, this._resolvedActive = e, this._activeOverride = void 0, this._cueActive = void 0, this._propertyNames = this._scanSceneObjectPropertyNames(), this.transform.setEnabled(e);
  }
  setActiveOverride(e) {
    const n = e !== void 0 && this._cueActive !== void 0;
    e === this._activeOverride && !n || (this._activeOverride = e, n && (this._cueActive = void 0), this.transform.setEnabled(this.active));
  }
  setActiveCue(e) {
    e !== this._cueActive && (this._cueActive = e, this.transform.setEnabled(this.active));
  }
  setPosition(e, n) {
    this._startPositionChannel(e, n);
  }
  setRotation(e, n) {
    this._startRotationChannel(e, n);
  }
  setScale(e, n) {
    this._startScaleChannel(e, n);
  }
  setTransform(e, n) {
    e.position && this._startPositionChannel(e.position, n), e.rotation && this._startRotationChannel(e.rotation, n), e.scale && this._startScaleChannel(e.scale, n);
  }
  _setName(e) {
    this.name = e, this._sceneObjectData.name = e, this.transform.name = e, this._animationRoot && (this._animationRoot.name = `${e}__animRoot`), this._animationLayer && (this._animationLayer.name = `${e}__animLayer`);
  }
  get resources() {
    return this._resources;
  }
  get config() {
    return this._config;
  }
  get animationClips() {
    if (this._boundAnimationClips.size === 0) return this._animationClips;
    if (!this._mergedAnimationClips) {
      const e = new Map(this._animationClips);
      for (const [n, o] of this._boundAnimationClips) e.has(n) || e.set(n, o);
      this._mergedAnimationClips = e;
    }
    return this._mergedAnimationClips;
  }
  get ownAnimationClips() {
    return this._animationClips;
  }
  get boundAnimationClips() {
    return this._boundAnimationClips;
  }
  _setBoundAnimationClips(e) {
    const n = this._boundAnimationClips;
    if (this._boundAnimationClips = e, this._mergedAnimationClips = null, n.size > 0)
      for (const o of this.behaviors) o.name === "Animation" && o._onBoundClipsReplaced(n);
    for (const o of n.values()) [...e.values()].includes(o) || o.dispose();
  }
  get animationBinding() {
    return this._sceneObjectData.animationBinding;
  }
  setAnimationClips(e, n) {
    const o = /* @__PURE__ */ new Map(), r = [];
    for (const s of e) {
      if (Zt(s)) {
        r.push(s);
        continue;
      }
      const a = n && s.name.startsWith(n) ? s.name.slice(n.length) : s.name;
      ce._trimLeadingDeadFrames(s), o.set(a, s);
    }
    this._animationClips = o, this._drivenAnimationClips = r, this._mergedAnimationClips = null;
  }
  get drivenAnimationClips() {
    return this._drivenAnimationClips;
  }
  static _trimLeadingDeadFrames(e) {
    if (e.from !== 0) return;
    const n = e.targetedAnimations;
    if (n.length === 0) return;
    let o = 1 / 0;
    for (const r of n) {
      const s = r.animation.getKeys();
      if (s.length < 2 || s[0].frame !== 0) return;
      const a = s[1].frame;
      if (a <= 0 || !ce._valuesEqual(s[0].value, s[1].value)) return;
      o = Math.min(o, a);
    }
    o > 0 && o < 1 / 0 && (e.from = o);
  }
  static _valuesEqual(e, n) {
    return e === n ? !0 : typeof e == "number" && typeof n == "number" ? e === n : e != null && n != null && typeof e.equals == "function" ? e.equals(n) : !1;
  }
  get traceScene() {
    return this._traceScene;
  }
  getPath() {
    return this._traceScene.getFullPath(this) ?? this.name;
  }
  constructor(e, n, o, r, s, a, i) {
    this._sceneObjectData = structuredClone(e), this.babylonScene = n, this._resources = o, this._config = r, this._traceScene = s, this._eventTarget = a || null, this.name = e.name, this.behaviors = [], this._src = e.src || "", i ? (this.transform = i, this._installParentInterceptor(), this._installEffectiveActiveTracking()) : this.setupTransformRoot(), this._scanAndResolveProperties(), i && this._propertyNames.size > 0 && (this._resolvedActive || this.transform.setEnabled(!1));
  }
  static fromLoadedTransform(e, n, o, r, s, a, i, c) {
    const l = new ce({
      name: n,
      active: i?.active ?? !0,
      behaviors: i?.behaviors ?? [],
      src: i?.src,
      ...i?.foreign ? { foreign: i.foreign } : {},
      ...i?.uid ? { uid: i.uid } : {},
      ...i?.animationBinding ? { animationBinding: i.animationBinding } : {},
      transform: {
        translation: [
          e.position.x,
          e.position.y,
          e.position.z
        ],
        rotation: e.rotationQuaternion ? [
          e.rotationQuaternion.x,
          e.rotationQuaternion.y,
          e.rotationQuaternion.z,
          e.rotationQuaternion.w
        ] : void 0,
        scale: [
          e.scaling.x,
          e.scaling.y,
          e.scaling.z
        ]
      }
    }, o, r, s, a, c, e);
    return l._src = i?.src || "", l.extensionsUsed = i?.extensionsUsed, l._resetAssetTransform = i?.resetAssetTransform ?? !1, l._sceneRef = i?.sceneRef ?? !1, l._srcName = i?.srcName, l._assetInstantiated = i?.assetInstantiated ?? !1, i?.active === !1 && e.setEnabled(!1), l;
  }
  setupTransformRoot(e) {
    const n = new se(this._sceneObjectData.name, this.babylonScene);
    e && (n.parent = e), this.transform = n, this._installParentInterceptor(), this._installEffectiveActiveTracking(), this._sceneObjectData.transform && Lr(this._sceneObjectData.transform, n), this._resolvedActive || this.transform.setEnabled(!1);
  }
  get uid() {
    return this._sceneObjectData.uid;
  }
  _setUidInternal(e) {
    e === void 0 ? delete this._sceneObjectData.uid : this._sceneObjectData.uid = e;
  }
  getSceneObjectData() {
    return structuredClone(this._sceneObjectData);
  }
  _registerBehaviorWithData(e, n) {
    this._sceneObjectData.behaviors || (this._sceneObjectData.behaviors = []), this._sceneObjectData.behaviors.push(n), this.behaviors.push(e), this._traceScene?._bumpStructureRevision?.(), this.transform.addBehavior(e, !0);
  }
  _getParentPath() {
    return this._sceneObjectData.transform?.parent;
  }
  _getBehaviorData() {
    return this._sceneObjectData.behaviors;
  }
  _behaviorLoadDepth = 0;
  get isLoadingBehaviors() {
    return this._behaviorLoadDepth > 0;
  }
  _beginBehaviorLoad() {
    this._behaviorLoadDepth++;
  }
  _endBehaviorLoad() {
    this._behaviorLoadDepth !== 0 && (this._behaviorLoadDepth--, this._behaviorLoadDepth === 0 && this._traceScene?._emitBehaviorsLoaded?.(this));
  }
  _setBehaviorData(e) {
    this._sceneObjectData.behaviors = e;
  }
  _getTransformData() {
    return this._sceneObjectData.transform;
  }
  async addBehavior(e, n) {
    if (typeof e == "string") {
      const a = It(e);
      if (a) return this.addBehavior(a, n);
      if (this.getBehavior(e)) throw new Error(`[SceneObject] ${this.name} already has a ${e} behavior.`);
      const i = this.traceScene.scriptRegistry?.createBehavior(this, e, n);
      if (i)
        return this._registerBehaviorWithData(i, i.getData()), y.log(`[SceneObject] Added script ${e} to ${this.name}`), i;
      throw new Error(`[SceneObject] Unknown behavior type: ${e}`);
    }
    const o = e.behaviorType;
    if (this.getBehavior(e)) throw new Error(`[SceneObject] ${this.name} already has a ${o} behavior. Use setBehavior() to update it.`);
    const r = le(o, n);
    this._sceneObjectData.behaviors || (this._sceneObjectData.behaviors = []), this._sceneObjectData.behaviors.push(r);
    const s = new e(this, r);
    return await s.load(), this.behaviors.push(s), this._traceScene?._bumpStructureRevision?.(), this.transform.addBehavior(s, !0), this.onBehaviorAddedObservable.notifyObservers(s), this.traceScene.refreshMeshPickability?.(this), y.log(`[SceneObject] Added ${o} behavior to ${this.name}`), s;
  }
  async setBehavior(e, n) {
    if (typeof e == "string") {
      const r = this.getBehavior(e);
      return r ? (await r.commit(n), r) : this.addBehavior(e, n);
    }
    const o = this.getBehavior(e);
    return o ? (await o.commit(n), o) : this.addBehavior(e, n);
  }
  _registerBehavior(e) {
    this.behaviors.push(e), this._traceScene?._bumpStructureRevision?.();
  }
  getBehavior(e) {
    if (typeof e == "string") {
      for (const n of this.behaviors) if (n.name === e) return n;
      return null;
    }
    for (const n of this.behaviors) if (n instanceof e) return n;
    return null;
  }
  getBehaviors() {
    return [...this.behaviors];
  }
  resolveProperty(e, n = !1) {
    let o = this;
    for (; o; ) {
      const r = o.getBehavior("Properties");
      if (r?.hasProperty(e)) return r.getValue(e, n);
      o = o.getParent();
    }
  }
  serializeBehaviors(e = {}) {
    return (e.excludeCmsManaged ? this.behaviors.filter((n) => !Vr(n)) : this.behaviors).map((n) => n.serialize());
  }
  removeBehavior(e) {
    const n = typeof e == "string" ? this.behaviors.findIndex((s) => s.name === e) : this.behaviors.findIndex((s) => s instanceof e);
    if (n === -1) return !1;
    const o = this.behaviors[n], r = o.name;
    if (this.transform.removeBehavior(o), o.detach(), this.behaviors.splice(n, 1), this._traceScene?._bumpStructureRevision?.(), this._sceneObjectData.behaviors) {
      const s = this._sceneObjectData.behaviors.findIndex((a) => a["@type"] === r);
      s !== -1 && this._sceneObjectData.behaviors.splice(s, 1);
    }
    return this.traceScene.refreshMeshPickability?.(this), !0;
  }
  async reload() {
    y.log(`[SceneObject] Reload ${this.name}`), this.captureTransform(), this._flattenAnimationRoot();
    const e = this.transform.getChildren().filter((r) => this._traceScene.findSceneObjectByTransform(r) !== void 0), n = this.transform.parent;
    let o = -1;
    if (n && (o = n.getChildren().indexOf(this.transform)), this.destroy(e), this._assetInstantiated = !1, this.setupTransformRoot(n), n && o >= 0) {
      const r = n.getChildren(), s = r.slice(o, r.length - 1);
      for (const a of s)
        a.parent = null, a.parent = n;
    }
    for (const r of e) r.parent = this.transform;
    if (!Ne) throw new Error("[SceneObject] setApplyComponents() was never called — ensure SceneCreation is imported before reloading objects.");
    await Ne(this, this.name), this._attachBehaviors(), this._eventTarget?.dispatchEvent(new CustomEvent("sceneobject:reloaded", {
      bubbles: !0,
      detail: {
        sceneObject: this,
        name: this.name
      }
    }));
  }
  _attachBehaviors() {
    for (const e of this.behaviors) this.transform.addBehavior(e, !0);
    if (this._traceScene.isPlayMode() && this._animationClips.size > 0 && !this.getBehavior("Animation")) {
      const e = this._animationClips.values().next().value;
      e && e.start(!0);
    }
    this.setupInspectableProperties();
  }
  addChild(e) {
    y.log(`scene object named ${this.name} added child ${e.name}`), e.parent = this._animationRoot || this.transform;
  }
  _changedAt(e) {
    if (!e) return [this];
    const n = this._traceScene?.findSceneObjectByTransform?.(e);
    return n ? [this, n] : void 0;
  }
  get _reparentPending() {
    return this._reparentSettlePending;
  }
  setParent(e) {
    const n = this.transform.parent;
    this.transform.parent = e._animationRoot || e.transform, this._notifyHierarchyChanged(), this._traceScene?._emitTopologyChanged?.(this._changedAt(n)), this.transform.parent !== n && this._traceScene?._emitObjectReparented?.(this, n);
  }
  _installParentInterceptor() {
    const e = this, n = this.transform.setParent.bind(this.transform);
    this.transform.setParent = function(o, r, s) {
      const a = e.transform.parent, i = !e._reparentSettlePending, c = a && o !== a ? {
        parent: a,
        order: a.getChildren()
      } : null, l = n(o, r, s);
      return e.transform.parent === a ? l : !(!i && e.transform.parent === e._reparentSettleFrom) && !e._consultReparentPolicy() ? (n(a, r, s), c && Fe(e.transform, c.parent, c.order), l) : (e._openReparentSettle(a), e._trackChildSlot(c), e._destinationIsOwnedByScene() && (e._resolveNameContention(), e._carryAuthoredPose()), l);
    };
  }
  _carryAuthoredPose() {
    const e = this._authoredParent, n = this.transform.parent;
    if (e === void 0 || e === n) return;
    const o = (r) => r ? r.computeWorldMatrix(!0) : kn.Identity();
    for (const r of this.behaviors) r.onParentFrameChanged(o(e), o(n));
    this._authoredParent = n, this._traceScene?.isPlayMode() || this.captureTransform();
  }
  _isSceneNode(e) {
    return e.getScene?.() !== this.babylonScene ? !1 : !!this._traceScene?.findSceneObjectByTransform(e);
  }
  _destinationIsOwnedByScene() {
    const e = this.transform.parent;
    return e ? this._isSceneNode(e) : !1;
  }
  _reparentSettleFrom = null;
  _reparentSettlePending = !1;
  _authoredParent = void 0;
  _openReparentSettle(e) {
    this._reparentSettlePending || (this._reparentSettlePending = !0, this._reparentSettleFrom = e, this._authoredParent = !e || this._isSceneNode(e) ? e : void 0, queueMicrotask(() => {
      this._reparentSettlePending && this._settleReparent();
    }));
  }
  _settleReparent() {
    this._reparentSettlePending = !1;
    const e = this._reparentSettleFrom;
    this._reparentSettleFrom = null, this._childSlotsLeft = null, !this.transform.parent && !this.transform.isDisposed() && this._carryAuthoredPose(), this._authoredParent = void 0, !this.transform.isDisposed() && this.transform.parent !== e && (this._resolveNameContention(), this._notifyHierarchyChanged(), this._traceScene?._emitTopologyChanged?.(this._changedAt(e)), this._traceScene?._emitObjectReparented?.(this, e));
  }
  _childSlotsLeft = null;
  _trackChildSlot(e) {
    const n = this.transform.parent, o = n ? this._childSlotsLeft?.get(n) : void 0;
    e && (this._childSlotsLeft ??= /* @__PURE__ */ new Map()).set(e.parent, e.order), !(!n || !o) && (this._childSlotsLeft?.delete(n), Fe(this.transform, n, o));
  }
  _consultReparentPolicy() {
    if (!this._traceScene) return !0;
    const e = this.transform.parent, n = e ? this._traceScene.findSceneObjectByTransform(e) ?? null : null;
    return this._traceScene._isReparentAllowed(this, n);
  }
  _resolveNameContention() {
    const e = this.getSiblings(), n = /* @__PURE__ */ new Set();
    for (const s of e) s !== this && n.add(s.name);
    if (!n.has(this.name)) return;
    const o = this.name, r = ue.generateUniqueName(o, n);
    this._setName(r), y.log(`[SceneObject] Renamed "${o}" → "${r}" to avoid sibling conflict`), this._traceScene._notifyObjectRenamed(this, o, r);
  }
  _installEffectiveActiveTracking() {
    this._effectiveActive = this.transform.isEnabled(), this._enabledStateObserver = this.transform.onEnabledStateChangedObservable.add(() => {
      this._refreshEffectiveActive();
    });
  }
  _refreshEffectiveActive() {
    const e = this.transform.isEnabled();
    if (e !== this._effectiveActive) {
      this._effectiveActive = e;
      for (const n of this.behaviors) n._onEffectiveActiveChanged(e);
      for (const n of this.getChildren()) n.transform.isEnabled(!1) && n._refreshEffectiveActive();
    }
  }
  _notifyHierarchyChanged() {
    this._refreshEffectiveActive(), this._resubscribeAndResolve();
    for (const e of this.behaviors) e._resubscribeAndResolve();
    for (const e of this.getDescendants()) {
      e._resubscribeAndResolve();
      for (const n of e.getBehaviors()) n._resubscribeAndResolve();
    }
  }
  getOrCreateAnimationRoot() {
    if (this._animationRoot) return this._animationRoot;
    this._animationRoot = new se(`${this.name}__animRoot`, this.babylonScene), this._animationRoot.parent = this.transform;
    const e = this.transform.getChildren();
    for (const n of e) n !== this._animationRoot && (n.parent = this._animationRoot);
    for (const n of this.behaviors) n.onAnimationRootCreated(this._animationRoot);
    return y.log(`[SceneObject] Created animation root for ${this.name}`), this._animationRoot;
  }
  get animationRoot() {
    return this._animationRoot;
  }
  isAnimationRoot(e) {
    return e === this._animationRoot;
  }
  getOrCreateAnimationLayer() {
    if (this._animationLayer) return this._animationLayer;
    const e = this.getOrCreateAnimationRoot();
    return this._animationLayer = new se(`${this.name}__animLayer`, this.babylonScene), this._animationLayer.parent = this.transform, e.parent = this._animationLayer, y.debug(`[SceneObject] Created animation layer for ${this.name}`), this._animationLayer;
  }
  get animationLayer() {
    return this._animationLayer;
  }
  isAnimationLayer(e) {
    return e === this._animationLayer;
  }
  _flattenAnimationRoot() {
    if (!this._animationRoot) return;
    const e = this._animationRoot.getChildren();
    for (const n of e) n.parent = this.transform;
    this._animationRoot.dispose(), this._animationRoot = null, this._animationLayer && (this._animationLayer.dispose(), this._animationLayer = null);
  }
  getChildTransforms() {
    if (this._animationRoot) {
      const e = this.transform.getChildren().filter((o) => o !== this._animationRoot && o !== this._animationLayer), n = this._animationRoot.getChildren();
      return [...e, ...n];
    }
    return this.transform.getChildren();
  }
  getChildren() {
    if (typeof this._traceScene?.findSceneObjectByTransform != "function") return [];
    const e = this.getChildTransforms(), n = /* @__PURE__ */ new Set(), o = [];
    for (const r of e) {
      const s = this._traceScene.findSceneObjectByTransform(r);
      s && !n.has(s) && (n.add(s), o.push(s));
    }
    return o;
  }
  getOwnedMeshes() {
    const e = this.getChildren();
    return e.length === 0 ? at(this.transform) : at(this.transform, new Set(e.map((n) => n.transform)));
  }
  getDescendants() {
    const e = this.transform.getDescendants(!1), n = /* @__PURE__ */ new Set([this]), o = [];
    for (const r of e) {
      const s = this._traceScene.findSceneObjectByTransform(r);
      s && !n.has(s) && (n.add(s), o.push(s));
    }
    return o;
  }
  referenceAncestor() {
    for (let e = this; e; e = e.getParent()) if (e.isSceneReference && e.getChildren().length > 0) return e;
    return null;
  }
  getParent() {
    const e = this.transform.parent;
    return e ? this._traceScene.findSceneObjectByTransform(e) ?? null : null;
  }
  getSiblings() {
    const e = this.getParent();
    return e ? e.getChildren() : this._traceScene.getSceneObjects().filter((n) => !n.transform.parent);
  }
  get position() {
    return this.transform.position;
  }
  set position(e) {
    this.transform.position = e;
  }
  get rotation() {
    return this.transform.rotation;
  }
  set rotation(e) {
    this.transform.rotation = e;
  }
  get scale() {
    return this.transform.scaling;
  }
  set scale(e) {
    this.transform.scaling = e;
  }
  removeNullValues(e) {
    if (e != null) {
      if (Array.isArray(e)) return e.map((n) => this.removeNullValues(n)).filter((n) => n != null);
      if (typeof e == "object") {
        const n = {};
        for (const o in e) if (Object.hasOwn(e, o)) {
          const r = this.removeNullValues(e[o]);
          r != null && (n[o] = r);
        }
        return n;
      }
      return e;
    }
  }
  _runtimeTransformFieldOwners = /* @__PURE__ */ new Map();
  setRuntimeTransformFieldOwner(e, n) {
    !n.position && !n.scale ? this._runtimeTransformFieldOwners.delete(e) : this._runtimeTransformFieldOwners.set(e, { ...n });
  }
  getRuntimeOwnedTransformFields() {
    let e = !1, n = !1;
    for (const o of this._runtimeTransformFieldOwners.values())
      e ||= o.position, n ||= o.scale;
    return {
      position: e,
      scale: n
    };
  }
  captureTransform() {
    if (this._isPropertyRef(this._sceneObjectData.src) || (this._sceneObjectData.src = this._src), !this.transform) return;
    this._sceneObjectData.transform || (this._sceneObjectData.transform = {});
    const e = this._sceneObjectData.transform, n = this.getBehavior("Properties")?.getAuthoredTransform();
    if (n) {
      e.translation = [
        n.position.x,
        n.position.y,
        n.position.z
      ], e.scale = [
        n.scale.x,
        n.scale.y,
        n.scale.z
      ], e.rotation = [
        n.rotation.x,
        n.rotation.y,
        n.rotation.z,
        n.rotation.w
      ];
      return;
    }
    e.translation = [
      this.transform.position.x,
      this.transform.position.y,
      this.transform.position.z
    ], e.scale = [
      this.transform.scaling.x,
      this.transform.scaling.y,
      this.transform.scaling.z
    ];
    let o;
    this.transform.rotationQuaternion ? o = this.transform.rotationQuaternion : o = R.FromEulerAngles(this.transform.rotation.x, this.transform.rotation.y, this.transform.rotation.z), e.rotation = [
      o.x,
      o.y,
      o.z,
      o.w
    ];
  }
  _isPropertyRef(e) {
    return typeof e == "string" && G.test(e);
  }
  refreshSceneData(e = !1) {
    if (e || this.captureTransform(), this.isLoadingBehaviors && this.behaviors.length === 0) return;
    const n = this.serializeBehaviors();
    this._sceneObjectData.behaviors = n.map((o) => this.removeNullValues(o)).filter((o) => o && typeof o == "object" && "@type" in o), y.log(`components now is ${JSON.stringify(this._sceneObjectData.behaviors)}`);
  }
  async setData(e) {
    return this._unsubscribeFromProperties(), this._sceneObjectData = structuredClone(e), this._scanAndResolveProperties(), await this.reload(), this._subscribeToProperties(), this.refreshSceneData(), this._sceneObjectData.behaviors || [];
  }
  async setSrc(e) {
    this._sceneObjectData.src !== e && (this._sceneObjectData.src = e, await this.setData(this._sceneObjectData));
  }
  destroy(e = []) {
    this.cancelTransformTransition(), this._enabledStateObserver && (this.transform.onEnabledStateChangedObservable.remove(this._enabledStateObserver), this._enabledStateObserver = null), this._unsubscribeFromProperties(), this._flattenAnimationRoot();
    const n = new Set(e), o = this.transform.getChildren();
    for (const r of o) n.has(r) && (r.parent = null);
    for (const r of o) n.has(r) || r.dispose();
    for (const r of this.behaviors)
      this.transform.removeBehavior(r), r.detach();
    this._animationClips = /* @__PURE__ */ new Map(), this._setBoundAnimationClips(/* @__PURE__ */ new Map()), this.transform.dispose(!1), this.behaviors = [], this._traceScene?._bumpStructureRevision?.();
  }
  _scanAndResolveProperties() {
    this._propertyNames = this._scanSceneObjectPropertyNames(), this._resolveSceneObjectFields();
  }
  _scanSceneObjectPropertyNames() {
    const e = /* @__PURE__ */ new Set();
    if (typeof this._sceneObjectData.active == "string") {
      const n = this._sceneObjectData.active.match(G);
      n && e.add($(n));
    }
    if (typeof this._sceneObjectData.src == "string") {
      const n = this._sceneObjectData.src.match(G);
      n && e.add($(n));
    }
    return e;
  }
  _resolveSceneObjectFields() {
    const e = this._sceneObjectData.active;
    if (typeof e == "string") {
      const n = e.match(G), o = n ? this.resolveProperty($(n)) : void 0;
      this._resolvedActive = typeof o == "boolean" ? o : !0;
    } else this._resolvedActive = e !== !1;
    if (this._sceneObjectData.src) if (this._isPropertyRef(this._sceneObjectData.src)) {
      const n = this._sceneObjectData.src.match(G), o = n ? $(n) : "", r = this.resolveProperty(o);
      this._src = typeof r == "string" ? r : "";
    } else this._src = this._sceneObjectData.src;
    else this._src = "";
  }
  _subscribeToProperties() {
    if (this._unsubscribeFromProperties(), this._propertyNames.size !== 0)
      for (const e of this._propertyNames) {
        let n = this;
        for (; n; ) {
          const o = n.getBehavior("Properties");
          if (o?.hasProperty(e)) {
            o.subscribe(e, this), this._subscribedProperties.set(e, o);
            break;
          }
          n = n.getParent();
        }
      }
  }
  _unsubscribeFromProperties() {
    for (const [e, n] of this._subscribedProperties) n.unsubscribe(e, this);
    this._subscribedProperties.clear();
  }
  _onPropertyChanged(e) {
    const n = this.active, o = this._src;
    this._resolveSceneObjectFields(), this.active !== n && this.transform.setEnabled(this.active), this._src !== o && this.reload().catch((r) => y.warn("[SceneObject] reload failed after property change:", r));
  }
  _resubscribeAndResolve() {
    if (this._propertyNames.size === 0) return;
    this._subscribeToProperties();
    const e = this.active, n = this._src;
    this._resolveSceneObjectFields(), this.active !== e && this.transform.setEnabled(this.active), this._src !== n && this.reload().catch((o) => y.warn("[SceneObject] reload failed after resubscribe:", o));
  }
  _startPositionChannel(e, n, o) {
    if (!n || !X(n) || n.duration <= 0) {
      this._cancelTransformChannel("pos"), this.transform.position.copyFrom(e);
      return;
    }
    const r = this.transform.position.clone(), s = e.clone();
    this._runTransformChannel("pos", n, (a) => {
      a === 1 ? this.transform.position.copyFrom(s) : B.LerpToRef(r, s, a, this.transform.position);
    }, o);
  }
  _startRotationChannel(e, n, o) {
    if (!n || !X(n) || n.duration <= 0) {
      this._cancelTransformChannel("rot"), this.transform.rotationQuaternion ? this.transform.rotationQuaternion.copyFrom(e) : this.transform.rotationQuaternion = e.clone();
      return;
    }
    const r = this.transform.rotationQuaternion?.clone() ?? R.Identity(), s = e.clone();
    this._runTransformChannel("rot", n, (a) => {
      this.transform.rotationQuaternion || (this.transform.rotationQuaternion = R.Identity()), a === 1 ? this.transform.rotationQuaternion.copyFrom(s) : R.SlerpToRef(r, s, a, this.transform.rotationQuaternion);
    }, o);
  }
  _startScaleChannel(e, n, o) {
    if (!n || !X(n) || n.duration <= 0) {
      this._cancelTransformChannel("scale"), this.transform.scaling.copyFrom(e);
      return;
    }
    const r = this.transform.scaling.clone(), s = e.clone();
    this._runTransformChannel("scale", n, (a) => {
      a === 1 ? this.transform.scaling.copyFrom(s) : B.LerpToRef(r, s, a, this.transform.scaling);
    }, o);
  }
  _transformChannelKey(e) {
    return `transform:${e}:${this.transform.uniqueId}`;
  }
  _runTransformChannel(e, n, o, r) {
    X(n) && (this._activeTransformChannels.add(e), Ze(this.babylonScene).start(this._transformChannelKey(e), n, o, () => {
      this._activeTransformChannels.delete(e), r?.();
    }));
  }
  _cancelTransformChannel(e) {
    this._activeTransformChannels.has(e) && (Ze(this.babylonScene).cancel(this._transformChannelKey(e)), this._activeTransformChannels.delete(e));
  }
  cancelTransformTransition() {
    this._cancelTransformChannel("pos"), this._cancelTransformChannel("rot"), this._cancelTransformChannel("scale");
  }
  get isTransformTransitioning() {
    return this._activeTransformChannels.size > 0;
  }
  setupInspectableProperties() {
    Object.defineProperty(this.transform, "source", {
      configurable: !0,
      get: () => this._src,
      set: (e) => {
        this._src = e;
      }
    }), this.transform.inspectableCustomProperties = [{
      label: "SceneObj src",
      propertyName: "source",
      type: rt.String
    }, {
      label: "Refresh SceneObject",
      propertyName: "refreshSrc",
      callback: () => {
        y.log(`Refreshing: ${this._src}`), this.reload();
      },
      type: rt.Button
    }];
  }
}, jr = "driven-animation-driver-unresolved", Et = /* @__PURE__ */ new WeakMap(), Ve = /* @__PURE__ */ new WeakMap();
function Mt(t) {
  Ve.get(t)?.(), Ve.delete(t);
}
function $r(t, e) {
  const n = an(t);
  if (!n) return { problem: "the object has no loaded glTF instance" };
  if ("error" in n) return { problem: n.error };
  const o = n.names.nodeByName.get(e.node), r = o !== void 0 ? n.nodes.get(o) : void 0;
  if (o === void 0 || !r) return { problem: `no node is named "${e.node}"` };
  const s = n.names.nodeMesh[o], a = s !== void 0 ? n.names.morphTargetNames[s]?.indexOf(e.target) ?? -1 : -1, i = (n.primitives.get(o) ?? Xe(r))[0]?.morphTargetManager;
  if (a < 0 || !i || a >= i.numTargets) return { problem: `"${e.node}" has no morph target named "${e.target}"` };
  const c = i.getTarget(a);
  return { read: () => c.influence };
}
function Dr(t, e) {
  t.isStarted ? t.isPlaying && t.pause() : (t.start(!1, 1, 0, t.to), t.pause()), t.goToFrame(Math.max(0, Math.min(e * (t.targetedAnimations[0]?.animation.framePerSecond ?? 60), t.to)));
}
function Ur(t) {
  Mt(t);
  const e = t.drivenAnimationClips;
  if (e.length === 0) {
    Et.delete(t);
    return;
  }
  const n = [], o = [];
  for (const i of e) {
    const c = Zt(i);
    if (!c) continue;
    const l = `${c.node}/${c.target}`, u = $r(t, c);
    if ("problem" in u) {
      n.push({
        clip: i.name,
        driver: l,
        resolved: !1,
        problem: u.problem
      }), y.warn(`[DrivenAnimation] ${jr}: "${t.name}" clip "${i.name}": driver ${l}: ${u.problem} — the clip stays inert.`);
      continue;
    }
    n.push({
      clip: i.name,
      driver: l,
      resolved: !0
    }), o.push({
      group: i,
      stamp: c,
      read: u.read,
      last: NaN
    });
  }
  if (Et.set(t, n), o.length === 0) return;
  const r = () => {
    if (t.transform.isDisposed()) {
      Mt(t);
      return;
    }
    for (const i of o) {
      if (i.group.targetedAnimations.length === 0) continue;
      const c = i.read();
      c !== i.last && (i.last = c, Dr(i.group, Math.max(i.stamp.inputMin, Math.min(c, i.stamp.inputMax))));
    }
  }, s = t.babylonScene, a = s.onAfterAnimationsObservable.add(r);
  Ve.set(t, () => s.onAfterAnimationsObservable.remove(a));
}
var Hr = class extends K {
}, ln = "Image", Qe = "Model", un = "Video", dn = "AudioClip";
function Wr(t, e) {
  let n = t.declMap.get(e);
  return n === void 0 && (n = t.declarations.length, t.declarations.push({ op: e }), t.declMap.set(e, n)), n;
}
function I(t, e, n) {
  const o = Wr(t, e), r = n ? Object.fromEntries(Object.entries(n).map(([a, i]) => [a, {
    type: 2,
    value: i
  }])) : void 0, s = t.nodes.length;
  return t.nodes.push({
    declaration: o,
    ...r ? { configuration: r } : {}
  }), s;
}
function P(t, e, n, o, r = "in") {
  const s = t.nodes[e];
  s.flows || (s.flows = {}), s.flows[n] = {
    node: o,
    socket: r
  };
}
function ne(t, e, n, o) {
  const r = t.nodes[e];
  r.values || (r.values = {}), r.values[n] = {
    type: typeof o == "boolean" ? 0 : typeof o == "number" ? 1 : 2,
    value: [o]
  };
}
function zr(t, e, n, o, r) {
  const s = t.nodes[e];
  s.values || (s.values = {}), s.values[n] = {
    node: o,
    socket: r
  };
}
function fn() {
  return {
    types: [
      { signature: "bool" },
      { signature: "float" },
      { signature: "string" }
    ],
    declarations: [],
    nodes: [],
    variables: [],
    declMap: /* @__PURE__ */ new Map(),
    toggleVarMap: /* @__PURE__ */ new Map()
  };
}
function qr(t, e, n) {
  let o = t.toggleVarMap.get(e);
  return o !== void 0 || (o = t.variables.length, t.variables.push({
    name: `toggle_${e}`,
    type: 0,
    value: [n]
  }), t.toggleVarMap.set(e, o)), o;
}
function pn(t) {
  const e = [
    "bool",
    "float",
    "string"
  ], n = /* @__PURE__ */ new Set();
  for (const c of t.nodes) {
    if (c.configuration) for (const l of Object.values(c.configuration)) n.add(l.type);
    if (c.values)
      for (const l of Object.values(c.values)) "type" in l && n.add(l.type);
  }
  for (const c of t.variables) n.add(c.type);
  const o = [...n].sort((c, l) => c - l), r = o.map((c) => ({ signature: e[c] })), s = /* @__PURE__ */ new Map();
  o.forEach((c, l) => s.set(c, l));
  const a = t.nodes.map((c) => {
    const l = { ...c };
    return l.configuration && (l.configuration = Object.fromEntries(Object.entries(l.configuration).map(([u, d]) => [u, {
      ...d,
      type: s.get(d.type) ?? 0
    }]))), l.values && (l.values = Object.fromEntries(Object.entries(l.values).map(([u, d]) => [u, "type" in d ? {
      ...d,
      type: s.get(d.type) ?? 0
    } : d]))), l;
  }), i = t.variables.map((c) => ({
    ...c,
    type: s.get(c.type) ?? 0
  }));
  return {
    types: r,
    declarations: t.declarations,
    variables: i,
    events: [],
    nodes: a
  };
}
function L(t) {
  return t["@type"] === "Triggers";
}
function F(t) {
  return t["@type"] === "Actions";
}
function Ge(t) {
  return t["@type"] === "Cycler";
}
function hn(t) {
  return t === "Select" || y.warn(`[V1ToV2Migration] Unknown V1 event type "${t}", falling back to onSelect`), b.EVENT_ON_SELECT;
}
function U(t, e, n, o) {
  if (o.has(e.name))
    return y.log(`[V1ToV2Migration] Circular action reference detected: ${e.name}`), -1;
  o.add(e.name);
  let r = -1;
  if (e.gameObjectState) {
    const s = e.target || "";
    r = I(t, b.TRACE_SET_ACTIVE, s ? { target: [s] } : void 0), ne(t, r, "state", e.gameObjectState.targetState ?? !0);
  } else if (e.toggle) {
    const s = e.toggle, a = qr(t, e.name, s.isOn ?? !1), i = I(t, b.VARIABLE_GET, { variable: [a] }), c = I(t, b.FLOW_BRANCH);
    zr(t, c, "condition", i, "value");
    const l = s.onAction ? n.get(s.onAction) : void 0, u = s.offAction ? n.get(s.offAction) : void 0;
    if (l) {
      const d = I(t, b.VARIABLE_SET, { variable: [a] });
      ne(t, d, "value", !0), P(t, c, "false", d);
      const g = U(t, l, n, new Set(o));
      g >= 0 && P(t, d, "out", g);
    }
    if (u) {
      const d = I(t, b.VARIABLE_SET, { variable: [a] });
      ne(t, d, "value", !1), P(t, c, "true", d);
      const g = U(t, u, n, new Set(o));
      g >= 0 && P(t, d, "out", g);
    }
    r = c;
  } else if (e.animation) {
    const s = e.animation, a = {};
    e.target && (a.target = [e.target]), s.playClip && (a.clip = [s.playClip]), r = I(t, b.TRACE_PLAY_ANIMATION, Object.keys(a).length > 0 ? a : void 0), s.wrapMode === oe.Loop && ne(t, r, "loop", !0);
  } else if (e.video) {
    const s = e.video, a = {};
    e.target && (a.target = [e.target]), r = I(t, s.play === !1 ? b.TRACE_PAUSE_MEDIA : b.TRACE_PLAY_MEDIA, Object.keys(a).length > 0 ? a : void 0);
  }
  if (r >= 0 && e.then && e.then !== "") {
    const s = n.get(e.then);
    if (s) {
      const a = U(t, s, n, new Set(o));
      a >= 0 && P(t, r, e.animation ? "done" : "out", a);
    }
  }
  return r;
}
function Yr(t, e) {
  const n = t.find(L), o = t.find(F);
  if (!n && !o) return t;
  if (t.some((l) => l["@type"] === "BehaviorGraph"))
    return y.log(`[V1ToV2Migration] Object "${e}" already has BehaviorGraph, skipping migration`), t;
  y.log(`[V1ToV2Migration] Migrating V1 interactions for object: ${e}`);
  const r = /* @__PURE__ */ new Map();
  if (o) for (const l of o.actions) r.set(l.name, l);
  const s = fn();
  let a = 0;
  if (n) for (const l of n.triggers) {
    const u = r.get(l.action);
    if (!u) {
      y.log(`[V1ToV2Migration] Warning: Trigger references unknown action "${l.action}" on object "${e}"`);
      continue;
    }
    const d = I(s, hn(l.on)), g = U(s, u, r, /* @__PURE__ */ new Set());
    if (g < 0) {
      y.log(`[V1ToV2Migration] Warning: Could not convert action "${l.action}" on object "${e}"`);
      continue;
    }
    P(s, d, "out", g), a++;
  }
  if (a === 0 && s.nodes.length === 0) return t.filter((l) => !L(l) && !F(l));
  const i = {
    "@type": "BehaviorGraph",
    graph: pn(s)
  }, c = t.filter((l) => !L(l) && !F(l));
  return c.push(i), y.log(`[V1ToV2Migration] Migrated ${n?.triggers?.length || 0} triggers and ${r.size} actions to BehaviorGraph for "${e}"`), c;
}
function Ct(t) {
  return t ? t.some((e) => L(e) || F(e)) : !1;
}
function Kr(t) {
  const e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
  for (const [o, r] of t) {
    const s = r.find(F);
    if (s) {
      const a = /* @__PURE__ */ new Map();
      for (const i of s.actions) a.set(i.name, i);
      e.set(o, a);
    }
  }
  for (const [o, r] of t) {
    const s = r.find(L);
    if (!s || r.some((i) => i["@type"] === "BehaviorGraph") || r.some(F)) continue;
    const a = fn();
    for (const i of s.triggers) {
      const c = i.target, l = e.get(c);
      if (!l) {
        y.log(`[V1ToV2Migration] Cross-object: trigger on "${o}" references unknown action object "${c}"`);
        continue;
      }
      const u = l.get(i.action);
      if (!u) {
        y.log(`[V1ToV2Migration] Cross-object: trigger on "${o}" references unknown action "${i.action}" on "${c}"`);
        continue;
      }
      const d = I(a, hn(i.on)), g = U(a, u, l, /* @__PURE__ */ new Set());
      g < 0 || (P(a, d, "out", g), n.add(c));
    }
    if (a.nodes.length > 0) {
      const i = r.filter((c) => !L(c));
      i.push({
        "@type": "BehaviorGraph",
        graph: pn(a)
      }), t.set(o, i), y.log(`[V1ToV2Migration] Cross-object: migrated interactions for "${o}"`);
    }
  }
  for (const o of n) {
    const r = t.get(o);
    r && t.set(o, r.filter((s) => !F(s)));
  }
}
function Xr(t, e) {
  if (!t.find(Ge)) return t;
  if (t.some((r) => r["@type"] === "Pages"))
    return y.log(`[V1ToV2Migration] Object "${e}" already has Pages, skipping Cycler migration`), t;
  y.log(`[V1ToV2Migration] Migrating V1 Cycler to Pages for object: ${e}`);
  const n = { "@type": "Pages" }, o = t.filter((r) => !Ge(r));
  return o.push(n), y.log(`[V1ToV2Migration] Migrated Cycler to Pages for "${e}"`), o;
}
function Qr(t) {
  return t ? t.some(Ge) : !1;
}
var Jr = {
  BoxCollider: ["size", "center"],
  SphereCollider: ["center"]
};
function Zr(t) {
  const e = Jr[t["@type"]];
  if (!e) return;
  const n = t;
  for (const o of e) {
    const r = n[o];
    if (r && typeof r == "object" && !Array.isArray(r)) {
      const s = r;
      typeof s.x == "number" && typeof s.y == "number" && typeof s.z == "number" && (n[o] = typeof s.w == "number" ? [
        s.x,
        s.y,
        s.z,
        s.w
      ] : [
        s.x,
        s.y,
        s.z
      ]);
    }
  }
}
var Le = /* @__PURE__ */ new Set([
  Qe,
  ln,
  un,
  dn
]);
function mn(t) {
  let e = null;
  if (Rn.has(t) || nt.has(t) ? e = Qe : Cn.has(t) ? e = ln : In.has(t) ? e = un : Mn.has(t) && (e = dn), !e) return [];
  const n = [le(e)];
  return nt.has(t) && n.push(le("Renderer", { castShadows: !1 })), n;
}
function es(t, e) {
  if (!e.length) return t;
  const n = t ?? [];
  return n.some((o) => o["@type"] === e[0]["@type"]) ? t : [...n, ...e.filter((o) => !n.some((r) => r["@type"] === o["@type"]))];
}
function ts(t, e) {
  const n = e._getBehaviorData(), o = es(n, mn(t));
  o && o !== n && e._setBehaviorData(o);
}
function oa(t) {
  const e = t._getBehaviorData();
  e?.some((n) => Le.has(n["@type"])) && t._setBehaviorData(e.filter((n) => !Le.has(n["@type"])));
}
var ns = class D {
  static createBehavior(e, n) {
    const o = n["@type"], r = e.name;
    if (o === "Frame") {
      const c = e.getBehavior("Frame");
      if (c) {
        const l = e.getBehaviors().filter((u) => u.name === "Frame");
        return y.log(`[SceneCreation] Frame behavior already exists for ${r} (total Frame behaviors: ${l.length}), updating data instead of creating duplicate`), c.commit(n), c.init(), null;
      }
      y.debug(`[SceneCreation] Creating new Frame behavior for ${r}`);
    }
    const s = It(o);
    if (s) return new s(e, le(o, n));
    const a = e.traceScene.scriptRegistry, i = a?.getFactory(o);
    return i || a?.isScriptType(o) && !a.executionEnabled ? new Rr(e, n, i) : new Hr(e, n);
  }
  static migrateV1CrossObjectBehaviors(e) {
    const n = /* @__PURE__ */ new Map();
    let o = !1;
    for (const r of e)
      !r.behaviors || !Ct(r.behaviors) || (n.set(r.name, r.behaviors), r.behaviors.some((s) => s["@type"] === "Triggers") && !r.behaviors.some((s) => s["@type"] === "Actions") && (o = !0));
    if (o) {
      Kr(n);
      for (const r of e) {
        const s = n.get(r.name);
        s && (r.behaviors = s);
      }
    }
  }
  static migrateV1CrossObjectBehaviorsOnObjects(e) {
    const n = e.map((o) => ({
      name: o.name,
      behaviors: o._getBehaviorData()
    }));
    D.migrateV1CrossObjectBehaviors(n);
    for (let o = 0; o < e.length; o++) {
      const r = n[o].behaviors;
      r && e[o]._setBehaviorData(r);
    }
  }
  static async applyComponents(e, n) {
    e._beginBehaviorLoad();
    try {
      await D._applyBehaviorComponents(e, n);
    } finally {
      e._endBehaviorLoad();
    }
    bn(e, e.traceScene), e.animationBinding?.sources.length && await yr(e), Ur(e);
  }
  static async _applyBehaviorComponents(e, n) {
    const o = e.src;
    if (o && yn(o)) {
      const c = e._getBehaviorData();
      c?.some((u) => u["@type"] === "Model") && (y.debug(`[SceneCreation] ${n}: "${o}" is built in — dropping the Model a bake left behind`), e._setBehaviorData(c.filter((u) => u["@type"] !== Qe)));
      const l = gn(o);
      if (l) {
        const u = vn(l, e.babylonScene, e.name);
        u.parent = e.transform;
      }
    } else o && e._assetInstantiated ? y.debug(`[SceneCreation] ${n}: loader already instantiated "${o}" — no implied asset behavior`) : o && D.ensurePrimitiveBehaviorData(o, e);
    const r = e._getBehaviorData();
    if (r) for (const c of r) Zr(c);
    _n(e);
    let s = r;
    if (s && Ct(s) && (s = Yr(s, n), e._setBehaviorData(s)), s && Qr(s) && (s = Xr(s, n), e._setBehaviorData(s)), !s) return;
    y.debug(`[SceneCreation] applyComponents(${n}): ${s.length} behaviors — ${s.map((c) => c["@type"]).join(", ")}`);
    const a = s.map((c) => ({
      behavior: D.createBehavior(e, c),
      component: c
    })), i = await Promise.allSettled(a.map(({ behavior: c }) => c ? Promise.resolve().then(() => c.load()) : Promise.resolve()));
    for (let c = 0; c < a.length; c++) {
      const { behavior: l, component: u } = a[c];
      if (!l) continue;
      const d = i[c];
      d.status === "fulfilled" ? e._registerBehavior(l) : (y.error(`Failed to load resource for ${n} (@type=${u["@type"]}):`, d.reason), Le.has(u["@type"]) && e._registerBehavior(l));
    }
  }
  static impliedPrimitiveBehaviorData(e) {
    return mn(ue.getFileExtensionFromSrc(e));
  }
  static ensurePrimitiveBehaviorData(e, n) {
    ts(ue.getFileExtensionFromSrc(e), n);
  }
  static initializeSceneObject(e, n, o, r, s, a) {
    return e.name || (e.name = `SceneObject_${crypto.randomUUID()}`), e.active === void 0 && (e.active = !0), e.src = On(e.src, e.behaviors, s, e.name, e.uid), y.debug(`Creating scene object: ${e.name}`), new Br(e, n, o, r, s, a);
  }
};
Gr((t, e) => ns.applyComponents(t, e));
export {
  Qn as $,
  Io as A,
  gt as B,
  pe as C,
  at as Ct,
  Js as D,
  Zs as E,
  Ys as F,
  to as G,
  Hs as H,
  Mo as I,
  Jn as J,
  Us as K,
  qs as L,
  Fo as M,
  No as N,
  Qs as O,
  xo as P,
  Kn as Q,
  ve as R,
  Ke as S,
  b as St,
  rr as T,
  Zt as U,
  Ws as V,
  Z as W,
  $s as X,
  eo as Y,
  Ds as Z,
  Or as _,
  Vs as _t,
  es as a,
  Bs as at,
  ea as b,
  it as bt,
  Br as c,
  ut as ct,
  na as d,
  Wn as dt,
  Kt as et,
  Fr as f,
  z as ft,
  Er as g,
  $e as gt,
  wr as h,
  De as ht,
  mn as i,
  Wt as it,
  Ks as j,
  Xs as k,
  Vr as l,
  Gs as lt,
  te as m,
  Ce as mt,
  oa as n,
  Ht as nt,
  Qe as o,
  js as ot,
  Rr as p,
  Ns as pt,
  fe as q,
  ts as r,
  Yt as rt,
  Hr as s,
  Ls as st,
  ns as t,
  Xn as tt,
  ta as u,
  xe as ut,
  yr as v,
  Nt as vt,
  yt as w,
  st as wt,
  Ye as x,
  Pt as xt,
  ir as y,
  Ft as yt,
  zs as z
};

//# sourceMappingURL=SceneCreation-DVCYLXYF.js.map